import { LitElement as e, css as t, html as n, nothing as r, svg as i } from "lit";
import { customElement as a, property as o, query as s, state as c } from "lit/decorators.js";
import { nothing as l } from "lit/html.js";
import { directive as u } from "lit/directive.js";
import { AsyncDirective as d } from "lit/async-directive.js";
import { unsafeHTML as f } from "lit/directives/unsafe-html.js";
import { consume as p, createContext as ee, provide as m } from "@lit-labs/context";
import { ref as h } from "lit/directives/ref.js";
import { html as g } from "lit-element";
//#region \0rolldown/runtime.js
var _ = Object.create, te = Object.defineProperty, ne = Object.getOwnPropertyDescriptor, v = Object.getOwnPropertyNames, re = Object.getPrototypeOf, ie = Object.prototype.hasOwnProperty, y = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), b = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = v(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !ie.call(e, s) && s !== n && te(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = ne(t, s)) || r.enumerable
	});
	return e;
}, x = (e, t, n) => (n = e == null ? {} : _(re(e)), b(t || !e || !e.__esModule ? te(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/decorateMetadata.js
function S(e, t) {
	if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/decorate.js
function C(e, t, n, r) {
	var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
	if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
	else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
	return i > 3 && a && Object.defineProperty(t, n, a), a;
}
//#endregion
//#region src/helpers/base-element.ts
var w = class extends e {
	constructor() {
		super(), this.customClass = "", this.customStyle = "";
	}
	getAttributesToExclude() {
		return [];
	}
	getAttributesToRemoveFromParent() {
		return ["class"];
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.mutationObserver?.disconnect();
	}
	removeParentAttributes() {
		this.getAttributesToRemoveFromParent().forEach((e) => {
			e === "class" && this.hasAttribute("class") && (this.customClass = this.getAttribute("class") || ""), e === "style" && this.hasAttribute("style") && (this.customStyle = this.getAttribute("style") || ""), this.hasAttribute(e) && this.removeAttribute(e);
		});
	}
	getFilteredAttributes() {
		let e = {};
		return Array.from(this.attributes).forEach((t) => {
			this.getAttributesToExclude().includes(t.name) || (e[t.name] = t.value ?? "");
		}), e;
	}
	isCustomPropertySet(e) {
		let t = getComputedStyle(this).getPropertyValue(e).trim();
		return t !== "inherit" && t.length > 0;
	}
	applyCustomClass(e, t, n = "") {
		let r = "";
		e.some((e) => this.isCustomPropertySet(e)) && (r = n), r && this.shadowRoot?.querySelector(t)?.classList.add(r);
	}
	removeDuplicateContent() {
		let e = document.createTreeWalker(this, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, { acceptNode: (e) => e.nodeType === Node.COMMENT_NODE || e.nodeType === Node.TEXT_NODE && !e.textContent?.trim() ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT }), t = /* @__PURE__ */ new Map(), n = [], r;
		for (; r = e.nextNode();) {
			let e;
			if (r.nodeType === Node.TEXT_NODE) {
				let t = r.textContent?.trim();
				if (!t) continue;
				e = `text:${t}`;
			} else if (r instanceof HTMLElement) {
				let t = Array.from(r.attributes).map((e) => `${e.name}=${e.value}`).sort().join(":");
				e = `element:${r.tagName}:${t}`;
			} else continue;
			if (t.has(e)) {
				let i = t.get(e);
				i && i.parentNode && n.push(i), t.set(e, r);
			} else t.set(e, r);
		}
		n.forEach((e) => {
			e.parentNode && (console.log("Removing duplicate:", e), e.parentNode.removeChild(e));
		});
	}
	moveLightDomChildrenInto(e, t) {
		let n;
		if (t && t.length > 0) {
			n = t.filter((t) => this.contains(t) && t !== e && !t.contains(e));
			for (let t of n) {
				let n = Array.from(e.childNodes).find((e) => e.isEqualNode?.(t));
				n && e.removeChild(n);
			}
		} else n = Array.from(this.childNodes).filter((t) => t !== e && !e.contains(t) && !t.contains(e));
		for (let t of n) e.appendChild(t);
	}
	normalizeEnum(e, t, n) {
		if (!e) return n;
		let r = Object.values(t), i = Object.keys(t);
		return r.includes(e) ? e : i.includes(e) ? t[e] : n;
	}
	observeStyleAndClassSync(e) {
		this.mutationObserver = new MutationObserver((t) => {
			for (let n of t) if (n.type === "attributes") {
				if (n.attributeName === "style") {
					let e = this.getAttribute("style") || "";
					e && (this.customStyle = e, this.removeAttribute("style"));
				}
				if (n.attributeName === "class") {
					let t = this.getAttribute("class") || "";
					t && (e.className = t, this.removeAttribute("class"));
				}
			}
		}), this.mutationObserver.observe(this, {
			attributes: !0,
			attributeFilter: ["style", "class"]
		});
	}
};
C([o({
	type: String,
	reflect: !0
}), S("design:type", Object)], w.prototype, "customClass", void 0), C([o({
	type: String,
	reflect: !0
}), S("design:type", Object)], w.prototype, "customStyle", void 0);
//#endregion
//#region src/helpers/genrate-uuid.helper.ts
function T() {
	let e = (/* @__PURE__ */ new Date()).getTime();
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
		let n = (e + Math.random() * 16) % 16 | 0;
		return (t == "x" ? n : n & 3 | 8).toString(16);
	});
}
//#endregion
//#region src/styles/tw.styles.ts
var E = t` 
@font-face {
  font-family: 'GeistSans';

  src: url('assets/fonts/Geist/GeistVariableVF.woff2') format('woff2');
}

/*
! tailwindcss v3.4.10 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured sans font-family by default.
5. Use the user's configured sans font-feature-settings by default.
6. Use the user's configured sans font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -moz-tab-size: 4;
  /* 3 */
  -o-tab-size: 4;
     tab-size: 4;
  /* 3 */
  font-family: var(--font-sans), ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 4 */
  font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
  -webkit-tap-highlight-color: transparent;
  /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from html so users can set them as a class directly on the html element.
*/

body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured mono font-family by default.
2. Use the user's configured mono font-feature-settings by default.
3. Use the user's configured mono font-variation-settings by default.
4. Correct the odd em font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-feature-settings: normal;
  /* 2 */
  font-variation-settings: normal;
  /* 3 */
  font-size: 1em;
  /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent sub and sup elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  letter-spacing: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional :invalid styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to inherit in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements display: block by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add vertical-align: middle to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

:root {
  --background: 0 0% 100%;
  --foreground: 240 10% 3.9%;
  --card: 0 0% 100%;
  --card-foreground: 240 10% 3.9%;
  --popover: 0 0% 100%;
  --popover-foreground: 240 10% 3.9%;
  --primary: 240 5.9% 10%;
  --primary-foreground: 0 0% 98%;
  --secondary: 240 4.8% 95.9%;
  --secondary-foreground: 240 5.9% 10%;
  --muted: 240 4.8% 95.9%;
  --muted-foreground: 240 4% 46%;
  --accent: 240 5% 96%;
  --accent-foreground: 240 6% 10%;
  --destructive: 0 84.2% 60.2%;
  --destructive-foreground: 0 0% 98%;
  --border: 240 5.9% 90%;
  --input: 240 5.9% 90%;
  --ring: 240 5.9% 10%;
  --radius: 0.5rem;
  --green-100: #d4f8e8;
  --green-200: #bbf7d0;
  --green-800: #166534;
  --red-100: #fddddd;
  --red-200: #fecaca;
  --red-800: #991b1b;
  --yellow-100: #fef4d9;
  --yellow-200: #fef08a;
  --yellow-800: #854d0e;
  --blue-100: #dbeafe;
  --blue-200: #bfdbfe;
  --blue-800: #1e40af;
}

.dark {
  --background: 240 10% 4%;
  --foreground: 0 0% 98%;
  --card: 240 10% 3.9%;
  --card-foreground: 0 0% 98%;
  --popover: 240 10% 3.9%;
  --popover-foreground: 0 0% 98%;
  --primary: 0 0% 98%;
  --primary-foreground: 240 5.9% 10%;
  --secondary: 240 3.7% 15.9%;
  --secondary-foreground: 0 0% 98%;
  --muted: 240 3.7% 15.9%;
  --muted-foreground: 240 5% 65%;
  --accent: 240 4% 16%;
  --accent-foreground: 0 0% 98%;
  --destructive: 0 62.8% 30.6%;
  --destructive-foreground: 0 0% 98%;
  --border: 240 3.7% 15.9%;
  --input: 240 3.7% 15.9%;
  --ring: 240 4.9% 83.9%;
  --green-100: #d4f8e8;
  --green-200: #bbf7d0;
  --green-800: #166534;
  --red-100: #fddddd;
  --red-200: #fecaca;
  --red-800: #991b1b;
  --yellow-100: #fef4d9;
  --yellow-200: #fef08a;
  --yellow-800: #854d0e;
  --blue-100: #dbeafe;
  --blue-200: #bfdbfe;
  --blue-800: #1e40af;
}

* {
  border-color: hsl(var(--border));
  font-family: GeistSans, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

body {
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
  font-synthesis-weight: none;
  text-rendering: optimizeLegibility;
}

/* p {
    margin-top: 6px;
    margin-block-start: 6px;
  } */

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}

@media (min-width: 1400px) {
  .container {
    max-width: 1400px;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.pointer-events-none {
  pointer-events: none;
}

.pointer-events-auto {
  pointer-events: auto;
}

.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

.collapse {
  visibility: collapse;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.inset-0 {
  inset: 0px;
}

.bottom-0 {
  bottom: 0px;
}

.end-3 {
  inset-inline-end: 0.75rem;
}

.left-2 {
  left: 0.5rem;
}

.left-\\[50\\%\\] {
  left: 50%;
}

.right-0 {
  right: 0px;
}

.right-1 {
  right: 0.25rem;
}

.right-4 {
  right: 1rem;
}

.top-0 {
  top: 0px;
}

.top-1 {
  top: 0.25rem;
}

.top-4 {
  top: 1rem;
}

.top-\\[50\\%\\] {
  top: 50%;
}

.top-auto {
  top: auto;
}

.z-10 {
  z-index: 10;
}

.z-50 {
  z-index: 50;
}

.z-\\[100\\] {
  z-index: 100;
}

.col-span-2 {
  grid-column: span 2 / span 2;
}

.col-span-3 {
  grid-column: span 3 / span 3;
}

.m-5 {
  margin: 1.25rem;
}

.m-auto {
  margin: auto;
}

.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.ml-auto {
  margin-left: auto;
}

.mr-10 {
  margin-right: 2.5rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-7 {
  margin-top: 1.75rem;
}

.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.block {
  display: block;
}

.inline {
  display: inline;
}

.flex {
  display: flex;
}



.inline-flex {
  display: inline-flex;
}

.table {
  display: table;
}

.grid {
  display: grid;
}

.contents {
  display: contents;
}

.hidden {
  display: none;
}

.aspect-square {
  aspect-ratio: 1 / 1;
}

.size-24 {
  width: 6rem;
  height: 6rem;
}

.size-3 {
  width: 0.75rem;
  height: 0.75rem;
}

.size-3\\.5 {
  width: 0.875rem;
  height: 0.875rem;
}

.size-4 {
  width: 1rem;
  height: 1rem;
}

.size-max {
  width: -moz-max-content;
  width: max-content;
  height: -moz-max-content;
  height: max-content;
}

.h-0{
  height: 0px
}
.h-1 {
  height: 0.25rem;
}

.h-10 {
  height: 2.5rem;
}

.h-11 {
  height: 2.75rem;
}

.h-2 {
  height: 0.5rem;
}

.h-3 {
  height: 0.75rem;
}

.h-3\\.5 {
  height: 0.875rem;
}

.h-4 {
  height: 1rem;
}

.h-5 {
  height: 1.25rem;
}

.h-7 {
  height: 1.75rem;
}

.h-8 {
  height: 2rem;
}

.h-9 {
  height: 2.25rem;
}

.h-\\[1px\\] {
  height: 1px;
}

.h-\\[400px\\] {
  height: 400px;
}

.h-\\[40px\\] {
  height: 40px;
}

.h-full {
  height: 100%;
}

.h-px {
  height: 1px;
}

.max-h-72 {
  max-height: 18rem;
}

.max-h-\\[300px\\] {
  max-height: 300px;
}

.max-h-screen {
  max-height: 100vh;
}

.min-h-\\[80px\\] {
  min-height: 80px;
}

.w-0{
  width: 0px
}

.w-1 {
  width: 0.25rem;
}

.w-10 {
  width: 2.5rem;
}

.w-2 {
  width: 0.5rem;
}

.w-3 {
  width: 0.75rem;
}

.w-3\\.5 {
  width: 0.875rem;
}

.w-32 {
  width: 8rem;
}

.w-4 {
  width: 1rem;
}

.w-5 {
  width: 1.25rem;
}

.w-64 {
  width: 16rem;
}

.w-72 {
  width: 18rem;
}

.w-8 {
  width: 2rem;
}

.w-80 {
  width: 20rem;
}

.w-9 {
  width: 2.25rem;
}

.w-96 {
  width: 24rem;
}

.w-\\[180px\\] {
  width: 180px;
}

.w-\\[1px\\] {
  width: 1px;
}

.w-\\[350px\\] {
  width: 350px;
}

.w-\\[400px\\] {
  width: 400px;
}

.w-\\[40px\\] {
  width: 40px;
}

.w-auto {
  width: auto;
}

.w-full {
  width: 100%;
}

.w-max {
  width: -moz-max-content;
  width: max-content;
}

.w-min {
  width: -moz-min-content;
  width: min-content;
}

.min-w-60 {
  min-width: 15rem;
}

.min-w-80 {
  min-width: 20rem;
}

.min-w-\\[8rem\\] {
  min-width: 8rem;
}

.max-w-\\[260px\\] {
  max-width: 260px;
}

.max-w-lg {
  max-width: 32rem;
}

.max-w-md {
  max-width: 28rem;
}

.max-w-sm {
  max-width: 24rem;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex-auto {
  flex: 1 1 auto;
}

.flex-shrink {
  flex-shrink: 1;
}

.shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.border-collapse {
  border-collapse: collapse;
}

.border-spacing-2 {
  --tw-border-spacing-x: 0.5rem;
  --tw-border-spacing-y: 0.5rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}

.border-spacing-6 {
  --tw-border-spacing-x: 1.5rem;
  --tw-border-spacing-y: 1.5rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}

.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.cursor-default {
  cursor: default;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-pointer {
  cursor: pointer;
}

.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.resize {
  resize: both;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.flex-row {
  flex-direction: row;
}

.flex-row-reverse{
  flex-direction: row-reverse;
}

.flex-col {
  flex-direction: column;
}

.flex-col-reverse {
  flex-direction: column-reverse;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-nowrap {
  flex-wrap: nowrap;
}

.items-start {
  align-items: flex-start;
}

.items-center {
  align-items: center;
}

.items-stretch {
  align-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-stretch {
  justify-content: stretch;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-1\\.5 {
  gap: 0.375rem;
}

.gap-10 {
  gap: 2.5rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-20 {
  gap: 5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}

.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}

.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-y-auto {
  overflow-y: auto;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.text-wrap {
  text-wrap: wrap;
}

.break-words {
  overflow-wrap: break-word;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-2xl {
  border-radius: calc(var(--radius) + 8px);
}

.rounded-xl {
  border-radius: calc(var(--radius) + 4px);
}

.rounded-lg {
  border-radius: var(--radius);
}

.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}

.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}

.rounded-r-md {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.border {
  border-width: 1px;
}

.border-0 {
  border-width: 0px;
}

.border-2 {
  border-width: 2px;
}

.border-4 {
  border-width: 4px;
}

.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-b-2 {
  border-bottom-width: 2px;
}

.border-l {
  border-left-width: 1px;
}

.border-r {
  border-right-width: 1px;
}

.border-t-2 {
  border-top-width: 2px;
}

.border-blue-200 {
  border-color: var(--blue-200);
}

.border-destructive {
  border-color: hsl(var(--destructive));
}

.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.border-green-200 {
  border-color: var(--green-200);
}

.border-input {
  border-color: hsl(var(--input));
}

.border-muted {
  border-color: hsl(var(--muted));
}

.border-primary {
  border-color: hsl(var(--primary));
}

.border-red-200 {
  border-color: var(--red-200);
}

.border-slate-50 {
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity));
}

.border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}

.border-transparent {
  border-color: transparent;
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.border-yellow-200 {
  border-color: var(--yellow-200);
}

.bg-accent {
  background-color: hsl(var(--accent));
}

.bg-background {
  background-color: hsl(var(--background));
}

.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}

.bg-blue-100 {
  background-color: var(--blue-100);
}

.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

.bg-border {
  background-color: hsl(var(--border));
}

.bg-card {
  background-color: hsl(var(--card));
}

.bg-destructive {
  background-color: hsl(var(--destructive));
}

.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.bg-green-100 {
  background-color: var(--green-100);
}

.bg-muted {
  background-color: hsl(var(--muted));
}

.bg-popover {
  background-color: hsl(var(--popover));
}

.bg-primary {
  background-color: hsl(var(--primary));
}

.bg-red-100 {
  background-color: var(--red-100);
}

.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}

.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}

.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}

.bg-secondary {
  background-color: hsl(var(--secondary));
}

.bg-transparent {
  background-color: transparent;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-yellow-100 {
  background-color: var(--yellow-100);
}

.fill-current {
  fill: currentColor;
}

.fill-primary {
  fill: hsl(var(--primary));
}

.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}

.p-0 {
  padding: 0;
}

.p-1 {
  padding: 0.25rem;
}

.p-3 {
  padding: 0.75rem;
}

.p-4 {
  padding: 1rem;
}

.p-5 {
  padding: 1.25rem;
}

.p-6 {
  padding: 1.5rem;
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}

.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.pb-1 {
  padding-bottom: 0.25rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pe-9 {
  padding-inline-end: 2.25rem;
}

.pr-6 {
  padding-right: 1.5rem;
}

.ps-4 {
  padding-inline-start: 1rem;
}

.pt-0 {
  padding-top: 0;
}

.pt-1 {
  padding-top: 0.25rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.pt-3 {
  padding-top: 0.75rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pt-6 {
  padding-top: 1.5rem;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.align-baseline {
  vertical-align: baseline;
}

.align-top {
  vertical-align: top;
}

.align-middle {
  vertical-align: middle;
}

.align-bottom {
  vertical-align: bottom;
}

.font-geist {
  font-family: GeistSans, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-bold {
  font-weight: 700;
}

.font-medium {
  font-weight: 500;
}

.font-normal {
  font-weight: 400;
}
.font-thin {
  font-weight: 300;
}

.font-semibold {
  font-weight: 600;
}

.uppercase {
  text-transform: uppercase;
}

.capitalize {
  text-transform: capitalize;
}

.leading-none {
  line-height: 1;
}

.tracking-tight {
  letter-spacing: -0.025em;
}

.tracking-widest {
  letter-spacing: 0.1em;
}

.text-accent-foreground {
  color: hsl(var(--accent-foreground));
}

.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}

.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}

.text-blue-800 {
  color: var(--blue-800);
}

.text-card-foreground {
  color: hsl(var(--card-foreground));
}

.text-current {
  color: currentColor;
}

.text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}

.text-foreground {
  color: hsl(var(--foreground));
}

.text-foreground\\/50 {
  color: hsl(var(--foreground) / 0.5);
}

.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

.text-green-800 {
  color: var(--green-800);
}

.text-muted {
  color: hsl(var(--muted));
}

.text-muted-foreground {
  color: hsl(var(--muted-foreground));
}

.text-popover-foreground {
  color: hsl(var(--popover-foreground));
}

.text-primary {
  color: hsl(var(--primary));
}

.text-primary-foreground {
  color: hsl(var(--primary-foreground));
}

.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}

.text-red-800 {
  color: var(--red-800);
}

.text-secondary {
  color: hsl(var(--secondary));
}

.text-secondary-foreground {
  color: hsl(var(--secondary-foreground));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-yellow-800 {
  color: var(--yellow-800);
}

.underline {
  text-decoration-line: underline;
}

.underline-offset-4 {
  text-underline-offset: 4px;
}

.opacity-0 {
  opacity: 0;
}

.opacity-100 {
  opacity: 1;
}

.opacity-40 {
  opacity: 0.4;
}

.opacity-50 {
  opacity: 0.5;
}

.opacity-70 {
  opacity: 0.7;
}

.opacity-90 {
  opacity: 0.9;
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.outline {
  outline-style: solid;
}

.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-ring {
  --tw-ring-color: hsl(var(--ring));
}

.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}

.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-200 {
  transition-duration: 200ms;
}

.duration-500 {
  transition-duration: 500ms;
}

@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}

@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}

.slide-in-from-left-1 {
  --tw-enter-translate-x: -0.25rem;
}

.slide-out-to-left-1 {
  --tw-exit-translate-x: -0.25rem;
}

.duration-200 {
  animation-duration: 200ms;
}

.duration-500 {
  animation-duration: 500ms;
}

@media (max-width: 640px) {
  .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.file\\:border-0::file-selector-button {
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button {
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button {
  color: hsl(var(--foreground));
}

.placeholder\\:text-muted-foreground::-moz-placeholder {
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}

.first\\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child {
  border-left-width: 1px;
}

.last\\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}

.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-muted:hover {
  background-color: hsl(var(--muted));
}

.hover\\:bg-primary\\/90:hover {
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-secondary:hover {
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover {
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:text-accent-foreground:hover {
  color: hsl(var(--accent-foreground));
}

.hover\\:text-foreground:hover {
  color: hsl(var(--foreground));
}

.hover\\:text-muted-foreground:hover {
  color: hsl(var(--muted-foreground));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.focus\\:border:focus {
  border-width: 1px;
}

.focus\\:border-\\[3px\\]:focus {
  border-width: 3px;
}

.focus\\:border-\\[\\#c1c1c1\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(193 193 193 / var(--tw-border-opacity));
}

.focus\\:bg-accent:focus {
  background-color: hsl(var(--accent));
}

.focus\\:bg-gray-100:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.focus\\:text-accent-foreground:focus {
  color: hsl(var(--accent-foreground));
}

.focus\\:opacity-100:focus {
  opacity: 1;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-0:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40 {
  border-color: hsl(var(--muted) / 0.4);
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
  --tw-ring-offset-color: #dc2626;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}

.aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(var(--accent));
}

.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(var(--accent-foreground));
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"] {
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes accordion-up {
  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"] {
  animation: accordion-up 0.2s ease-out;
}

@keyframes accordion-down {
  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"] {
  animation: accordion-down 0.2s ease-out;
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
  background-color: hsl(var(--background));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
  background-color: hsl(var(--primary));
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"] {
  color: hsl(var(--foreground));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}

.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"] {
  transition-property: none;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"] {
  --tw-enter-translate-y: -100%;
}

.dark\\:border-neutral-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity));
}

.dark\\:bg-neutral-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity));
}

.dark\\:text-blue-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}

.dark\\:text-neutral-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity));
}

.dark\\:text-neutral-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}

.dark\\:hover\\:bg-neutral-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}

.dark\\:focus\\:bg-neutral-800:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}

@media (min-width: 640px) {
  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:max-w-\\[425px\\] {
    max-width: 425px;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }

  .sm\\:text-left {
    text-align: left;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"] {
    --tw-enter-translate-y: 100%;
  }
}

@media (min-width: 768px) {
  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }
}

.\\[\\&\\+div\\]\\:text-xs+div {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-gray-300::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.dark\\:\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-neutral-500:is(.dark *)::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-gray-100::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.dark\\:\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-neutral-700:is(.dark *)::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-2::-webkit-scrollbar {
  width: 0.5rem;
}

.\\[\\&\\>svg\\]\\:size-3\\.5>svg {
  width: 0.875rem;
  height: 0.875rem;
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:px-2 [rtgcmd-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:py-1\\.5 [rtgcmd-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:text-xs [rtgcmd-group-heading] {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:font-medium [rtgcmd-group-heading] {
  font-weight: 500;
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:text-muted-foreground [rtgcmd-group-heading] {
  color: hsl(var(--muted-foreground));
}

.\\[\\&_svg\\]\\:pointer-events-none svg {
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4 svg {
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}
 `, D = new CSSStyleSheet();
D.replaceSync(E.cssText || E.toString());
var O = class extends e {
	static {
		this.styles = t`
    :host {
      display: block;
      border: 2px solid black;
      padding: 10px;
    }
    .wrapper {
      display: block;
    }
  `;
	}
	constructor() {
		super();
	}
	connectedCallback() {
		super.connectedCallback(), this.shadowRoot ? this.shadowRoot.adoptedStyleSheets = [...this.shadowRoot.adoptedStyleSheets, D] : console.error("Shadow root not available in ShadowWrapper");
	}
	render() {
		return n`<div><slot></slot></div>`;
	}
};
customElements.define("shadow-wrapper", O);
//#endregion
//#region node_modules/clsx/dist/clsx.mjs
function k(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = k(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function ae() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = k(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region node_modules/tailwind-merge/dist/bundle-mjs.mjs
var oe = "-", A = (e) => {
	let t = ue(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			let n = e.split(oe);
			return n[0] === "" && n.length !== 1 && n.shift(), se(n, t) || le(e);
		},
		getConflictingClassGroupIds: (e, t) => {
			let i = n[e] || [];
			return t && r[e] ? [...i, ...r[e]] : i;
		}
	};
}, se = (e, t) => {
	if (e.length === 0) return t.classGroupId;
	let n = e[0], r = t.nextPart.get(n), i = r ? se(e.slice(1), r) : void 0;
	if (i) return i;
	if (t.validators.length === 0) return;
	let a = e.join(oe);
	return t.validators.find(({ validator: e }) => e(a))?.classGroupId;
}, ce = /^\[(.+)\]$/, le = (e) => {
	if (ce.test(e)) {
		let t = ce.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
		if (n) return "arbitrary.." + n;
	}
}, ue = (e) => {
	let { theme: t, prefix: n } = e, r = {
		nextPart: /* @__PURE__ */ new Map(),
		validators: []
	};
	return me(Object.entries(e.classGroups), n).forEach(([e, n]) => {
		de(n, r, e, t);
	}), r;
}, de = (e, t, n, r) => {
	e.forEach((e) => {
		if (typeof e == "string") {
			let r = e === "" ? t : fe(t, e);
			r.classGroupId = n;
			return;
		}
		if (typeof e == "function") {
			if (pe(e)) {
				de(e(r), t, n, r);
				return;
			}
			t.validators.push({
				validator: e,
				classGroupId: n
			});
			return;
		}
		Object.entries(e).forEach(([e, i]) => {
			de(i, fe(t, e), n, r);
		});
	});
}, fe = (e, t) => {
	let n = e;
	return t.split(oe).forEach((e) => {
		n.nextPart.has(e) || n.nextPart.set(e, {
			nextPart: /* @__PURE__ */ new Map(),
			validators: []
		}), n = n.nextPart.get(e);
	}), n;
}, pe = (e) => e.isThemeGetter, me = (e, t) => t ? e.map(([e, n]) => [e, n.map((e) => typeof e == "string" ? t + e : typeof e == "object" ? Object.fromEntries(Object.entries(e).map(([e, n]) => [t + e, n])) : e)]) : e, he = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = (i, a) => {
		n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
	};
	return {
		get(e) {
			let t = n.get(e);
			if (t !== void 0) return t;
			if ((t = r.get(e)) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			n.has(e) ? n.set(e, t) : i(e, t);
		}
	};
}, ge = "!", _e = (e) => {
	let { separator: t, experimentalParseClassName: n } = e, r = t.length === 1, i = t[0], a = t.length, o = (e) => {
		let n = [], o = 0, s = 0, c;
		for (let l = 0; l < e.length; l++) {
			let u = e[l];
			if (o === 0) {
				if (u === i && (r || e.slice(l, l + a) === t)) {
					n.push(e.slice(s, l)), s = l + a;
					continue;
				}
				if (u === "/") {
					c = l;
					continue;
				}
			}
			u === "[" ? o++ : u === "]" && o--;
		}
		let l = n.length === 0 ? e : e.substring(s), u = l.startsWith(ge);
		return {
			modifiers: n,
			hasImportantModifier: u,
			baseClassName: u ? l.substring(1) : l,
			maybePostfixModifierPosition: c && c > s ? c - s : void 0
		};
	};
	return n ? (e) => n({
		className: e,
		parseClassName: o
	}) : o;
}, ve = (e) => {
	if (e.length <= 1) return e;
	let t = [], n = [];
	return e.forEach((e) => {
		e[0] === "[" ? (t.push(...n.sort(), e), n = []) : n.push(e);
	}), t.push(...n.sort()), t;
}, ye = (e) => ({
	cache: he(e.cacheSize),
	parseClassName: _e(e),
	...A(e)
}), be = /\s+/, xe = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i } = t, a = [], o = e.trim().split(be), s = "";
	for (let e = o.length - 1; e >= 0; --e) {
		let t = o[e], { modifiers: c, hasImportantModifier: l, baseClassName: u, maybePostfixModifierPosition: d } = n(t), f = !!d, p = r(f ? u.substring(0, d) : u);
		if (!p) {
			if (!f) {
				s = t + (s.length > 0 ? " " + s : s);
				continue;
			}
			if (p = r(u), !p) {
				s = t + (s.length > 0 ? " " + s : s);
				continue;
			}
			f = !1;
		}
		let ee = ve(c).join(":"), m = l ? ee + ge : ee, h = m + p;
		if (a.includes(h)) continue;
		a.push(h);
		let g = i(p, f);
		for (let e = 0; e < g.length; ++e) {
			let t = g[e];
			a.push(m + t);
		}
		s = t + (s.length > 0 ? " " + s : s);
	}
	return s;
};
function j() {
	let e = 0, t, n, r = "";
	for (; e < arguments.length;) (t = arguments[e++]) && (n = Se(t)) && (r && (r += " "), r += n);
	return r;
}
var Se = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = Se(e[r])) && (n && (n += " "), n += t);
	return n;
};
function Ce(e, ...t) {
	let n, r, i, a = o;
	function o(o) {
		return n = ye(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o);
	}
	function s(e) {
		let t = r(e);
		if (t) return t;
		let a = xe(e, n);
		return i(e, a), a;
	}
	return function() {
		return a(j.apply(null, arguments));
	};
}
var M = (e) => {
	let t = (t) => t[e] || [];
	return t.isThemeGetter = !0, t;
}, we = /^\[(?:([a-z-]+):)?(.+)\]$/i, Te = /^\d+\/\d+$/, Ee = /*#__PURE__*/ new Set([
	"px",
	"full",
	"screen"
]), De = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Oe = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ke = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Ae = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, je = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Me = (e) => Pe(e) || Ee.has(e) || Te.test(e), Ne = (e) => Ke(e, "length", qe), Pe = (e) => !!e && !Number.isNaN(Number(e)), Fe = (e) => Ke(e, "number", Pe), Ie = (e) => !!e && Number.isInteger(Number(e)), Le = (e) => e.endsWith("%") && Pe(e.slice(0, -1)), N = (e) => we.test(e), Re = (e) => De.test(e), ze = /*#__PURE__*/ new Set([
	"length",
	"size",
	"percentage"
]), Be = (e) => Ke(e, ze, Je), Ve = (e) => Ke(e, "position", Je), He = /*#__PURE__*/ new Set(["image", "url"]), Ue = (e) => Ke(e, He, Xe), We = (e) => Ke(e, "", Ye), Ge = () => !0, Ke = (e, t, n) => {
	let r = we.exec(e);
	return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, qe = (e) => Oe.test(e) && !ke.test(e), Je = () => !1, Ye = (e) => Ae.test(e), Xe = (e) => je.test(e), Ze = /*#__PURE__*/ Ce(() => {
	let e = M("colors"), t = M("spacing"), n = M("blur"), r = M("brightness"), i = M("borderColor"), a = M("borderRadius"), o = M("borderSpacing"), s = M("borderWidth"), c = M("contrast"), l = M("grayscale"), u = M("hueRotate"), d = M("invert"), f = M("gap"), p = M("gradientColorStops"), ee = M("gradientColorStopPositions"), m = M("inset"), h = M("margin"), g = M("opacity"), _ = M("padding"), te = M("saturate"), ne = M("scale"), v = M("sepia"), re = M("skew"), ie = M("space"), y = M("translate"), b = () => [
		"auto",
		"contain",
		"none"
	], x = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], S = () => [
		"auto",
		N,
		t
	], C = () => [N, t], w = () => [
		"",
		Me,
		Ne
	], T = () => [
		"auto",
		Pe,
		N
	], E = () => [
		"bottom",
		"center",
		"left",
		"left-bottom",
		"left-top",
		"right",
		"right-bottom",
		"right-top",
		"top"
	], D = () => [
		"solid",
		"dashed",
		"dotted",
		"double",
		"none"
	], O = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], k = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch"
	], ae = () => [
		"",
		"0",
		N
	], oe = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], A = () => [Pe, N];
	return {
		cacheSize: 500,
		separator: ":",
		theme: {
			colors: [Ge],
			spacing: [Me, Ne],
			blur: [
				"none",
				"",
				Re,
				N
			],
			brightness: A(),
			borderColor: [e],
			borderRadius: [
				"none",
				"",
				"full",
				Re,
				N
			],
			borderSpacing: C(),
			borderWidth: w(),
			contrast: A(),
			grayscale: ae(),
			hueRotate: A(),
			invert: ae(),
			gap: C(),
			gradientColorStops: [e],
			gradientColorStopPositions: [Le, Ne],
			inset: S(),
			margin: S(),
			opacity: A(),
			padding: C(),
			saturate: A(),
			scale: A(),
			sepia: ae(),
			skew: A(),
			space: C(),
			translate: C()
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				"video",
				N
			] }],
			container: ["container"],
			columns: [{ columns: [Re] }],
			"break-after": [{ "break-after": oe() }],
			"break-before": [{ "break-before": oe() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: [...E(), N] }],
			overflow: [{ overflow: x() }],
			"overflow-x": [{ "overflow-x": x() }],
			"overflow-y": [{ "overflow-y": x() }],
			overscroll: [{ overscroll: b() }],
			"overscroll-x": [{ "overscroll-x": b() }],
			"overscroll-y": [{ "overscroll-y": b() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: [m] }],
			"inset-x": [{ "inset-x": [m] }],
			"inset-y": [{ "inset-y": [m] }],
			start: [{ start: [m] }],
			end: [{ end: [m] }],
			top: [{ top: [m] }],
			right: [{ right: [m] }],
			bottom: [{ bottom: [m] }],
			left: [{ left: [m] }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				"auto",
				Ie,
				N
			] }],
			basis: [{ basis: S() }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"wrap",
				"wrap-reverse",
				"nowrap"
			] }],
			flex: [{ flex: [
				"1",
				"auto",
				"initial",
				"none",
				N
			] }],
			grow: [{ grow: ae() }],
			shrink: [{ shrink: ae() }],
			order: [{ order: [
				"first",
				"last",
				"none",
				Ie,
				N
			] }],
			"grid-cols": [{ "grid-cols": [Ge] }],
			"col-start-end": [{ col: [
				"auto",
				{ span: [
					"full",
					Ie,
					N
				] },
				N
			] }],
			"col-start": [{ "col-start": T() }],
			"col-end": [{ "col-end": T() }],
			"grid-rows": [{ "grid-rows": [Ge] }],
			"row-start-end": [{ row: [
				"auto",
				{ span: [Ie, N] },
				N
			] }],
			"row-start": [{ "row-start": T() }],
			"row-end": [{ "row-end": T() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": [
				"auto",
				"min",
				"max",
				"fr",
				N
			] }],
			"auto-rows": [{ "auto-rows": [
				"auto",
				"min",
				"max",
				"fr",
				N
			] }],
			gap: [{ gap: [f] }],
			"gap-x": [{ "gap-x": [f] }],
			"gap-y": [{ "gap-y": [f] }],
			"justify-content": [{ justify: ["normal", ...k()] }],
			"justify-items": [{ "justify-items": [
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"justify-self": [{ "justify-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"align-content": [{ content: [
				"normal",
				...k(),
				"baseline"
			] }],
			"align-items": [{ items: [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"align-self": [{ self: [
				"auto",
				"start",
				"end",
				"center",
				"stretch",
				"baseline"
			] }],
			"place-content": [{ "place-content": [...k(), "baseline"] }],
			"place-items": [{ "place-items": [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"place-self": [{ "place-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			p: [{ p: [_] }],
			px: [{ px: [_] }],
			py: [{ py: [_] }],
			ps: [{ ps: [_] }],
			pe: [{ pe: [_] }],
			pt: [{ pt: [_] }],
			pr: [{ pr: [_] }],
			pb: [{ pb: [_] }],
			pl: [{ pl: [_] }],
			m: [{ m: [h] }],
			mx: [{ mx: [h] }],
			my: [{ my: [h] }],
			ms: [{ ms: [h] }],
			me: [{ me: [h] }],
			mt: [{ mt: [h] }],
			mr: [{ mr: [h] }],
			mb: [{ mb: [h] }],
			ml: [{ ml: [h] }],
			"space-x": [{ "space-x": [ie] }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": [ie] }],
			"space-y-reverse": ["space-y-reverse"],
			w: [{ w: [
				"auto",
				"min",
				"max",
				"fit",
				"svw",
				"lvw",
				"dvw",
				N,
				t
			] }],
			"min-w": [{ "min-w": [
				N,
				t,
				"min",
				"max",
				"fit"
			] }],
			"max-w": [{ "max-w": [
				N,
				t,
				"none",
				"full",
				"min",
				"max",
				"fit",
				"prose",
				{ screen: [Re] },
				Re
			] }],
			h: [{ h: [
				N,
				t,
				"auto",
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"min-h": [{ "min-h": [
				N,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"max-h": [{ "max-h": [
				N,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			size: [{ size: [
				N,
				t,
				"auto",
				"min",
				"max",
				"fit"
			] }],
			"font-size": [{ text: [
				"base",
				Re,
				Ne
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black",
				Fe
			] }],
			"font-family": [{ font: [Ge] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest",
				N
			] }],
			"line-clamp": [{ "line-clamp": [
				"none",
				Pe,
				Fe
			] }],
			leading: [{ leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose",
				Me,
				N
			] }],
			"list-image": [{ "list-image": ["none", N] }],
			"list-style-type": [{ list: [
				"none",
				"disc",
				"decimal",
				N
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"placeholder-color": [{ placeholder: [e] }],
			"placeholder-opacity": [{ "placeholder-opacity": [g] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"text-color": [{ text: [e] }],
			"text-opacity": [{ "text-opacity": [g] }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...D(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				"auto",
				"from-font",
				Me,
				Ne
			] }],
			"underline-offset": [{ "underline-offset": [
				"auto",
				Me,
				N
			] }],
			"text-decoration-color": [{ decoration: [e] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: C() }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				N
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: ["none", N] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-opacity": [{ "bg-opacity": [g] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: [...E(), Ve] }],
			"bg-repeat": [{ bg: ["no-repeat", { repeat: [
				"",
				"x",
				"y",
				"round",
				"space"
			] }] }],
			"bg-size": [{ bg: [
				"auto",
				"cover",
				"contain",
				Be
			] }],
			"bg-image": [{ bg: [
				"none",
				{ "gradient-to": [
					"t",
					"tr",
					"r",
					"br",
					"b",
					"bl",
					"l",
					"tl"
				] },
				Ue
			] }],
			"bg-color": [{ bg: [e] }],
			"gradient-from-pos": [{ from: [ee] }],
			"gradient-via-pos": [{ via: [ee] }],
			"gradient-to-pos": [{ to: [ee] }],
			"gradient-from": [{ from: [p] }],
			"gradient-via": [{ via: [p] }],
			"gradient-to": [{ to: [p] }],
			rounded: [{ rounded: [a] }],
			"rounded-s": [{ "rounded-s": [a] }],
			"rounded-e": [{ "rounded-e": [a] }],
			"rounded-t": [{ "rounded-t": [a] }],
			"rounded-r": [{ "rounded-r": [a] }],
			"rounded-b": [{ "rounded-b": [a] }],
			"rounded-l": [{ "rounded-l": [a] }],
			"rounded-ss": [{ "rounded-ss": [a] }],
			"rounded-se": [{ "rounded-se": [a] }],
			"rounded-ee": [{ "rounded-ee": [a] }],
			"rounded-es": [{ "rounded-es": [a] }],
			"rounded-tl": [{ "rounded-tl": [a] }],
			"rounded-tr": [{ "rounded-tr": [a] }],
			"rounded-br": [{ "rounded-br": [a] }],
			"rounded-bl": [{ "rounded-bl": [a] }],
			"border-w": [{ border: [s] }],
			"border-w-x": [{ "border-x": [s] }],
			"border-w-y": [{ "border-y": [s] }],
			"border-w-s": [{ "border-s": [s] }],
			"border-w-e": [{ "border-e": [s] }],
			"border-w-t": [{ "border-t": [s] }],
			"border-w-r": [{ "border-r": [s] }],
			"border-w-b": [{ "border-b": [s] }],
			"border-w-l": [{ "border-l": [s] }],
			"border-opacity": [{ "border-opacity": [g] }],
			"border-style": [{ border: [...D(), "hidden"] }],
			"divide-x": [{ "divide-x": [s] }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": [s] }],
			"divide-y-reverse": ["divide-y-reverse"],
			"divide-opacity": [{ "divide-opacity": [g] }],
			"divide-style": [{ divide: D() }],
			"border-color": [{ border: [i] }],
			"border-color-x": [{ "border-x": [i] }],
			"border-color-y": [{ "border-y": [i] }],
			"border-color-s": [{ "border-s": [i] }],
			"border-color-e": [{ "border-e": [i] }],
			"border-color-t": [{ "border-t": [i] }],
			"border-color-r": [{ "border-r": [i] }],
			"border-color-b": [{ "border-b": [i] }],
			"border-color-l": [{ "border-l": [i] }],
			"divide-color": [{ divide: [i] }],
			"outline-style": [{ outline: ["", ...D()] }],
			"outline-offset": [{ "outline-offset": [Me, N] }],
			"outline-w": [{ outline: [Me, Ne] }],
			"outline-color": [{ outline: [e] }],
			"ring-w": [{ ring: w() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: [e] }],
			"ring-opacity": [{ "ring-opacity": [g] }],
			"ring-offset-w": [{ "ring-offset": [Me, Ne] }],
			"ring-offset-color": [{ "ring-offset": [e] }],
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				Re,
				We
			] }],
			"shadow-color": [{ shadow: [Ge] }],
			opacity: [{ opacity: [g] }],
			"mix-blend": [{ "mix-blend": [
				...O(),
				"plus-lighter",
				"plus-darker"
			] }],
			"bg-blend": [{ "bg-blend": O() }],
			filter: [{ filter: ["", "none"] }],
			blur: [{ blur: [n] }],
			brightness: [{ brightness: [r] }],
			contrast: [{ contrast: [c] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				Re,
				N
			] }],
			grayscale: [{ grayscale: [l] }],
			"hue-rotate": [{ "hue-rotate": [u] }],
			invert: [{ invert: [d] }],
			saturate: [{ saturate: [te] }],
			sepia: [{ sepia: [v] }],
			"backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
			"backdrop-blur": [{ "backdrop-blur": [n] }],
			"backdrop-brightness": [{ "backdrop-brightness": [r] }],
			"backdrop-contrast": [{ "backdrop-contrast": [c] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [l] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [u] }],
			"backdrop-invert": [{ "backdrop-invert": [d] }],
			"backdrop-opacity": [{ "backdrop-opacity": [g] }],
			"backdrop-saturate": [{ "backdrop-saturate": [te] }],
			"backdrop-sepia": [{ "backdrop-sepia": [v] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": [o] }],
			"border-spacing-x": [{ "border-spacing-x": [o] }],
			"border-spacing-y": [{ "border-spacing-y": [o] }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"none",
				"all",
				"",
				"colors",
				"opacity",
				"shadow",
				"transform",
				N
			] }],
			duration: [{ duration: A() }],
			ease: [{ ease: [
				"linear",
				"in",
				"out",
				"in-out",
				N
			] }],
			delay: [{ delay: A() }],
			animate: [{ animate: [
				"none",
				"spin",
				"ping",
				"pulse",
				"bounce",
				N
			] }],
			transform: [{ transform: [
				"",
				"gpu",
				"none"
			] }],
			scale: [{ scale: [ne] }],
			"scale-x": [{ "scale-x": [ne] }],
			"scale-y": [{ "scale-y": [ne] }],
			rotate: [{ rotate: [Ie, N] }],
			"translate-x": [{ "translate-x": [y] }],
			"translate-y": [{ "translate-y": [y] }],
			"skew-x": [{ "skew-x": [re] }],
			"skew-y": [{ "skew-y": [re] }],
			"transform-origin": [{ origin: [
				"center",
				"top",
				"top-right",
				"right",
				"bottom-right",
				"bottom",
				"bottom-left",
				"left",
				"top-left",
				N
			] }],
			accent: [{ accent: ["auto", e] }],
			appearance: [{ appearance: ["none", "auto"] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				N
			] }],
			"caret-color": [{ caret: [e] }],
			"pointer-events": [{ "pointer-events": ["none", "auto"] }],
			resize: [{ resize: [
				"none",
				"y",
				"x",
				""
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scroll-m": [{ "scroll-m": C() }],
			"scroll-mx": [{ "scroll-mx": C() }],
			"scroll-my": [{ "scroll-my": C() }],
			"scroll-ms": [{ "scroll-ms": C() }],
			"scroll-me": [{ "scroll-me": C() }],
			"scroll-mt": [{ "scroll-mt": C() }],
			"scroll-mr": [{ "scroll-mr": C() }],
			"scroll-mb": [{ "scroll-mb": C() }],
			"scroll-ml": [{ "scroll-ml": C() }],
			"scroll-p": [{ "scroll-p": C() }],
			"scroll-px": [{ "scroll-px": C() }],
			"scroll-py": [{ "scroll-py": C() }],
			"scroll-ps": [{ "scroll-ps": C() }],
			"scroll-pe": [{ "scroll-pe": C() }],
			"scroll-pt": [{ "scroll-pt": C() }],
			"scroll-pr": [{ "scroll-pr": C() }],
			"scroll-pb": [{ "scroll-pb": C() }],
			"scroll-pl": [{ "scroll-pl": C() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				N
			] }],
			fill: [{ fill: [e, "none"] }],
			"stroke-w": [{ stroke: [
				Me,
				Ne,
				Fe
			] }],
			stroke: [{ stroke: [e, "none"] }],
			sr: ["sr-only", "not-sr-only"],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-s",
				"border-w-e",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-s",
				"border-color-e",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] }
	};
});
//#endregion
//#region src/helpers/style.helpers.ts
function P(...e) {
	return Ze(ae(e));
}
//#endregion
//#region node_modules/@open-wc/lit-helpers/src/spread.js
var Qe = class extends d {
	constructor() {
		super(...arguments), this.prevData = {};
	}
	render(e) {
		return l;
	}
	update(e, [t]) {
		this.element !== e.element && (this.element = e.element), this.host = e.options?.host || this.element, this.apply(t), this.groom(t), this.prevData = { ...t };
	}
	apply(e) {
		if (!e) return;
		let { prevData: t, element: n } = this;
		for (let r in e) {
			let i = e[r];
			i !== t[r] && (n[r] = i);
		}
	}
	groom(e) {
		let { prevData: t, element: n } = this;
		if (t) for (let r in t) (!e || !(r in e) && n[r] === t[r]) && (n[r] = void 0);
	}
};
u(Qe);
var $e = class extends Qe {
	constructor() {
		super(...arguments), this.eventData = {};
	}
	apply(e) {
		if (e) for (let t in e) {
			let n = e[t];
			n !== this.eventData[t] && this.applyEvent(t, n);
		}
	}
	applyEvent(e, t) {
		let { prevData: n, element: r } = this;
		this.eventData[e] = t, n[e] && r.removeEventListener(e, this, t), r.addEventListener(e, this, t);
	}
	groom(e) {
		let { prevData: t, element: n } = this;
		if (t) for (let r in t) (!e || !(r in e) && n[r] === t[r]) && this.groomEvent(r, t[r]);
	}
	groomEvent(e, t) {
		let { element: n } = this;
		delete this.eventData[e], n.removeEventListener(e, this, t);
	}
	handleEvent(e) {
		let t = this.eventData[e.type];
		typeof t == "function" ? t.call(this.host, e) : t.handleEvent(e);
	}
	disconnected() {
		let { eventData: e, element: t } = this;
		for (let n in e) {
			let r = n.slice(1), i = e[n];
			t.removeEventListener(r, this, i);
		}
	}
	reconnected() {
		let { eventData: e, element: t } = this;
		for (let n in e) {
			let r = n.slice(1), i = e[n];
			t.addEventListener(r, this, i);
		}
	}
};
u($e);
var F = u(class extends $e {
	apply(e) {
		if (!e) return;
		let { prevData: t, element: n } = this;
		for (let r in e) {
			let i = e[r];
			if (i === t[r]) continue;
			let a = r.slice(1);
			switch (r[0]) {
				case "@":
					this.eventData[a] = i, this.applyEvent(a, i);
					break;
				case ".":
					n[a] = i;
					break;
				case "?":
					i ? n.setAttribute(a, "") : n.removeAttribute(a);
					break;
				default:
					i == null ? n.removeAttribute(r) : n.setAttribute(r, String(i));
					break;
			}
		}
	}
	groom(e) {
		let { prevData: t, element: n } = this;
		if (t) for (let r in t) {
			let i = r.slice(1);
			if (!e || !(r in e) && n[i] === t[r]) switch (r[0]) {
				case "@":
					this.groomEvent(i, t[r]);
					break;
				case ".":
					n[i] = void 0;
					break;
				case "?":
					n.removeAttribute(i);
					break;
				default:
					n.removeAttribute(r);
					break;
			}
		}
	}
}), et = {
	base: [""],
	item: ["rtg-border-b-accordion-item-width-border rtg-border-b-accordion-item-color-border"],
	trigger: [
		"rtg-flex rtg-flex-1 rtg-gap-accordion-trigger-space-gap rtg-justify-between rtg-items-start",
		"rtg-py-accordion-trigger-space-py",
		"rtg-w-accordion-trigger-space-w",
		"rtg-rounded-accordion-trigger-radius rtg-outline-none",
		"rtg-text-accordion-trigger-font rtg-font-accordion-trigger-font-weight rtg-text-left",
		"rtg-transition-all",
		"hover:rtg-underline",
		"focus-visible:rtg-border-accordion-trigger-width-border-focus focus-visible:rtg-border-accordion-trigger-color-border-focus",
		"focus-visible:rtg-ring-accordion-trigger-width-ring-focus focus-visible:rtg-ring-accordion-trigger-color-ring-focus",
		"disabled:rtg-pointer-events-none disabled:rtg-opacity-50",
		"[&[data-state=open]>svg]:rtg-rotate-180"
	],
	chevron: [
		"rtg-shrink-0",
		"rtg-size-accordion-trigger-icon-space-size",
		"rtg-text-accordion-trigger-icon-color-text",
		"rtg-translate-y-0.5 rtg-transition-transform rtg-duration-200",
		"rtg-pointer-events-none"
	],
	content: [
		"rtg-overflow-hidden",
		"rtg-text-accordion-content-font rtg-font-accordion-content-font-weight",
		"data-[state=closed]:rtg-h-accordion-content-space-h-closed",
		"data-[state=closed]:rtg-animate-accordion-content-animate-closed",
		"data-[state=open]:rtg-animate-accordion-content-animate-open",
		"data-[state=open]:rtg-h-fit",
		"[&>div]:rtg-pt-accordion-content-div-space-pt [&>div]:rtg-pb-accordion-content-div-space-pb"
	]
}, tt = class extends w {
	constructor(...e) {
		super(...e), this._onAccordionClick = () => {
			this.requestUpdate();
		};
	}
	get _accordion() {
		let e = this.parentElement;
		for (; e && !(e instanceof it);) e = e.parentElement;
		return e;
	}
	get _item() {
		let e = this.parentElement;
		for (; e && !(e instanceof I);) e = e.parentElement;
		return e;
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._accordion?.addEventListener("clicked-accordion", this._onAccordionClick);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._accordion?.removeEventListener("clicked-accordion", this._onAccordionClick);
	}
	firstUpdated(e) {
		this.removeDuplicateContent();
	}
	hasActiveState() {
		return !!this._item?.value && !!this._accordion?.selectedItems.includes(this._item.value);
	}
	render() {
		return n`
      <div
        part="accordion-content"
        role="region"
        data-state=${this.hasActiveState() ? "open" : "closed"}
        data-orientation="vertical"
        class=${P(et.content, this.className)}
        @click=${(e) => e.stopPropagation()}
      >
        <div>${f(this.textContent?.trim() || "")}</div>
      </div>
    `;
	}
};
tt = C([a("rtg-accordion-content")], tt);
//#endregion
//#region src/components/ui/accordion/accordion-item.ts
var I = class extends w {
	constructor(...e) {
		super(...e), this.value = "", this.tabindex = 0, this._initialChildren = [], this._onClick = (e) => {
			let t = e.target.closest("rtg-accordion-trigger");
			!t || !this._accordion || (e.preventDefault(), e.stopPropagation(), this._accordion.raiseEvent(this.value), t.requestUpdate(), setTimeout(() => this.requestUpdate(), 0));
		}, this._onAccordionClick = () => {
			this.requestUpdate();
		};
	}
	get _accordion() {
		let e = this.parentElement;
		for (; e && !(e instanceof it);) e = e.parentElement;
		return e;
	}
	getAttributesToExclude() {
		return [
			"aria-orientation",
			"role",
			"data-orientation",
			"data-testid"
		];
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._initialChildren = this.filterChildren(), this.addEventListener("click", this._onClick), this._accordion?.addEventListener("clicked-accordion", this._onAccordionClick);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener("click", this._onClick), this._accordion?.removeEventListener("clicked-accordion", this._onAccordionClick);
	}
	filterChildren() {
		return Array.from(this.children).filter((e) => e instanceof nt || e instanceof tt);
	}
	render() {
		let e = this._accordion?.selectedItems.includes(this.value), t = this._initialChildren.length ? this._initialChildren : this.filterChildren();
		return n`
      <div
        data-state=${e ? "open" : "closed"}
        class="${P(et.item, this.className)}"
        value=${this.value}
        role="tablist"
        data-orientation="vertical"
        part="accordion-item"
      >
        ${t}
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], I.prototype, "value", void 0), C([o({ type: Number }), S("design:type", Object)], I.prototype, "tabindex", void 0), I = C([a("rtg-accordion-item")], I);
//#endregion
//#region src/components/ui/accordion/accordion-trigger.ts
var nt = class extends w {
	get _item() {
		let e = this.parentElement;
		for (; e && !(e instanceof I);) e = e.parentElement;
		return e;
	}
	get _accordion() {
		let e = this.parentElement;
		for (; e && !(e instanceof it);) e = e.parentElement;
		return e;
	}
	getAttributesToExclude() {
		return ["value", "defaultValue"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.removeDuplicateContent();
	}
	hasActiveState() {
		return !!this._item?.value && !!this._accordion?.selectedItems.includes(this._item.value);
	}
	render() {
		let e = this.hasActiveState();
		return n`
      <button
        type="button"
        part="accordion-trigger"
        role="tab"
        value=${this._item?.value || ""}
        aria-selected=${e}
        aria-expanded=${e}
        data-state=${e ? "open" : "closed"}
        class="${P(et.trigger, this.className)}"
        tabindex="-1"
        data-orientation="horizontal"
        data-radix-collection-item
      >
        ${f(this.textContent || "")}

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class=${P(et.chevron, "lucide lucide-chevron-down-icon lucide-chevron-down")}
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>
    `;
	}
};
nt = C([a("rtg-accordion-trigger")], nt);
//#endregion
//#region src/components/ui/accordion/accordion.defs.ts
var rt = /* @__PURE__ */ function(e) {
	return e.MULTIPLE = "multiple", e.SINGLE = "single", e;
}({}), it = class extends w {
	constructor(...e) {
		super(...e), this.type = rt.MULTIPLE, this.selectedItems = [], this._initialChildren = [];
	}
	getAttributesToExclude() {
		return ["variant", "data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._initialChildren = Array.from(this.children).filter((e) => e instanceof I);
	}
	willUpdate(e) {
		e.has("type") && (this.type === rt.SINGLE && this.selectedItems.length > 1 && (this.selectedItems = this.selectedItems.slice(0, 1)), this._initialChildren.forEach((e) => {
			e instanceof I && e.requestUpdate();
		}));
	}
	updated(e) {
		e.has("type") && this._initialChildren.forEach((e) => {
			e instanceof I && e.requestUpdate();
		});
	}
	setSelectedItems(e) {
		let t = this.selectedItems.indexOf(e);
		if (t > -1) if (this.type === rt.SINGLE) this.selectedItems = [];
		else if (this.type === rt.MULTIPLE) this.selectedItems.splice(t, 1);
		else throw Error("Invalid accordion type");
		else if (this.type === rt.SINGLE) this.selectedItems = [e];
		else if (this.type === rt.MULTIPLE) this.selectedItems.push(e);
		else throw Error("Invalid accordion type");
	}
	raiseEvent(e) {
		this.setSelectedItems(e), this.dispatchEvent(new CustomEvent("clicked-accordion", {
			bubbles: !0,
			composed: !0,
			detail: { selectedItems: this.selectedItems }
		}));
	}
	render() {
		let e = this._initialChildren.length ? this._initialChildren : Array.from(this.children).filter((e) => e instanceof I);
		return n`
      <div
        data-orientation="vertical"
        ${F(this.getFilteredAttributes())}
        part="accordion"
        class="${P(et.base, this.className)}"
      >
        ${e}
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", rt === void 0 ? Object : rt)], it.prototype, "type", void 0), it = C([a("rtg-accordion")], it);
//#endregion
//#region src/components/ui/alert/_alert.ts
var at = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"alert\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="alert" data-variant=${this.variant}></div>`;
	}
};
C([o({ type: String }), S("design:type", Object)], at.prototype, "variant", void 0), at = C([a("rtg-alert")], at);
//#endregion
//#region src/components/ui/alert/_alert-title.ts
var ot = class extends e {
	get _titleSlot() {
		return this.querySelector("[data-slot=\"alert-title\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._titleSlot && this._titleSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="alert-title"></div>`;
	}
};
ot = C([a("rtg-alert-title")], ot);
//#endregion
//#region src/components/ui/alert/_alert-description.ts
var st = class extends e {
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"alert-description\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._descriptionSlot && this._descriptionSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="alert-description"></div>`;
	}
};
st = C([a("rtg-alert-description")], st);
//#endregion
//#region src/components/ui/alert/_alert-action.ts
var ct = class extends e {
	get _actionSlot() {
		return this.querySelector("[data-slot=\"alert-action\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._actionSlot && this._actionSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="alert-action"></div>`;
	}
};
ct = C([a("rtg-alert-action")], ct);
//#endregion
//#region src/components/ui/aspect-ratio/aspect-ratio.styles.ts
var lt = {
	host: ["rtg-block rtg-relative rtg-w-full"],
	self: ["rtg-absolute rtg-inset-0"]
}, ut = class extends e {
	constructor(...e) {
		super(...e), this.ratio = 1 / 1, this._userClass = "", this._userStyle = "";
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._userClass = this.getAttribute("class") ?? "", this._userStyle = this.getAttribute("style") ?? "", this._userClass && this.removeAttribute("class"), this._userStyle && this.removeAttribute("style"), this.className = P(this.className, lt.host);
	}
	updated(e) {
		e.has("ratio") && (this.style.paddingBottom = this.ratio > 0 ? `${100 / this.ratio}%` : "0%");
	}
	firstUpdated() {
		this.style.paddingBottom = this.ratio > 0 ? `${100 / this.ratio}%` : "0%";
		let e = this.querySelector(".aspect-ratio");
		if (e) {
			if (this._userClass && (e.className = P(e.className, this._userClass)), this._userStyle) {
				let t = e.getAttribute("style")?.trim(), n = this._userStyle.trim();
				e.setAttribute("style", [t, n].filter(Boolean).join("; "));
			}
			Array.from(this.childNodes).forEach((t) => {
				t !== e && e.appendChild(t);
			});
		}
	}
	render() {
		return n`
      <div class="${P("aspect-ratio", lt.self)}"></div>
    `;
	}
};
C([o({
	type: Number,
	reflect: !0
}), S("design:type", Object)], ut.prototype, "ratio", void 0), ut = C([a("rtg-aspect-ratio")], ut);
//#endregion
//#region src/components/ui/avatar/_avatar.ts
var dt = class extends e {
	constructor(...e) {
		super(...e), this.size = "default", this._imageLoaded = !1, this._imageError = !1;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"avatar\"]");
	}
	get _avatarImageChild() {
		return this.querySelector("rtg-avatar-image");
	}
	get _avatarFallbackChild() {
		return this.querySelector("rtg-avatar-fallback");
	}
	_syncChildren() {
		let e = this._imageError || !this._imageLoaded;
		this._avatarImageChild && (this._avatarImageChild.style.display = e ? "none" : ""), this._avatarFallbackChild && (this._avatarFallbackChild.style.display = e ? "" : "none");
	}
	_onImageLoad() {
		this._imageLoaded = !0, this._imageError = !1, this._syncChildren();
	}
	_onImageError() {
		this._imageLoaded = !1, this._imageError = !0, this._syncChildren();
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("rtg-avatar:image-load", this._onImageLoad), this.addEventListener("rtg-avatar:image-error", this._onImageError);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener("rtg-avatar:image-load", this._onImageLoad), this.removeEventListener("rtg-avatar:image-error", this._onImageError);
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<span data-slot="avatar" data-size=${this.size}></span>`;
	}
};
C([o({ type: String }), S("design:type", Object)], dt.prototype, "size", void 0), C([c(), S("design:type", Object)], dt.prototype, "_imageLoaded", void 0), C([c(), S("design:type", Object)], dt.prototype, "_imageError", void 0), dt = C([a("rtg-avatar")], dt);
//#endregion
//#region src/components/ui/avatar/_avatar-image.ts
var ft = class extends e {
	_onLoad() {
		this.dispatchEvent(new CustomEvent("rtg-avatar:image-load", {
			bubbles: !0,
			composed: !0
		}));
	}
	_onError() {
		this.dispatchEvent(new CustomEvent("rtg-avatar:image-error", {
			bubbles: !0,
			composed: !0
		}));
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <img
        data-slot="avatar-image"
        src=${this.src ?? ""}
        alt=${this.alt ?? ""}
        @load=${this._onLoad}
        @error=${this._onError}
      />
    `;
	}
};
C([o({ type: String }), S("design:type", String)], ft.prototype, "src", void 0), C([o({ type: String }), S("design:type", String)], ft.prototype, "alt", void 0), ft = C([a("rtg-avatar-image")], ft);
//#endregion
//#region src/components/ui/avatar/_avatar-fallback.ts
var pt = class extends e {
	get _fallbackSlot() {
		return this.querySelector("[data-slot=\"avatar-fallback\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._fallbackSlot && this._fallbackSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<span data-slot="avatar-fallback"></span>`;
	}
};
pt = C([a("rtg-avatar-fallback")], pt);
//#endregion
//#region src/components/ui/avatar/_avatar-badge.ts
var mt = class extends e {
	get _badgeSlot() {
		return this.querySelector("[data-slot=\"avatar-badge\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._badgeSlot && this._badgeSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<span data-slot="avatar-badge"></span>`;
	}
};
mt = C([a("rtg-avatar-badge")], mt);
//#endregion
//#region src/components/ui/avatar/_avatar-group.ts
var ht = class extends e {
	get _groupSlot() {
		return this.querySelector("[data-slot=\"avatar-group\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._groupSlot && this._groupSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="avatar-group"></div>`;
	}
};
ht = C([a("rtg-avatar-group")], ht);
//#endregion
//#region src/components/ui/avatar/_avatar-group-count.ts
var gt = class extends e {
	get _groupCountSlot() {
		return this.querySelector("[data-slot=\"avatar-group-count\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._groupCountSlot && this._groupCountSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="avatar-group-count"></div>`;
	}
};
gt = C([a("rtg-avatar-group-count")], gt);
//#endregion
//#region src/components/ui/badge/_badge.ts
var _t = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"badge\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return this.href ? n`
        <a
          data-slot="badge"
          data-variant=${this.variant}
          href=${this.href}
          target=${this.target ?? r}
          aria-label=${this.ariaLabel ?? r}
          aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        ></a>
      ` : n`
      <span
        data-slot="badge"
        data-variant=${this.variant}
        aria-label=${this.ariaLabel ?? r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
      ></span>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], _t.prototype, "variant", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], _t.prototype, "invalid", void 0), C([o({ type: String }), S("design:type", String)], _t.prototype, "href", void 0), C([o({ type: String }), S("design:type", Object)], _t.prototype, "target", void 0), _t = C([a("rtg-badge")], _t);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb.styles.ts
var vt = {
	list: ["rtg-flex rtg-flex-wrap rtg-gap-breadcrumb-list-space-gap-sm sm:rtg-gap-breadcrumb-list-space-gap rtg-items-center", "rtg-text-breadcrumb-list-font rtg-font-breadcrumb-list-font-weight rtg-text-breadcrumb-list-color-text rtg-break-words"],
	item: ["rtg-inline-flex rtg-gap-breadcrumb-item-space-gap rtg-items-center"],
	link: ["rtg-transition-colors", "hover:rtg-text-breadcrumb-link-color-text-hover"],
	page: ["rtg-font-breadcrumb-page-font-weight rtg-text-breadcrumb-page-color-text"],
	separator: ["[&>svg]:rtg-size-breadcrumb-separator-icon-space-size"],
	ellipsis: [
		"rtg-flex rtg-justify-center rtg-items-center",
		"rtg-size-breadcrumb-ellipsis-space-size",
		"[&>svg]:rtg-size-breadcrumb-ellipsis-icon-space-size"
	]
}, yt = class extends w {
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <span
        ${F(this.getFilteredAttributes())}
        id="rtg-bread-crumb-ellipsis"
        role="presentation"
        aria-hidden="true"
        class="${P(vt.ellipsis, this.className)}"
        part="breadcrumb-ellipsis"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-ellipsis-icon lucide-ellipsis"
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>
      </span>
    `;
	}
};
yt = C([a("rtg-bread-crumb-ellipsis")], yt);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-item.ts
var bt = class extends w {
	get _containerElement() {
		return this.querySelector("li[part=breadcrumb-item]");
	}
	getAttributesToExclude() {
		return ["variant"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <li
        ${F(this.getFilteredAttributes())}
        id="rtg-bread-crumb-item"
        class="${P(vt.item, this.className)}"
        part="breadcrumb-item"
      ></li>
    `;
	}
};
bt = C([a("rtg-bread-crumb-item")], bt);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-link.ts
var xt = class extends w {
	constructor(...e) {
		super(...e), this.href = "/";
	}
	get _containerElement() {
		return this.querySelector("a[part=breadcrumb-link]");
	}
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <a
        ${F(this.getFilteredAttributes())}
        id="rtg-bread-crumb-link"
        class="${P(vt.link, this.className)}"
        href="${this.href}"
        part="breadcrumb-link"
      >
      </a>
    `;
	}
};
C([o({ type: String }), S("design:type", String)], xt.prototype, "href", void 0), xt = C([a("rtg-bread-crumb-link")], xt);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-list.ts
var St = class extends w {
	get _containerElement() {
		return this.querySelector("ol[part=breadcrumb-list]");
	}
	getAttributesToExclude() {
		return ["variant"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <ol
        ${F(this.getFilteredAttributes())}
        id="rtg-bread-crumb-list"
        class="${P(vt.list, this.className)}"
        part="breadcrumb-list"
      ></ol>
    `;
	}
};
St = C([a("rtg-bread-crumb-list")], St);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-separator.ts
var Ct = class extends w {
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <li
        ${F(this.getFilteredAttributes())}
        id="rtg-bread-crumb-separator"
        role="presentation"
        aria-hidden="true"
        class="${P(vt.separator, this.className)}"
        part="breadcrumb-separator"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-chevron-right-icon lucide-chevron-right"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </li>
    `;
	}
};
Ct = C([a("rtg-bread-crumb-separator")], Ct);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-text.ts
var wt = class extends w {
	get _containerElement() {
		return this.querySelector("span[part=breadcrumb-text]");
	}
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <span
        ${F(this.getFilteredAttributes())}
        id="rtg-bread-crumb-text"
        aria-disabled="true"
        aria-current="page"
        class="${P(vt.page, this.className)}"
        part="breadcrumb-text"
      >
      </span>
    `;
	}
};
wt = C([a("rtg-bread-crumb-text")], wt);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb.ts
var Tt = class extends w {
	get _containerElement() {
		return this.querySelector("nav[part=breadcrumb]");
	}
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <nav
        ${F(this.getFilteredAttributes())}
        part="breadcrumb"
        class="${P(this.className)}"
        aria-label="breadcrumb"
      ></nav>
    `;
	}
};
Tt = C([a("rtg-bread-crumb")], Tt);
//#endregion
//#region src/components/ui/button/_button.ts
var L = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default", this.size = "default", this.type = "button";
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"button\"]");
	}
	_handleClick(e) {
		this.onClick && this.onClick(e);
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return this.href ? n`
        <a
          data-slot="button"
          data-variant=${this.variant}
          data-size=${this.size}
          href=${this.href}
          target=${this.target ?? r}
          ?disabled=${this.disabled}
          aria-label=${this.ariaLabel ?? r}
          aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
          @click=${this._handleClick}
        ></a>
      ` : n`
      <button
        data-slot="button"
        data-variant=${this.variant}
        data-size=${this.size}
        type=${this.type}
        ?disabled=${this.disabled}
        aria-label=${this.ariaLabel ?? r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        @click=${this._handleClick}
      ></button>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], L.prototype, "variant", void 0), C([o({ type: String }), S("design:type", Object)], L.prototype, "size", void 0), C([o({ type: String }), S("design:type", Object)], L.prototype, "type", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], L.prototype, "disabled", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], L.prototype, "invalid", void 0), C([o({ type: String }), S("design:type", String)], L.prototype, "href", void 0), C([o({ type: String }), S("design:type", Object)], L.prototype, "target", void 0), C([o({
	attribute: !1,
	type: Function
}), S("design:type", Function)], L.prototype, "onClick", void 0), L = C([a("rtg-button")], L);
//#endregion
//#region src/components/ui/calendar/calendar.helpers.ts
var Et = [
	"Sunday",
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday"
];
function Dt(e) {
	let t = e % 100;
	if (t >= 11 && t <= 13) return "th";
	switch (e % 10) {
		case 1: return "st";
		case 2: return "nd";
		case 3: return "rd";
		default: return "th";
	}
}
function Ot(e) {
	let t = new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(e), n = new Intl.DateTimeFormat("en-US", { month: "long" }).format(e), r = e.getDate(), i = e.getFullYear();
	return `${t}, ${n} ${r}${Dt(r)}, ${i}`;
}
//#endregion
//#region node_modules/class-variance-authority/dist/index.mjs
var kt = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, At = ae, jt = (e, t) => (n) => {
	if (t?.variants == null) return At(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = kt(t) || kt(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return At(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, Mt = jt([
	"rtg-inline-flex rtg-items-center rtg-justify-center rtg-shrink-0",
	"rtg-text-button-font-size rtg-font-button-font-weight rtg-whitespace-nowrap",
	"rtg-rounded-button-radius rtg-outline-none",
	"rtg-transition-all",
	"disabled:rtg-opacity-button-opacity-disabled disabled:rtg-pointer-events-none",
	"focus-visible:rtg-border-button-width-border-focus focus-visible:rtg-border-button-color-border-focus focus-visible:rtg-ring-button-width-ring-focus",
	"aria-invalid:rtg-border-button-width-border-invalid aria-invalid:rtg-border-button-color-border-invalid",
	"aria-invalid:rtg-ring-button-width-ring-invalid aria-invalid:rtg-ring-button-color-ring-invalid",
	"[&_svg]:rtg-pointer-events-none [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-button-icon-space-size [&_svg]:rtg-shrink-0"
], {
	variants: {
		variant: {
			default: [
				"rtg-bg-button-default-color-bg rtg-text-button-default-color-text",
				"hover:rtg-bg-button-default-color-bg-hover",
				"focus-visible:rtg-ring-button-default-color-ring-focus"
			],
			destructive: [
				"rtg-bg-button-destructive-color-bg rtg-text-button-destructive-color-text",
				"hover:rtg-bg-button-destructive-color-bg-hover",
				"focus-visible:rtg-ring-button-destructive-color-ring-focus"
			],
			outline: [
				"rtg-bg-button-outline-color-bg",
				"rtg-border-button-outline-width-border rtg-border-button-outline-color-border",
				"hover:rtg-bg-button-outline-color-bg-hover hover:rtg-text-button-outline-color-text-hover",
				"focus-visible:rtg-ring-button-outline-color-ring-focus"
			],
			secondary: [
				"rtg-bg-button-secondary-color-bg rtg-text-button-secondary-color-text",
				"hover:rtg-bg-button-secondary-color-bg-hover",
				"focus-visible:rtg-ring-button-secondary-color-ring-focus"
			],
			ghost: ["hover:rtg-bg-button-ghost-color-bg-hover hover:rtg-text-button-ghost-color-text-hover", "focus-visible:rtg-ring-button-ghost-color-ring-focus"],
			link: [
				"rtg-text-button-link-color-text rtg-underline-offset-4",
				"hover:rtg-underline",
				"focus-visible:rtg-ring-button-link-color-ring-focus"
			]
		},
		size: {
			default: [
				"rtg-h-button-space-h-default",
				"rtg-gap-button-space-gap-default rtg-px-button-space-px-default rtg-py-button-space-py-default",
				"has-[>svg]:rtg-px-button-space-px-default-has-icon"
			],
			sm: [
				"rtg-h-button-space-h-sm",
				"rtg-gap-button-space-gap-sm rtg-px-button-space-px-sm",
				"has-[>svg]:rtg-px-button-space-px-sm-has-icon"
			],
			lg: [
				"rtg-h-button-space-h-lg",
				"rtg-gap-button-space-gap-lg rtg-px-button-space-px-lg",
				"has-[>svg]:rtg-px-button-space-px-lg-has-icon"
			],
			icon: "rtg-size-button-space-size-icon",
			"icon-sm": "rtg-size-button-space-size-icon-sm",
			"icon-lg": "rtg-size-button-space-size-icon-lg"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), R = {
	host: ["rtg-contents"],
	root: [
		"group/calendar",
		"rtg-relative",
		"rtg-p-calendar-space-p",
		"rtg-w-fit",
		"rtg-bg-calendar-color-bg"
	],
	months: ["rtg-flex rtg-relative", "rtg-flex-col md:rtg-flex-row rtg-gap-calendar-months-space-gap"],
	nav: [
		"rtg-flex rtg-absolute rtg-top-0 rtg-inset-x-0",
		"rtg-gap-calendar-nav-space-gap rtg-justify-between rtg-items-center",
		"rtg-w-full"
	],
	month: [
		"rtg-flex",
		"rtg-flex-col rtg-gap-calendar-month-space-gap",
		"rtg-w-full"
	],
	buttonPrevious: [
		P(Mt({
			variant: "ghost",
			size: "icon-sm"
		})),
		"rtg-select-none",
		"aria-disabled:rtg-opacity-calendar-button-previous-opacity-disabled"
	],
	buttonNext: [
		P(Mt({
			variant: "ghost",
			size: "icon-sm"
		})),
		"rtg-select-none",
		"aria-disabled:rtg-opacity-calendar-button-next-opacity-disabled"
	],
	chevron: ["rtg-size-calendar-chevron-space-size"],
	monthCaption: [
		"rtg-flex rtg-justify-center rtg-items-center",
		"rtg-px-calendar-month-caption-space-px",
		"rtg-w-full rtg-h-calendar-month-caption-space-h"
	],
	captionLabel: ["rtg-text-calendar-caption-label-font rtg-font-calendar-caption-label-font-weight", "rtg-select-none"],
	monthGrid: ["rtg-w-full", "rtg-border-collapse"],
	weekdays: ["rtg-flex"],
	weekday: [
		"rtg-flex-1",
		"rtg-text-calendar-weekday-font rtg-font-calendar-weekday-font-weight rtg-text-calendar-weekday-color-text",
		"rtg-rounded-calendar-weekday-radius",
		"rtg-select-none"
	],
	weeks: [""],
	week: [
		"rtg-flex",
		"rtg-mt-calendar-week-space-mt",
		"rtg-w-full"
	],
	day: {
		base: [
			"group/day",
			"rtg-aspect-square rtg-relative",
			"rtg-w-full rtg-h-full",
			"rtg-p-calendar-day-space-p",
			"rtg-text-center",
			"rtg-select-none"
		],
		today: ["rtg-bg-calendar-day-today-color-bg", "rtg-rounded-calendar-day-radius"],
		selected: {
			common: ["rtg-bg-calendar-day-color-bg-selected"],
			single: ["rtg-rounded-calendar-day-radius"],
			range: {
				start: ["rtg-rounded-l-calendar-day-radius"],
				middle: ["rtg-rounded-none"],
				end: ["rtg-rounded-r-calendar-day-radius"]
			}
		},
		index: {
			first: ["rtg-rounded-l-calendar-day-radius"],
			last: ["rtg-rounded-r-calendar-day-radius"]
		},
		hidden: ["rtg-invisible"]
	},
	dayButton: {
		base: [
			Mt({
				variant: "ghost",
				size: "icon"
			}),
			"rtg-aspect-square rtg-flex",
			"rtg-flex-col rtg-gap-calendar-day-button-space-gap",
			"rtg-size-auto rtg-w-full rtg-min-w-calendar-day-button-space-min-w",
			"rtg-text-calendar-day-button-font rtg-font-calendar-day-button-font-weight",
			"disabled:rtg-text-calendar-day-button-color-text-disabled disabled:rtg-opacity-calendar-day-button-opacity-disabled",
			"data-[selected-single=true]:rtg-text-calendar-day-button-color-text-single-selected data-[selected-single=true]:rtg-bg-calendar-day-button-color-bg-single-selected",
			"data-[range-start=true]:rtg-text-calendar-day-button-color-text-range-start data-[range-start=true]:rtg-bg-calendar-day-button-color-bg-range-start",
			"data-[range-middle=true]:rtg-text-calendar-day-button-color-text-range-middle data-[range-middle=true]:rtg-bg-calendar-day-button-color-bg-range-middle",
			"data-[range-end=true]:rtg-text-calendar-day-button-color-text-range-end data-[range-end=true]:rtg-bg-calendar-day-button-color-bg-range-end",
			"[&>span]:rtg-text-calendar-day-button-span-font [&>span]:rtg-opacity-calendar-day-button-span-opacity",
			"group-data-[focused=true]/day:rtg-relative group-data-[focused=true]/day:rtg-z-10",
			"group-data-[focused=true]/day:rtg-border-calendar-day-width-border-focus group-data-[focused=true]/day:rtg-border-calendar-day-color-border-focus",
			"group-data-[focused=true]/day:rtg-ring-calendar-day-width-ring-focus group-data-[focused=true]/day:rtg-ring-calendar-day-color-ring-focus"
		],
		outside: ["rtg-text-calendar-day-button-outside-color-text"],
		today: ["rtg-text-calendar-day-button-today-color-text", "rtg-bg-calendar-day-button-today-color-bg"]
	}
}, Nt = class extends e {
	constructor(...e) {
		super(...e), this.currentDate = /* @__PURE__ */ new Date(), this.selectedStartDate = null, this.selectedEndDate = null, this.mode = "single", this._userClass = "", this._userStyle = "";
	}
	getDaysInMonth(e, t) {
		return new Date(e, t + 1, 0).getDate();
	}
	previousMonth() {
		this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1);
	}
	nextMonth() {
		this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1);
	}
	selectDate(e, t) {
		if (!t) {
			let t = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), e);
			t.getMonth() === this.currentDate.getMonth() && (this.mode === "single" ? (this.selectedStartDate = t, this.selectedEndDate = null) : this.mode === "range" && (!this.selectedStartDate || this.selectedEndDate ? (this.selectedStartDate = t, this.selectedEndDate = null) : t >= this.selectedStartDate ? this.selectedEndDate = t : (this.selectedEndDate = this.selectedStartDate, this.selectedStartDate = t)), this.dispatchEvent(new CustomEvent("date-selected", {
				detail: {
					startDate: this.selectedStartDate,
					endDate: this.selectedEndDate
				},
				bubbles: !0,
				composed: !0
			})));
		}
	}
	isDayInRange(e, t) {
		return !this.selectedStartDate || !this.selectedEndDate || e.getMonth() !== this.currentDate.getMonth() ? !1 : t ? e > this.selectedStartDate && e < this.selectedEndDate : e >= this.selectedStartDate && e <= this.selectedEndDate;
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._userClass = this.getAttribute("class")?.replace(P(R.host), "") ?? "", this._userStyle = this.getAttribute("style") ?? "", this._userClass && this.removeAttribute("class"), this._userStyle && this.removeAttribute("style"), this.className = P(R.host);
	}
	firstUpdated(e) {
		let t = this.querySelector(".calendar");
		if (t && (this._userClass && (t.className = P("calendar", R.root, this._userClass)), this._userStyle)) {
			let e = t.getAttribute("style")?.trim(), n = this._userStyle.trim();
			t.setAttribute("style", [e, n].filter(Boolean).join("; "));
		}
	}
	render() {
		let e = this.currentDate.getFullYear(), t = this.currentDate.getMonth(), r = this.getDaysInMonth(e, t), i = new Date(e, t, 1).getDay(), a = new Date(e, t, 0).getDate(), o = [];
		for (let e = i - 1; e >= 0; e--) o.push({
			day: String(a - e),
			month: t - 1,
			isOutside: !0
		});
		for (let e = 1; e <= r; e++) o.push({
			day: String(e),
			month: t,
			isOutside: !1
		});
		let s = o.length % 7;
		if (s !== 0) {
			let e = 7 - s;
			for (let n = 1; n <= e; n++) o.push({
				day: String(n),
				month: t + 1,
				isOutside: !0
			});
		}
		let c = this.currentDate.toLocaleString("default", {
			month: "long",
			year: "numeric"
		}), l = this.currentDate.toLocaleString("default", {
			month: "long",
			year: "numeric"
		});
		return n`
      <div
        class=${P("calendar", R.root, this._userClass)}
        data-slot="calendar"
        data-mode=${this.mode}
        part="calendar"
        style=${this._userStyle}
      >
        <div class=${P("calendar-months", R.months)}>
          <nav class=${P("calendar-nav", R.nav)}>
            <button
              class=${P("calendar-button-previous", R.buttonPrevious)}
              aria-label="Go to the Previous Month"
              @click="${this.previousMonth}"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${P("calendar-chevron", R.chevron, "lucide lucide-chevron-left-icon lucide-chevron-left")}
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>

            <button
              class=${P("calendar-button-next", R.buttonNext)}
              aria-label="Go to the Next Month"
              @click="${this.nextMonth}"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${P("calendar-chevron", R.chevron, "lucide lucide-chevron-right-icon lucide-chevron-right")}
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
          </nav>

          <div class=${P("calendar-month", R.month)}>
            <div
              class=${P("calendar-month-caption", R.monthCaption)}
            >
              <span
                class=${P("calendar-caption-label", R.captionLabel)}
                role="status"
                aria-live="polite"
              >
                ${c}
              </span>
            </div>

            <table
              class=${P("calendar-month-grid", R.monthGrid)}
              role="grid"
              aria-label=${l}
              aria-multiselectable=${this.mode === "range" ? "true" : "false"}
            >
              <thead aria-hidden="true">
                <tr class=${P("calendar-weekdays", R.weekdays)}>
                  ${Et.map((e) => n`
                      <th
                        class=${P("calendar-weekday", R.weekday)}
                        scope="col"
                        aria-label=${e}
                      >
                        ${e.slice(0, 2)}
                      </th>
                    `)}
                </tr>
              </thead>

              <tbody class=${P("calendar-weeks", R.weeks)}>
                ${Array.from({ length: Math.ceil(o.length / 7) }, (e, t) => n`
                    <tr class=${P("calendar-week", R.week)}>
                      ${o.slice(t * 7, (t + 1) * 7).map((e, t) => {
			let r = new Date(this.currentDate.getFullYear(), e.month, Number(e.day)), i = r.toDateString() === (/* @__PURE__ */ new Date()).toDateString(), a = this.mode === "range" && r.toDateString() === this.selectedStartDate?.toDateString(), o = this.mode === "range" && this.isDayInRange(r, !0), s = this.mode === "range" && r.toDateString() === this.selectedEndDate?.toDateString(), c = this.mode === "single" && r.toDateString() === this.selectedStartDate?.toDateString(), l = c || a || o || s, u = t === 0, d = t === 6, f = i ? "Today, " : "";
			return f += Ot(r), f += l ? ", selected" : "", n`
                            <td
                              class=${P("calendar-day", R.day.base, i && !l && R.day.today, l && R.day.selected.common, c && R.day.selected.single, a && R.day.selected.range.start, o && R.day.selected.range.middle, s && R.day.selected.range.end, u && R.day.index.first, d && R.day.index.last, !1)}
                              role="gridcell"
                              data-day=${r.toISOString().slice(0, 10)}
                              ?data-disabled=${void 0}
                              ?data-focused=${void 0}
                              ?data-hidden=${void 0}
                              ?data-outside=${e.isOutside ? "true" : void 0}
                              ?data-today=${i ? "true" : void 0}
                              ?data-selected=${l ? "true" : void 0}
                              ?aria-disabled=${void 0}
                              ?aria-hidden=${void 0}
                              ?aria-selected=${l ? "true" : void 0}
                            >
                              <button
                                class=${P("calendar-day-button", R.dayButton.base, e.isOutside && R.dayButton.outside, i && R.dayButton.today)}
                                ?disabled=${void 0}
                                data-variant="ghost"
                                data-size="icon"
                                data-selected-single=${c.toString()}
                                data-range-start=${a.toString()}
                                data-range-middle=${o.toString()}
                                data-range-end=${s.toString()}
                                tabindex=${c || s ? "0" : "-1"}
                                type="button"
                                aria-label=${f}
                                @click="${() => this.selectDate(Number(e.day), e.isOutside)}"
                              >
                                ${e.day}
                              </button>
                            </td>
                          `;
		})}
                    </tr>
                  `)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    `;
	}
};
C([o({ type: Object }), S("design:type", typeof Date > "u" ? Object : Date)], Nt.prototype, "currentDate", void 0), C([o({ type: Object }), S("design:type", Object)], Nt.prototype, "selectedStartDate", void 0), C([o({ type: Object }), S("design:type", Object)], Nt.prototype, "selectedEndDate", void 0), C([o({ type: String }), S("design:type", Object)], Nt.prototype, "mode", void 0), Nt = C([a("rtg-calendar")], Nt);
//#endregion
//#region src/components/ui/card/_card.ts
var Pt = class extends e {
	constructor(...e) {
		super(...e), this.size = "default";
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"card\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card" data-size=${this.size}></div>`;
	}
};
C([o({ type: String }), S("design:type", Object)], Pt.prototype, "size", void 0), Pt = C([a("rtg-card")], Pt);
//#endregion
//#region src/components/ui/card/_card-header.ts
var Ft = class extends e {
	get _headerSlot() {
		return this.querySelector("[data-slot=\"card-header\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._headerSlot && this._headerSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div data-slot="card-header" ?data-border=${this.border}></div>
    `;
	}
};
C([o({ type: Boolean }), S("design:type", Boolean)], Ft.prototype, "border", void 0), Ft = C([a("rtg-card-header")], Ft);
//#endregion
//#region src/components/ui/card/_card-title.ts
var It = class extends e {
	get _titleSlot() {
		return this.querySelector("[data-slot=\"card-title\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._titleSlot && this._titleSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card-title"></div>`;
	}
};
It = C([a("rtg-card-title")], It);
//#endregion
//#region src/components/ui/card/_card-description.ts
var Lt = class extends e {
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"card-description\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._descriptionSlot && this._descriptionSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card-description"></div>`;
	}
};
Lt = C([a("rtg-card-description")], Lt);
//#endregion
//#region src/components/ui/card/_card-action.ts
var Rt = class extends e {
	get _actionSlot() {
		return this.querySelector("[data-slot=\"card-action\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._actionSlot && this._actionSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card-action"></div>`;
	}
};
Rt = C([a("rtg-card-action")], Rt);
//#endregion
//#region src/components/ui/card/_card-content.ts
var zt = class extends e {
	get _contentSlot() {
		return this.querySelector("[data-slot=\"card-content\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._contentSlot && this._contentSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card-content"></div>`;
	}
};
zt = C([a("rtg-card-content")], zt);
//#endregion
//#region src/components/ui/card/_card-footer.ts
var Bt = class extends e {
	get _footerSlot() {
		return this.querySelector("[data-slot=\"card-footer\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._footerSlot && this._footerSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div data-slot="card-footer" ?data-border=${this.border}></div>
    `;
	}
};
C([o({ type: Boolean }), S("design:type", Boolean)], Bt.prototype, "border", void 0), Bt = C([a("rtg-card-footer")], Bt);
//#endregion
//#region src/assets/icons/arrows.icon.ts
function Vt() {
	return i` <svg
  class="shrink-0 size-3.5 text-gray-500 dark:text-neutral-500"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="m7 15 5 5 5-5"></path>
  <path d="m7 9 5-5 5 5"></path>
</svg>
  `;
}
//#endregion
//#region src/assets/icons/carousel-arrow-left.ts
function Ht() {
	return i` 
   <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-arrow-left h-4 w-4"
    >   
        <path d="m12 19-7-7 7-7"></path>
        <path d="M19 12H5"></path>
    </svg>
  `;
}
//#endregion
//#region src/assets/icons/carousel-arrow-right.ts
function Ut() {
	return i` 
   <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-arrow-right h-4 w-4"
            >
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
        </svg>
  `;
}
//#endregion
//#region src/assets/icons/check.icon.ts
function Wt(e) {
	return n`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class=${P("lucide lucide-check-icon lucide-check", e ?? "")}
    >
      <path d="M20 6 9 17l-5-5"/>
    </svg>
  `;
}
//#endregion
//#region src/assets/icons/minus.icon.ts
function Gt(e) {
	return n`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class=${P("lucide lucide-minus-icon lucide-minus", e ?? "")}
    >
      <path d="M5 12h14"/>
    </svg>
  `;
}
//#endregion
//#region src/assets/icons/search.icon.ts
function Kt(e) {
	return n`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class=${P("lucide lucide-search-icon lucide-search", e ?? "")}
    >
      <path d="m21 21-4.34-4.34"/>
      <circle cx="11" cy="11" r="8"/>
    </svg>
  `;
}
//#endregion
//#region src/assets/icons/tick.icon.ts
function qt() {
	return i`
             <svg
                class="rtg-shrink-0 rtg-size-3.5 rtg-text-primary"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M20 6 9 17l-5-5"></path>
              </svg>
  `;
}
//#endregion
//#region src/components/ui/carousel/carousel.styles.ts
var z = {
	root: ["rtg-relative rtg-mx-carousel-space-mx rtg-h-carousel-space-h rtg-w-carousel-space-w"],
	viewport: ["rtg-w-carousel-viewport-space-w rtg-h-carousel-viewport-space-h rtg-overflow-hidden"],
	slidesWrapper: {
		base: ["rtg-flex rtg-transition-transform rtg-duration-carousel-motion-duration rtg-ease-carousel-motion-fn"],
		orientation: {
			horizontal: ["rtg-flex-row"],
			vertical: ["rtg-flex-col"]
		}
	},
	slide: {
		base: ["rtg-min-w-0 rtg-basis-full rtg-h-carousel-slide-space-h rtg-flex-shrink-0 rtg-flex-grow-0 rtg-transition-transform rtg-duration-carousel-motion-duration rtg-px-carousel-slide-space-px rtg-py-carousel-slide-space-py"],
		size: {
			true: ["lg:rtg-basis-1/3 lg:rtg-h-1/2 md:rtg-basis-1/2 md:rtg-h-1/2"],
			false: [""]
		}
	},
	controls: {
		base: ["rtg-absolute rtg-z-10 rtg-flex"],
		orientation: {
			horizontal: ["rtg-top-1/2 rtg-left-carousel-control-horizontal-space-left rtg-right-carousel-control-horizontal-space-right rtg-justify-between"],
			vertical: ["rtg-w-carousel-control-vertical-space-w rtg-h-carousel-control-vertical-space-h rtg-top-0 rtg-flex-col rtg-justify-between rtg-items-center"]
		}
	},
	controlButton: {
		base: ["rtg-bg-carousel-button-color-bg rtg-text-carousel-button-color-text rtg-border-none rtg-px-carousel-button-space-px rtg-py-carousel-button-space-py rtg-cursor-pointer rtg-z-10 rtg-rounded-carousel-button-radius rtg-w-carousel-button-space-w rtg-h-carousel-button-space-h rtg-flex rtg-items-center rtg-justify-center hover:rtg-bg-carousel-button-color-bg-hover disabled:rtg-opacity-carousel-button-opacity-disabled"],
		orientation: {
			verticalPrev: ["rtg-relative rtg-top-carousel-button-vertical-prev-space-top rtg-rotate-90"],
			verticalNext: ["rtg-relative rtg-top-carousel-button-vertical-next-space-top rtg-rotate-90"]
		}
	}
}, Jt = class extends e {
	constructor(...e) {
		super(...e), this.currentIndex = 0, this.items = [], this.orientation = "horizontal", this.size = !1, this.handleResize = () => {
			this.updateSlides(), this.currentIndex = 0, this.querySelectorAll(".slide").forEach((e) => {
				e.className = this.getSlideClasses();
			});
		};
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated() {
		this.restructureSlides();
	}
	restructureSlides() {
		let e = this.querySelector(".slides");
		if (e) for (let t = 0; t < this.items.length; t++) {
			let n = `slide-${t}`, r = this.querySelector(`[slot="${n}"]`);
			if (r && r.parentElement !== e) {
				let t = document.createElement("div");
				t.className = this.getSlideClasses(), e.appendChild(t), t.appendChild(r);
			}
		}
	}
	getSlideClasses() {
		return P(z.slide.base, this.size ? z.slide.size.true : z.slide.size.false);
	}
	nextSlide() {
		this.currentIndex < this.items.length - 1 && (this.currentIndex += 1, this.updateSlides());
	}
	prevSlide() {
		this.currentIndex > 0 && (--this.currentIndex, this.updateSlides());
	}
	updateSlides() {
		let e;
		e = this.size ? window.innerWidth >= 1024 ? 33.3333 : window.innerWidth >= 768 ? 50 : 100 : 100;
		let t = this.orientation === "vertical" ? 100 / this.items.length : 100;
		this.slides && (this.slides.style.transform = this.orientation === "horizontal" ? `translateX(-${this.currentIndex * e}%)` : `translateY(-${this.currentIndex * t}%)`);
	}
	connectedCallback() {
		super.connectedCallback(), window.addEventListener("resize", this.handleResize);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), window.removeEventListener("resize", this.handleResize);
	}
	render() {
		let e = this.currentIndex === 0, t = this.size ? window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1 : 1, r = this.currentIndex >= this.items.length - t, i = P(z.slidesWrapper.base, z.slidesWrapper.orientation[this.orientation]), a = P(z.controls.base, z.controls.orientation[this.orientation]), o = P(z.controlButton.base, this.orientation === "vertical" && z.controlButton.orientation.verticalPrev), s = P(z.controlButton.base, this.orientation === "vertical" && z.controlButton.orientation.verticalNext);
		return n`
      <div
        part="rtg-carousel"
        class="${P(z.root, this.className)}"
        size="${this.size}"
        orientation="${this.orientation}"
      >
        <div class="${P(z.viewport, this.className)}">
          <div class="slides ${i}"></div>

          <div class="${a}">
            <button
              @click="${this.prevSlide}"
              ?disabled="${e}"
              class="${o}"
            >
              ${Ht()}
            </button>

            <button
              @click="${this.nextSlide}"
              ?disabled="${r}"
              class="${s}"
            >
              ${Ut()}
            </button>
          </div>
        </div>
      </div>
    `;
	}
};
C([o({ type: Number }), S("design:type", Object)], Jt.prototype, "currentIndex", void 0), C([o({ type: Array }), S("design:type", Array)], Jt.prototype, "items", void 0), C([o({ type: String }), S("design:type", String)], Jt.prototype, "orientation", void 0), C([o({ type: Boolean }), S("design:type", Object)], Jt.prototype, "size", void 0), C([s(".slides"), S("design:type", typeof HTMLElement > "u" ? Object : HTMLElement)], Jt.prototype, "slides", void 0), Jt = C([a("rtg-carousel")], Jt);
//#endregion
//#region src/components/ui/checkbox/_checkbox.ts
var B = class extends e {
	constructor(...e) {
		super(...e), this.value = "on";
	}
	createRenderRoot() {
		return this;
	}
	_isControlled() {
		return this.checked !== void 0;
	}
	_getState() {
		return this._checked ? "checked" : "unchecked";
	}
	updated(e) {
		e.has("checked") && this._isControlled() && (this._checked = this.checked);
	}
	firstUpdated(e) {
		this._checked = this.defaultChecked || this.checked;
	}
	_handleClick() {
		if (this.disabled) return;
		let e = !this._checked;
		this._isControlled() || (this._checked = e), this.dispatchEvent(new CustomEvent("rtg-checkbox:checked-change", {
			detail: { checked: e },
			bubbles: !0,
			composed: !0
		})), this.onCheckedChange !== void 0 && this.onCheckedChange(e);
	}
	_renderIndicator() {
		return this._checked ? n`
      <span
        data-slot="checkbox-indicator"
        data-state=${this._getState()}
        ?data-disabled=${this.disabled}
      >
        ${Wt()}
      </span>
    ` : null;
	}
	_renderInput() {
		return this.name === void 0 ? null : n`
      <input
        data-slot="checkbox-input"
        type="checkbox"
        name=${this.name}
        value=${this.value}
        ?checked=${this._checked}
        tabindex="-1"
        ?disabled=${this.disabled}
        ?required=${this.required}
        aria-hidden="true"
      />
    `;
	}
	render() {
		return n`
      <button
        data-slot="checkbox"
        data-state=${this._getState()}
        ?data-disabled=${this.disabled}
        type="button"
        role="checkbox"
        ?disabled=${this.disabled}
        value=${this.value}
        aria-checked=${this._checked ? "true" : "false"}
        aria-required=${this.required ? "true" : r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        @click=${this._handleClick}
      >
        ${this._renderIndicator()}
      </button>

      ${this._renderInput()}
    `;
	}
};
C([o({
	attribute: "default-checked",
	type: Boolean
}), S("design:type", Boolean)], B.prototype, "defaultChecked", void 0), C([o({
	attribute: !0,
	type: Boolean
}), S("design:type", Boolean)], B.prototype, "checked", void 0), C([o({
	attribute: !1,
	type: Function
}), S("design:type", Function)], B.prototype, "onCheckedChange", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], B.prototype, "disabled", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], B.prototype, "required", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], B.prototype, "invalid", void 0), C([o({ type: String }), S("design:type", String)], B.prototype, "name", void 0), C([o({ type: String }), S("design:type", Object)], B.prototype, "value", void 0), C([c(), S("design:type", Boolean)], B.prototype, "_checked", void 0), B = C([a("rtg-checkbox")], B);
//#endregion
//#region src/components/ui/collapsible/collapsible-trigger.ts
var Yt = class extends w {
	getAttributesToExclude() {
		return [""];
	}
	get _containerElement() {
		return this.querySelector("div[part=collapsible-trigger]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	get _collapsible() {
		let e = this.parentElement;
		for (; e && !(e instanceof Zt);) e = e.parentElement;
		return e;
	}
	onTrigger() {
		let e = this._collapsible;
		e && (e.open = !e.open, this.dispatchEvent(new CustomEvent("click-collapsible-event", {
			bubbles: !0,
			composed: !0
		})));
	}
	render() {
		let e = this.getFilteredAttributes();
		return n`
      <div
        @click=${this.onTrigger}
        ${F(e)}
        part="collapsible-trigger"
      ></div>
    `;
	}
};
Yt = C([a("rtg-collapsible-trigger")], Yt);
//#endregion
//#region src/components/ui/collapsible/collapsible-content.ts
var Xt = class extends w {
	constructor(...e) {
		super(...e), this._toggleHandler = (e) => {
			let t = e;
			requestAnimationFrame(() => {
				let e = this._containerElement;
				e && (e.style.display = t.detail.open ? "block" : "none");
			});
		};
	}
	get _containerElement() {
		return this.querySelector("div[part=collapsible-content]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [""];
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("toggle-collapsible-content", this._toggleHandler);
	}
	disconnectedCallback() {
		this.removeEventListener("toggle-collapsible-content", this._toggleHandler), super.disconnectedCallback();
	}
	render() {
		return n`
      <div
        ${F(this.getFilteredAttributes())}
        class="${P("", this.className)}"
        style="display: none;--radix-collapsible-content-height: 100px; --radix-collapsible-content-width: 350px;"
        part="collapsible-content"
      ></div>
    `;
	}
};
Xt = C([a("rtg-collapsible-content")], Xt);
//#endregion
//#region src/components/ui/collapsible/collapsible.ts
var Zt = class extends w {
	constructor(...e) {
		super(...e), this.open = !1, this._clickHandler = () => {
			this.querySelector("rtg-collapsible-content")?.dispatchEvent(new CustomEvent("toggle-collapsible-content", { detail: { open: this.open } }));
		};
	}
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	get _containerElement() {
		return this.querySelector("div[part=collapsible]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("click-collapsible-event", this._clickHandler);
	}
	disconnectedCallback() {
		this.removeEventListener("click-collapsible-event", this._clickHandler), super.disconnectedCallback();
	}
	render() {
		return n`
      <div
        ${F(this.getFilteredAttributes())}
        class="${P("", this.className)}"
        part="collapsible"
      ></div>
    `;
	}
};
C([o({ type: Boolean }), S("design:type", Object)], Zt.prototype, "open", void 0), Zt = C([a("rtg-collapsible")], Zt);
//#endregion
//#region src/components/ui/combobox/combo-box.styles.ts
var Qt = {
	empty: [
		"rtg-py-combo-box-empty-space-py",
		"rtg-text-center",
		"rtg-text-combo-box-empty-font"
	],
	group: { base: [
		"rtg-pointer-events-none",
		"rtg-invisible",
		"rtg-absolute",
		"rtg-z-50",
		"rtg-mt-combo-box-group-space-mt",
		"rtg-max-h-combo-box-group-space-max-h",
		"rtg-w-combo-box-group-space-w",
		"rtg-origin-top",
		"rtg-scale-y-0",
		"rtg-transform",
		"rtg-overflow-hidden",
		"rtg-overflow-y-auto",
		"rtg-rounded-combo-box-group-radius",
		"rtg-border-combo-box-group-width-border",
		"rtg-border-combo-box-group-color-border",
		"rtg-bg-combo-box-group-color-bg",
		"rtg-px-combo-box-group-space-px",
		"rtg-py-combo-box-group-space-py",
		"rtg-opacity-0",
		"rtg-shadow-combo-box-group-shadow",
		"rtg-transition-opacity",
		"rtg-duration-combo-box-group-motion-duration",
		"rtg-ease-combo-box-group-motion-fn",
		"[&::-webkit-scrollbar]:rtg-w-0"
	] },
	input: [
		"rtg-flex",
		"rtg-h-combo-box-input-space-h",
		"rtg-w-combo-box-input-space-w",
		"rtg-rounded-combo-box-input-radius",
		"rtg-border-0",
		"rtg-bg-combo-box-input-color-bg",
		"rtg-px-combo-box-input-space-px",
		"rtg-py-combo-box-input-space-py",
		"rtg-text-combo-box-input-font",
		"rtg-text-combo-box-input-color-text",
		"rtg-shadow-none",
		"placeholder:rtg-text-combo-box-input-color-text-placeholder",
		"focus:rtg-outline-none",
		"focus-visible:rtg-ring-0"
	],
	trigger: { base: [
		"rtg-z-20",
		"rtg-flex",
		"rtg-h-combo-box-trigger-space-h",
		"rtg-flex-row-reverse",
		"rtg-items-center",
		"rtg-justify-between",
		"rtg-rounded-combo-box-trigger-radius",
		"rtg-border-combo-box-trigger-width-border",
		"rtg-border-combo-box-trigger-color-border",
		"rtg-bg-combo-box-trigger-color-bg",
		"rtg-px-combo-box-trigger-space-px",
		"rtg-py-combo-box-trigger-space-py",
		"rtg-text-combo-box-trigger-font",
		"focus:rtg-outline-none",
		"focus:rtg-ring-combo-box-trigger-width-ring-focus",
		"focus:rtg-ring-combo-box-trigger-color-ring-focus",
		"focus:rtg-ring-offset-combo-box-trigger-width-ring-offset-focus",
		"disabled:rtg-cursor-not-allowed",
		"disabled:rtg-opacity-combo-box-trigger-opacity-disabled"
	] },
	value: [
		"rtg-line-clamp-1",
		"rtg-flex",
		"rtg-w-combo-box-value-space-w"
	],
	item: { base: [
		"rtg-flex",
		"rtg-w-combo-box-item-space-w",
		"rtg-cursor-pointer",
		"rtg-flex-row-reverse",
		"rtg-items-center",
		"rtg-justify-between",
		"rtg-rounded-combo-box-item-radius",
		"rtg-px-combo-box-item-space-px",
		"rtg-py-combo-box-item-space-py",
		"hover:rtg-bg-accent",
		"focus:rtg-bg-combo-box-item-color-bg-hover",
		"focus:rtg-outline-none"
	] }
}, $t = class extends w {
	constructor(...e) {
		super(...e), this.handleClick = () => {
			this._comboBox && ([...document.getElementsByTagName("rtg-combo-box")].forEach((e) => {
				e.uuid !== this._comboBox?.uuid && (e.isOpen = !1);
			}), this._comboBox.isOpen = !this._comboBox.isOpen);
		};
	}
	get _comboBox() {
		let e = this.parentElement;
		for (; e && !(e instanceof H);) e = e.parentElement;
		return e;
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this.buttonElement), this.addEventListener("click", (e) => {
			e.stopPropagation();
		});
	}
	render() {
		return n`
      <button
        type="button"
        part="combo-box-trigger-button"
        role="tab"
        class="${P(Qt.trigger.base, this.className)}"
        tabindex="-1"
        data-orientation="horizontal"
        data-radix-collection-item=""
        @click=${this.handleClick}
      >
        ${Vt()}
      </button>
    `;
	}
};
C([s("button"), S("design:type", typeof HTMLButtonElement > "u" ? Object : HTMLButtonElement)], $t.prototype, "buttonElement", void 0), $t = C([a("rtg-combo-box-trigger")], $t);
//#endregion
//#region src/components/ui/combobox/combo-box-value.ts
var en = class extends e {
	constructor(...e) {
		super(...e), this.placeholder = "select a value", this.handleClick = () => {
			this._comboBox && ([...document.getElementsByTagName("rtg-combo-box")].forEach((e) => {
				e.uuid !== this._comboBox?.uuid && (e.isOpen = !1);
			}), this._comboBox.isOpen = !this._comboBox.isOpen);
		}, this.renderLabel = () => this._comboBox && this._comboBox.selectedValue.length > 0 ? this._comboBox.selectedValue : this.placeholder;
	}
	get _comboBox() {
		let e = this.parentElement;
		for (; e && !(e instanceof H);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("clicked-combo-box-item", () => {
			this.requestUpdate();
		});
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.addEventListener("click", (e) => {
			e.stopPropagation();
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <span
        part="combo-box-value"
        class="${P(Qt.value, this.className)}"
        @click=${this.handleClick}
        >${this.renderLabel()}</span
      >
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], en.prototype, "placeholder", void 0), en = C([a("rtg-combo-box-value")], en);
//#endregion
//#region src/components/ui/separator/_separator.ts
var tn = class extends e {
	constructor(...e) {
		super(...e), this.orientation = "horizontal";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        data-slot="separator"
        data-orientation=${this.orientation}
        role=${this.decorative ? "none" : "separator"}
        aria-orientation=${this.decorative ? r : this.orientation}
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], tn.prototype, "orientation", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], tn.prototype, "decorative", void 0), tn = C([a("rtg-separator")], tn);
//#endregion
//#region src/components/ui/combobox/combo-box-group.ts
var nn = class extends w {
	constructor(...e) {
		super(...e), this.searchKey = "", this.focusedIndex = 0, this.selectedValue = "", this.isOpen = !1, this.handleItemClicked = () => {
			this.requestUpdate();
		}, this.handleTriggerComboBox = (e) => {
			e.detail.isOpen !== this._comboBox?.isOpen && this.requestUpdate(), e.detail.isOpen && this._comboBox?.selectedValue && (this.focusedIndex = this.comboBoxItems.findIndex((e) => e.getAttribute("value") === this._comboBox?.selectedValue), this.requestUpdate());
		}, this.handleKeyDown = (e) => {
			if (!this._comboBox?.isOpen) return;
			e.preventDefault();
			let t = this.filteredItems;
			switch (e.key) {
				case "ArrowDown":
					if (t.length === 0) return;
					this.focusedIndex = (this.focusedIndex + 1) % t.length;
					break;
				case "ArrowUp":
					if (t.length === 0) return;
					this.focusedIndex = (this.focusedIndex - 1 + t.length) % t.length;
					break;
				case "Enter":
					if (this.focusedIndex >= 0 && this.focusedIndex < t.length) {
						let e = t[this.focusedIndex].getAttribute("value");
						this.dispatchEvent(new CustomEvent("clicked-combo-box-item", {
							bubbles: !0,
							composed: !0,
							detail: { selectedItem: e }
						}));
					}
					break;
			}
		}, this.handleMouseOver = (e, t) => {
			e.preventDefault(), this.focusedIndex = t;
		}, this.onSelectedValue = (e, t) => {
			this.focusedIndex = t, this.selectedValue = e;
		}, this.boundHandleComboBoxStateChanged = this.handleComboBoxStateChanged.bind(this), this.boundHandleKeyDown = this.handleKeyDown.bind(this);
	}
	get comboBoxItems() {
		return Array.from(this.querySelectorAll("[data-managed=\"true\"][tag=\"rtg-combo-box-item\"], rtg-combo-box-item")).filter((e) => e.hasAttribute("value"));
	}
	get comboBoxInput() {
		return this.querySelector("rtg-combo-box-input");
	}
	get comboBoxEmpty() {
		return this.querySelector("rtg-combo-box-empty");
	}
	get hasResults() {
		return !this.filteredItems.length;
	}
	get filteredItems() {
		let e = this.searchKey?.toLowerCase();
		return this.comboBoxItems.filter((t) => t.getAttribute("value")?.toLowerCase().includes(e));
	}
	get _comboBox() {
		let e = this.parentElement;
		for (; e && !(e instanceof H);) e = e.parentElement;
		return e;
	}
	handleComboBoxStateChanged(e) {
		let { isOpen: t, targetComboBoxId: n } = e.detail;
		if (this.isOpen = t, n !== this._comboBox?.uuid) return;
		let r = this.renderRoot.querySelector("[part=\"select-group\"]");
		r && (t ? (clearTimeout(r._hideTimeout), r.classList.remove("rtg-scale-y-0", "rtg-opacity-0"), r.classList.add("rtg-scale-y-100", "rtg-opacity-100"), r.classList.remove("rtg-invisible", "rtg-pointer-events-none"), r.classList.add("rtg-visible", "rtg-pointer-events-auto")) : (r.classList.remove("rtg-opacity-100"), r.classList.add("rtg-opacity-0"), r._hideTimeout = setTimeout(() => {
			r.classList.remove("rtg-visible", "rtg-pointer-events-auto", "rtg-scale-y-100"), r.classList.add("rtg-invisible", "rtg-pointer-events-none", "rtg-scale-y-0");
		}, 300)));
	}
	moveChildren() {
		let e = this.renderRoot.querySelector("[part=\"select-group\"]");
		if (!e) return;
		let t = {
			top: e.querySelector("#topSlot"),
			empty: e.querySelector("#emptySlot"),
			list: e.querySelector("#listSlot")
		}, n = {
			"rtg-combo-box-input": "top",
			"rtg-combo-box-empty": "empty",
			"rtg-combo-box-item": "list"
		};
		Array.from(this.children).forEach((e) => {
			let r = n[e.tagName.toLowerCase()];
			r && (e.setAttribute("data-managed", "true"), t[r]?.appendChild(e));
		});
	}
	renderFilteredItems() {
		return this.comboBoxItems.forEach((e) => e.setAttribute("hidden", "true")), this.filteredItems.map((e, t) => {
			let r = e.getAttribute("value") ?? "", i = t === this.focusedIndex, a = r.toLowerCase() === this._comboBox?.selectedValue.toLowerCase();
			return n`
        <rtg-combo-box-item
          @mouseover="${(e) => this.handleMouseOver(e, t)}"
          .value=${r}
          .selectItemIndex=${t}
          .isFocus=${i}
          .onSelect=${this.onSelectedValue}
          .isSelected=${a}
        >
          ${e.textContent}
        </rtg-combo-box-item>
      `;
		});
	}
	getAttributesToExclude() {
		return [];
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("rtg-combo-box-state-changed", this.boundHandleComboBoxStateChanged), document.addEventListener("clicked-combo-box-item", this.handleItemClicked), document.addEventListener("trigger-combo-box", this.handleTriggerComboBox);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), document.removeEventListener("clicked-combo-box-item", this.handleItemClicked), document.removeEventListener("trigger-combo-box", this.handleTriggerComboBox), document.removeEventListener("rtg-combo-box-state-changed", this.boundHandleComboBoxStateChanged), document.removeEventListener("keydown", this.boundHandleKeyDown);
	}
	firstUpdated(e) {
		this.moveChildren(), document.addEventListener("keydown", this.boundHandleKeyDown);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select-group"
        class="${P(Qt.group.base, this.className)}"
        data-hs-combo-box-output=""
        data-testId="select-group"
      >
        <rtg-separator
          id="topSlot"
          data-testid="horizontal-separator"
        ></rtg-separator>
        <div id="emptySlot" ?hidden=${!this.hasResults}></div>
        <div id="listSlot" ?hidden=${this.hasResults}>
          ${this.renderFilteredItems()}
        </div>
      </div>
    `;
	}
};
C([c(), S("design:type", Object)], nn.prototype, "searchKey", void 0), C([c(), S("design:type", Object)], nn.prototype, "focusedIndex", void 0), C([c(), S("design:type", Object)], nn.prototype, "selectedValue", void 0), C([c(), S("design:type", Boolean)], nn.prototype, "isOpen", void 0), nn = C([a("rtg-combo-box-group")], nn);
//#endregion
//#region src/components/ui/combobox/combo-box-item.ts
var V = class extends w {
	constructor(...e) {
		super(...e), this.value = "", this.key = "", this.tabindex = 0, this.isSelected = !1, this.isFocus = !1, this.class = "", this.selectItemIndex = -1, this.onSelect = (e, t) => {}, this.onMouseOver = (e, t) => {}, this.handleClick = (e) => {
			this.onSelect(this.value, this.selectItemIndex), e.stopPropagation();
			let t = new CustomEvent("clicked-combo-box-item", {
				bubbles: !0,
				composed: !0,
				detail: { selectedItem: this.value }
			});
			this.dispatchEvent(t);
		};
	}
	getAttributesToExclude() {
		return [
			"aria-orientation",
			"role",
			"data-orientation",
			"data-testid"
		];
	}
	connectedCallback() {
		super.connectedCallback();
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.itemDivContainer);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        ${F(this.getFilteredAttributes())}
        @click=${this.handleClick}
        class="${P(Qt.item.base, this.className)}"
        data-hs-combo-box-value=${this.value}
        aria-selected="${this.isSelected}"
        data-selected="${this.isSelected}"
        id="rtg-combo-box-item"
      >
        <span
          class="${this.isSelected ? "rtg-visible" : "rtg-invisible"} data-hs-combo-box-value rtg-mr-2"
        >
          ${qt()}
        </span>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], V.prototype, "value", void 0), C([o({ type: String }), S("design:type", Object)], V.prototype, "key", void 0), C([o({ type: Number }), S("design:type", Object)], V.prototype, "tabindex", void 0), C([o({ type: Boolean }), S("design:type", Object)], V.prototype, "isSelected", void 0), C([o({ type: Boolean }), S("design:type", Object)], V.prototype, "isFocus", void 0), C([o({ type: String }), S("design:type", Object)], V.prototype, "class", void 0), C([o({ type: Number }), S("design:type", Object)], V.prototype, "selectItemIndex", void 0), C([o({ type: Function }), S("design:type", Object)], V.prototype, "onSelect", void 0), C([o({ type: Function }), S("design:type", Object)], V.prototype, "onMouseOver", void 0), C([s("#rtg-combo-box-item"), S("design:type", typeof HTMLDivElement > "u" ? Object : HTMLDivElement)], V.prototype, "itemDivContainer", void 0), V = C([a("rtg-combo-box-item")], V);
//#endregion
//#region src/components/ui/combobox/combo-box-input.ts
var rn = class extends e {
	constructor(...e) {
		super(...e), this.placeholder = "Search Item ...", this.searchValue = "";
	}
	get _comboBoxGroup() {
		let e = this.parentElement;
		for (; e && !(e instanceof nn);) e = e.parentElement;
		return e;
	}
	handleSearch(e) {
		e.stopPropagation();
		let t = e.target;
		this.searchValue = t.value, this._comboBoxGroup && (this._comboBoxGroup.searchKey = this.searchValue);
	}
	handleKeyDown(e) {
		e.stopPropagation();
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div class="rtg-flex rtg-items-center rtg-px-2">
        ${Kt()}
        <input
          part="combo-box-input"
          type="text"
          class="${P(Qt.input, this.className)}"
          placeholder=${this.placeholder}
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
          aria-autocomplete="list"
          role="combobox"
          value=${this.searchValue}
          @input="${this.handleSearch}"
          @keydown="${this.handleKeyDown}"
        />
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], rn.prototype, "placeholder", void 0), C([c(), S("design:type", Object)], rn.prototype, "searchValue", void 0), rn = C([a("rtg-combo-box-input")], rn);
//#endregion
//#region src/components/ui/combobox/combo-box-empty.ts
var an = class extends w {
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.removeDuplicateContent();
	}
	render() {
		return n`
      <div
        class="${P(Qt.empty, this.className)}"
        role="presentation"
      >
        ${Array.from(this.childNodes)[0].textContent}
      </div>
    `;
	}
};
an = C([a("rtg-combo-box-empty")], an);
//#endregion
//#region src/components/ui/combobox/combo-box.ts
var H = class extends w {
	constructor() {
		super(), this.isOpen = !1, this.selectedValue = "", this.searchTerm = "", this.focusedIndex = -1, this.filteredItems = [], this.uuid = T(), this.label = "Select an item", this.items = [], this.handleClickOutside = (e) => {
			let t = this.renderRoot?.querySelector("[data-combo-box-uuid]"), n = e.target;
			if (!n.tagName.includes("RTG-COMBO") && !(n.shadowRoot && n.shadowRoot.innerHTML.includes(t?.innerHTML))) {
				if (this.isOpen && !t || !t?.contains(n)) this.isOpen = !1;
				else if (!n?.firstElementChild) return;
			}
		};
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("clicked-combo-box-item", (e) => {
			this.isOpen && (this.selectedValue = e.detail.selectedItem, this.isOpen = !1, this.requestUpdate());
		});
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.parentDiveElement), this.items && this.items.length > 0 && (this.filteredItems = this.items.filter((e) => e.toLowerCase().includes(this.searchTerm)));
	}
	updated(e) {
		super.updated(e), e.has("isOpen") && (this.dispatchEvent(new CustomEvent("rtg-combo-box-state-changed", {
			detail: {
				isOpen: this.isOpen,
				targetComboBoxId: this.uuid
			},
			bubbles: !0,
			composed: !0
		})), this.isOpen ? document.addEventListener("mousedown", this.handleClickOutside) : document.removeEventListener("mousedown", this.handleClickOutside));
	}
	disconnectedCallback() {
		document.removeEventListener("mousedown", this.handleClickOutside), super.disconnectedCallback();
	}
	selectItem(e) {
		let t = e.target;
		if (t instanceof HTMLElement) {
			let e = t.closest("rtg-combo-box-item");
			e ? (this.selectedValue = e.getAttribute("data-hs-combo-box-value") || "", this.isOpen = !1) : console.log("No valid rtg-combo-box-item found");
		} else console.log("Event target is not an HTMLElement");
	}
	render() {
		return n`
      <div
        class="${P("rtg-relative", this.className)}"
        data-hs-combo-box=""
        data-combo-box-uuid=${this.uuid}
        part="combo-box"
      ></div>
    `;
	}
};
C([o({ type: Boolean }), S("design:type", Object)], H.prototype, "isOpen", void 0), C([c(), S("design:type", Object)], H.prototype, "selectedValue", void 0), C([c(), S("design:type", Object)], H.prototype, "searchTerm", void 0), C([c(), S("design:type", Object)], H.prototype, "focusedIndex", void 0), C([c(), S("design:type", Array)], H.prototype, "filteredItems", void 0), C([c(), S("design:type", Object)], H.prototype, "uuid", void 0), C([o({ type: String }), S("design:type", String)], H.prototype, "label", void 0), C([o({ type: Array }), S("design:type", Object)], H.prototype, "items", void 0), C([s("[part=\"combo-box\"]"), S("design:type", typeof HTMLDivElement > "u" ? Object : HTMLDivElement)], H.prototype, "parentDiveElement", void 0), H = C([a("rtg-combo-box"), S("design:paramtypes", [])], H);
//#endregion
//#region src/components/ui/command/command.styles.ts
var on = {
	root: [
		"rtg-flex rtg-overflow-hidden",
		"rtg-flex-col",
		"rtg-w-command-space-w rtg-h-command-space-h",
		"rtg-text-command-color-text",
		"rtg-bg-command-color-bg",
		"rtg-rounded-command-radius"
	],
	input: {
		wrapper: [
			"rtg-flex",
			"rtg-gap-command-input-wrapper-space-gap rtg-items-center",
			"rtg-px-command-input-wrapper-space-px",
			"rtg-h-command-input-wrapper-space-h",
			"rtg-border-b-command-input-wrapper-width-border rtg-border-b-command-input-wrapper-color-border"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-command-input-icon-space-size",
			"rtg-opacity-command-input-icon-opacity"
		],
		input: [
			"rtg-flex",
			"rtg-py-command-input-space-py",
			"rtg-w-command-input-space-w rtg-h-command-input-space-h",
			"rtg-text-command-input-font",
			"rtg-bg-command-input-color-bg",
			"rtg-rounded-command-input-radius rtg-outline-hidden",
			"focus:rtg-outline-none",
			"disabled:rtg-opacity-command-input-opacity-disabled disabled:rtg-cursor-not-allowed",
			"placeholder:rtg-text-command-input-placeholder-color-text"
		]
	},
	list: [
		"rtg-overflow-x-hidden rtg-overflow-y-auto",
		"rtg-max-h-command-list-space-max-h",
		"rtg-scroll-py-1"
	],
	empty: ["rtg-py-command-empty-space-py", "rtg-text-command-empty-font rtg-text-center"],
	group: [
		"rtg-overflow-hidden",
		"rtg-p-command-group-space-p",
		"rtg-text-command-group-color-text"
	],
	heading: ["rtg-px-command-heading-space-px rtg-py-command-heading-space-py", "rtg-text-command-heading-font rtg-font-command-heading-font-weight rtg-text-command-heading-color-text"],
	separator: [
		"rtg-command-separator-space-mx",
		"rtg-h-command-separator-space-h",
		"rtg-bg-command-separator-color-bg"
	],
	item: [
		"rtg-flex rtg-relative",
		"rtg-gap-command-item-space-gap rtg-items-center",
		"rtg-px-command-item-space-px rtg-py-command-item-space-py",
		"rtg-text-command-item-font",
		"rtg-rounded-command-item-radius rtg-outline-hidden",
		"rtg-cursor-default rtg-select-none",
		"hover:rtg-text-command-item-color-text-hover hover:rtg-bg-command-item-color-bg-hover",
		"aria-selected:rtg-text-command-item-color-text-selected aria-selected:rtg-bg-command-item-color-bg-selected",
		"data-[disabled=\"true\"]:rtg-opacity-command-item-opacity-disabled data-[disabled=\"true\"]:rtg-pointer-events-none",
		"[&_svg]:rtg-shrink-0 [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-command-item-icon-space-size [&_svg:not([class*=\"rtg-text-\"])]:rtg-text-command-item-icon-color-text [&_svg]:rtg-pointer-events-none"
	],
	shortcut: ["rtg-ml-auto", "rtg-text-command-shortcut-font rtg-text-command-shortcut-color-text"]
}, sn, cn = class extends w {
	static {
		sn = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "true";
	}
	static {
		this._counter = 0;
	}
	get containerElement() {
		return this.querySelector(`#${this.identifier}`);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement;
		return e ? this._id = `${e.getAttribute("id")}e${sn._counter++}` : this._id = `rtgcmdrxlxe${sn._counter++}`, this._id;
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-empty
        id="${this.identifier}"
        part="command-empty"
        role="presentation"
        class=${P(on.empty, this._hidden === "true" && "rtg-hidden", this.className)}
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], cn.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], cn.prototype, "_hidden", void 0), cn = sn = C([a("rtg-command-empty")], cn);
//#endregion
//#region src/components/ui/command/command-group.atom.ts
var ln, un = class extends w {
	static {
		ln = this;
	}
	constructor(...e) {
		super(...e), this.heading = "", this._id = "", this._hidden = "";
	}
	static {
		this._counter = 0;
	}
	get itemsContainerElement() {
		return this.querySelector(`#${this.identifier}g`);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement;
		return e ? this._id = `${e.getAttribute("id")}g${ln._counter++}` : this._id = `rtgcmdrxlxg${ln._counter++}`, this._id;
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		let t = this.itemsContainerElement;
		if (t) {
			for (; t.firstChild;) t.removeChild(t.firstChild);
			this.moveLightDomChildrenInto(t);
		}
	}
	render() {
		return n`
      <div
        rtgcmd-group
        id="${this.identifier}"
        part="command-group"
        role="presentation"
        class=${P(on.group, this._hidden === "true" && "rtg-hidden", this.className)}
      >
        <div
          rtgcmd-group-heading
          aria-hidden="true"
          id="${this.identifier}h"
          class=${P(on.heading)}
        >
          ${this.heading}
        </div>
        <div
          rtgcmd-group-items
          id="${this.identifier}g"
          role="group"
          aria-labelledby="${this.identifier}h"
        ></div>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], un.prototype, "heading", void 0), C([o({
	attribute: "id",
	type: String
}), S("design:type", Object)], un.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], un.prototype, "_hidden", void 0), un = ln = C([a("rtg-command-group")], un);
//#endregion
//#region src/components/ui/command/command-input.atom.ts
var dn = class extends e {
	constructor(...e) {
		super(...e), this.placeholder = "Type a command or search...", this._value = "";
	}
	get identifier() {
		let e = this.parentElement;
		return e ? `${e.getAttribute("id")}i` : "rtgcmdrxi";
	}
	filterItems() {
		let e = this.parentElement;
		if (e) {
			let t = !0, n = e.querySelectorAll("rtg-command-group");
			n && n.forEach((e) => {
				let n = !0, r = e.querySelectorAll("rtg-command-item");
				r && r.forEach((e) => {
					(e.value || "").toLowerCase().includes(this._value.toLowerCase()) ? (n = !1, t = !1, e._hidden = "false") : e._hidden = "true";
				}), e._hidden = n ? "true" : "false";
				let i = e.previousElementSibling;
				i && (i._hidden = n || i.previousElementSibling?.getAttribute("aria-hidden") === "true" ? "true" : "false"), i = e.nextElementSibling, i && (i._hidden = n || i.nextElementSibling?.getAttribute("aria-hidden") === "true" ? "true" : "false");
			});
			let r = e.querySelector("rtg-command-empty");
			r && r.setAttribute("aria-hidden", t ? "false" : "true");
		}
	}
	handleChange(e) {
		let t = e.target;
		t && (this._value = t.value, this.filterItems());
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="command-input"
        class=${P(on.input.wrapper, this.className)}
        name="rtgcmd-input-container"
        data-slot="rtg-command-input-wrapper"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class=${P(on.input.icon, "lucide lucide-search-icon lucide-search")}
        >
          <path d="m21 21-4.34-4.34" />
          <circle cx="11" cy="11" r="8" />
        </svg>

        <input
          rtgcmd-input
          id="${this.identifier}"
          type="text"
          role="combobox"
          placeholder="${this.placeholder}"
          data-value="${this._value}"
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
          aria-autocomplete="list"
          aria-expanded="true"
          aria-controls=":r1oe:"
          aria-labelledby=":r1of:"
          @input="${this.handleChange}"
          class=${P(on.input.input)}
        />
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], dn.prototype, "placeholder", void 0), C([o({
	attribute: "value",
	type: String
}), S("design:type", Object)], dn.prototype, "_value", void 0), dn = C([a("rtg-command-input")], dn);
//#endregion
//#region src/components/ui/command/command-item.atom.ts
var fn, pn = class extends w {
	static {
		fn = this;
	}
	constructor(...e) {
		super(...e), this.selected = !1, this._id = "", this._hidden = "false", this.onSelect = () => {}, this.disabled = "false";
	}
	static {
		this._counter = 0;
	}
	get containerElement() {
		return this.querySelector(`#${this.identifier}`);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement;
		return e ? this._id = `${e.getAttribute("id")}li${fn._counter++}` : this._id = `rtgcmdrxgxli${fn._counter++}`, this._id;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.containerElement);
	}
	updated(e) {}
	render() {
		return n`
      <div
        rtgcmd-item
        id="${this.identifier}"
        part="command-item"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        aria-selected="${this.selected}"
        aria-hidden="${this._hidden}"
        data-disabled=${this.disabled}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        @click="${this.onSelect}"
        class=${P(on.item, this._hidden === "true" && "rtg-hidden", this.className)}
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], pn.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], pn.prototype, "_hidden", void 0), C([o({ type: Function }), S("design:type", Object)], pn.prototype, "onSelect", void 0), C([
	o({
		attribute: "data-value",
		type: String
	}),
	o({ type: Boolean }),
	S("design:type", Object),
	S("design:paramtypes", [])
], pn.prototype, "containerElement", null), C([o({
	attribute: "data-disabled",
	type: String
}), S("design:type", String)], pn.prototype, "disabled", void 0), pn = fn = C([a("rtg-command-item")], pn);
//#endregion
//#region src/components/ui/command/command-list.atom.ts
var mn = class extends w {
	get identifier() {
		let e = this.parentElement;
		return e ? `${e.getAttribute("id")}l` : "rtgcmdrxl";
	}
	get containerElement() {
		return this.querySelector("div[rtgcmd-list]");
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-list
        id="${this.identifier}"
        part="command-list"
        role="listbox"
        class=${P(on.list, this.className)}
      >
        <div></div>
      </div>
    `;
	}
};
mn = C([a("rtg-command-list")], mn);
//#endregion
//#region src/components/ui/command/command-separator.atom.ts
var hn, gn = class extends e {
	static {
		hn = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "";
	}
	static {
		this._counter = 0;
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement;
		return e ? this._id = `${e.getAttribute("id")}s${hn._counter++}` : this._id = `rtgcmdrxlxs${hn._counter++}`, this._id;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`${this._hidden === "true" ? r : n`
          <div
            rtgcmd-separator
            id="${this.identifier}"
            part="command-separator"
            role="separator"
            class=${P(on.separator, this.className)}
          ></div>
        `}`;
	}
};
C([o({ type: String }), S("design:type", Object)], gn.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], gn.prototype, "_hidden", void 0), gn = hn = C([a("rtg-command-separator")], gn);
//#endregion
//#region src/components/ui/command/command.ts
var _n = class extends w {
	get containerElement() {
		return this.querySelector("div[rtgcmd-root]");
	}
	getAttributesToExclude() {
		return [];
	}
	getAttributesToRemoveFromParent() {
		return ["class", "style"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.removeParentAttributes(), this.moveLightDomChildrenInto(this.containerElement), this.containerElement && this.observeStyleAndClassSync(this.containerElement);
	}
	render() {
		let e = this.customClass || "", t = this.customStyle || "";
		return n`
      <div
        part="command"
        class="${P(on.root, e)}"
        style="${t}"
        id="rtgcmdr1"
        rtgcmd-root
      ></div>
    `;
	}
};
_n = C([a("rtg-command")], _n);
//#endregion
//#region src/components/ui/context-menu/context-menu.styles.ts
var U = {
	root: [""],
	trigger: [""],
	content: [
		"rtg-overflow-x-hidden rtg-overflow-y-auto rtg-z-50",
		"rtg-p-context-menu-content-space-p",
		"rtg-min-w-context-menu-content-space-min-w",
		"rtg-text-context-menu-content-color-text",
		"rtg-bg-context-menu-content-color-bg",
		"rtg-rounded-context-menu-content-radius rtg-border-context-menu-content-width-border rtg-border-context-menu-content-color-border",
		"rtg-shadow-context-menu-content-shadow",
		"rtg-translate-y-0.5",
		"rtg-slide-in-from-top-2",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
	],
	group: [""],
	item: [
		"rtg-flex rtg-relative",
		"rtg-gap-context-menu-item-space-gap rtg-items-center",
		"rtg-px-context-menu-item-space-px rtg-py-context-menu-item-space-py",
		"rtg-text-context-menu-item-font",
		"rtg-rounded-context-menu-item-radius rtg-outline-hidden",
		"rtg-cursor-default",
		"rtg-select-none",
		"hover:rtg-bg-context-menu-item-color-bg-hover hover:rtg-text-context-menu-item-color-text-hover",
		"focus:rtg-bg-context-menu-item-color-bg-focus focus:rtg-text-context-menu-item-color-text-focus",
		"data-[disabled]:rtg-opacity-context-menu-item-opacity-disabled data-[disabled]:rtg-pointer-events-none",
		"[&_svg]:rtg-shrink-0 [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-context-menu-item-icon-space-size [&_svg:not([class*=\"rtg-text-\"])]:rtg-text-context-menu-item-icon-color-text [&_svg]:rtg-pointer-events-none"
	],
	checkboxItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-context-menu-checkbox-item-space-gap rtg-items-center",
			"rtg-pl-context-menu-checkbox-item-space-pl rtg-pr-context-menu-checkbox-item-space-pr rtg-py-context-menu-checkbox-item-space-py",
			"rtg-text-context-menu-checkbox-item-font",
			"rtg-rounded-context-menu-checkbox-item-radius rtg-outline-hidden",
			"rtg-cursor-default",
			"rtg-select-none",
			"aria-selected:rtg-bg-context-menu-checkbox-item-color-bg-focus aria-selected:rtg-text-context-menu-checkbox-item-color-text-focus",
			"data-[disabled]:rtg-opacity-context-menu-checkbox-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		span: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-context-menu-checkbox-item-icon-container-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-context-menu-checkbox-item-icon-space-size",
			"rtg-pointer-events-none"
		]
	},
	radioItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-context-menu-radio-item-space-gap rtg-items-center",
			"rtg-pl-context-menu-radio-item-space-pl rtg-pr-context-menu-radio-item-space-pr rtg-py-context-menu-radio-item-space-py",
			"rtg-text-context-menu-radio-item-font",
			"rtg-rounded-context-menu-radio-item-radius rtg-outline-hidden",
			"rtg-cursor-default",
			"rtg-select-none",
			"aria-selected:rtg-bg-context-menu-radio-item-color-bg-focus aria-selected:rtg-text-context-menu-radio-item-color-text-focus",
			"data-[disabled]:rtg-opacity-context-menu-radio-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		span: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-context-menu-radio-item-icon-container-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-context-menu-radio-item-icon-space-size",
			"rtg-pointer-events-none",
			"rtg-fill-current"
		]
	},
	label: ["rtg-px-context-menu-label-space-px rtg-py-context-menu-label-space-py", "rtg-text-context-menu-label-font rtg-font-context-menu-label-font-weight"],
	separator: [
		"rtg-mx-context-menu-separator-space-mx rtg-my-context-menu-separator-space-my",
		"rtg-h-context-menu-separator-space-h",
		"rtg-bg-context-menu-separator-color-bg"
	],
	shortcut: ["rtg-ml-auto", "rtg-text-context-menu-shortcut-font rtg-text-context-menu-shortcut-color-text"]
}, vn = class extends w {
	constructor(...e) {
		super(...e), this._id = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu-checkbox-item-container]");
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked = !this.checked;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-item
        part="context-menu-checkbox"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        aria-selected="${this.selected}"
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        class=${P(U.checkboxItem.base, this.className)}
      >
        <span class=${P(U.checkboxItem.span)}>
          ${this.checked ? n`
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${P(U.checkboxItem.icon, "lucide lucide-check-icon lucide-check")}
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              ` : r}
        </span>
        <div part="context-menu-checkbox-item-container"></div>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], vn.prototype, "_id", void 0), C([
	o({
		attribute: "data-value",
		type: String
	}),
	S("design:type", Object),
	S("design:paramtypes", [])
], vn.prototype, "value", null), C([o({ type: Boolean }), S("design:type", Object)], vn.prototype, "selected", void 0), C([o({ type: Boolean }), S("design:type", Object)], vn.prototype, "checked", void 0), C([o({
	attribute: "data-disabled",
	type: Boolean
}), S("design:type", Object)], vn.prototype, "disabled", void 0), vn = C([a("rtg-context-menu-checkbox-item")], vn);
//#endregion
//#region src/components/ui/context-menu/context-menu-content.ts
var yn = class extends w {
	constructor() {
		super(), this.isOpen = !1, this.handleClickOutside = this.handleClickOutside.bind(this);
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu-content");
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("click", this.handleClickOutside), super.disconnectedCallback();
	}
	handleClickOutside(e) {
		let t = this?.querySelector("button");
		!this.contains(e.target) && !t?.contains(e.target) && requestAnimationFrame(() => {
			this._containerElement.style.display = "none", this._containerElement.style.position = "absolute", this._containerElement.dataset.state = "closed", this.isOpen = !1;
		});
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="context-menu-content"
        class=${P(U.content, this.className)}
      ></div>
    `;
	}
};
C([c(), S("design:type", Object)], yn.prototype, "isOpen", void 0), yn = C([a("rtg-context-menu-content"), S("design:paramtypes", [])], yn);
//#endregion
//#region src/components/ui/context-menu/context-menu-group.ts
var bn = class extends w {
	constructor(...e) {
		super(...e), this.heading = "";
	}
	get _containerElement() {
		return this.querySelector("div[  rtgcontext-group-items]");
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-group
        part="context-menu-group"
        role="presentation"
        class=${P(U.group, this.className)}
      >
        <div rtgcmd-group-heading class=${P(U.label)}>
          ${this.heading}
        </div>

        <div rtgcontext-group-items role="group"></div>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], bn.prototype, "heading", void 0), bn = C([a("rtg-context-menu-group")], bn);
//#endregion
//#region src/components/ui/context-menu/context-menu-item.ts
var xn = class extends w {
	constructor(...e) {
		super(...e), this.disabled = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu-item]");
	}
	getAttributesToExclude() {
		return [];
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement), this._containerElement?.addEventListener("click", () => {
			this.dispatchEvent(new MouseEvent("click", {
				bubbles: !0,
				composed: !0,
				cancelable: !0
			})), this.dispatchEvent(new CustomEvent("close-context-menu", {
				bubbles: !0,
				composed: !0
			}));
		});
	}
	connectedCallback() {
		super.connectedCallback();
	}
	disconnectedCallback() {}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="context-menu-item"
        role="option"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        class=${P(U.item, this.className)}
      ></div>
    `;
	}
};
C([
	o({
		attribute: "data-value",
		type: String
	}),
	S("design:type", Object),
	S("design:paramtypes", [])
], xn.prototype, "value", null), C([o({
	attribute: "data-disabled",
	type: Boolean
}), S("design:type", Object)], xn.prototype, "disabled", void 0), xn = C([a("rtg-context-menu-item")], xn);
//#endregion
//#region src/components/ui/context-menu/context-menu-radio-item.ts
var Sn = class extends w {
	constructor(...e) {
		super(...e), this._id = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu-radio-item-container]");
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked || (this.checked = !0, this.dispatchEvent(new CustomEvent("radio-selected", {
			bubbles: !0,
			composed: !0
		})));
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-item
        part="context-menu-radio"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        aria-selected="${this.selected}"
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        class=${P(U.radioItem.base, this.className)}
      >
        <span class=${P(U.radioItem.span)}>
          ${this.checked ? n`<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${P(U.radioItem.icon, "lucide lucide-circle-icon lucide-circle")}
              >
                <circle cx="12" cy="12" r="10" />
              </svg>` : r}
        </span>
        <div part="context-menu-radio-item-container"></div>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Sn.prototype, "_id", void 0), C([
	o({
		attribute: "data-value",
		type: String
	}),
	S("design:type", Object),
	S("design:paramtypes", [])
], Sn.prototype, "value", null), C([o({ type: Boolean }), S("design:type", Object)], Sn.prototype, "selected", void 0), C([o({ type: Boolean }), S("design:type", Object)], Sn.prototype, "checked", void 0), C([o({
	attribute: "data-disabled",
	type: Boolean
}), S("design:type", Object)], Sn.prototype, "disabled", void 0), Sn = C([a("rtg-context-menu-radio-item")], Sn);
//#endregion
//#region src/components/ui/context-menu/context-menu-seperator.ts
var Cn = class extends e {
	constructor(...e) {
		super(...e), this._id = "";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        rtgcmd-separator
        part="context-menu-separator"
        role="separator"
        class=${P(U.separator, this.className)}
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Cn.prototype, "_id", void 0), Cn = C([a("rtg-context-menu-separator")], Cn);
//#endregion
//#region src/components/ui/context-menu/context-menu-shortcut.ts
var wn = class extends w {
	get _containerElement() {
		return this.querySelector("span[part=context-menu-shortcut]");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this.classList = P(U.shortcut), this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <span
        part="context-menu-shortcut"
        class=${P(U.shortcut, this.className)}
      >
      </span>
    `;
	}
};
wn = C([a("rtg-context-menu-shortcut")], wn);
//#endregion
//#region src/components/ui/context-menu/context-menu-trigger.ts
var Tn = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n``;
	}
};
Tn = C([a("rtg-context-menu-trigger")], Tn);
//#endregion
//#region src/components/ui/context-menu/context-menu.ts
var En = class extends w {
	constructor(...e) {
		super(...e), this.isOpen = !1, this.handleClickOutside = (e) => {
			let t = e.target;
			this?.contains(t) || (this.isOpen = !1);
		};
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu]");
	}
	get _triggerElement() {
		return this.querySelector("rtg-context-menu-trigger");
	}
	get _content() {
		return this?.querySelector("div[part=context-menu-content]");
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside), this.addEventListener("radio-selected", this._handleRadioSelected), this.addEventListener("close-context-menu", () => {
			this.isOpen = !1, requestAnimationFrame(() => {
				let e = this._content;
				e && (e.style.display = "none");
			});
		});
	}
	disconnectedCallback() {
		document.removeEventListener("click", this.handleClickOutside), super.disconnectedCallback();
	}
	toggleDropdown(e) {
		e.preventDefault(), e.stopPropagation();
		let { clientX: t, clientY: n } = e, r = e.target.getBoundingClientRect();
		requestAnimationFrame(() => {
			let e = this._content;
			e && (e.style.display = "", e.style.position = "absolute", e.style.left = `${t - r.left}px`, e.style.top = `${n - r.top}px`, e.dataset.state = "open", this.isOpen = !0);
		});
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "closed");
	}
	_handleRadioSelected(e) {
		this.querySelectorAll("rtg-context-menu-radio-item").forEach((t) => {
			t !== e.target && (t.checked = !1);
		});
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement), this._triggerElement?.addEventListener("contextmenu", (e) => {
			this.toggleDropdown(e);
		}), this.style.position = "relative";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="context-menu"
        class=${P(U.root, this.className)}
      ></div>
    `;
	}
};
C([c(), S("design:type", Object)], En.prototype, "isOpen", void 0), En = C([a("rtg-context-menu")], En);
//#endregion
//#region src/components/ui/popover/popover.style.ts
var Dn = {
	root: ["rtg-relative"],
	trigger: [""],
	content: [
		"rtg-absolute rtg-z-50",
		"rtg-p-popover-content-space-p",
		"rtg-w-popover-content-space-w",
		"rtg-text-popover-content-color-text",
		"rtg-bg-popover-content-color-bg",
		"rtg-rounded-popover-content-radius rtg-border-popover-content-width-border rtg-border-popover-content-color-border rtg-outline-hidden",
		"rtg-shadow-popover-content-shadow",
		"data-[state=\"open\"]:rtg-block data-[state=\"closed\"]:rtg-hidden",
		"data-[state=\"open\"]:rtg-animate-in data-[state=\"open\"]:rtg-fade-in-0 data-[state=\"open\"]:rtg-zoom-in-95",
		"data-[state=\"closed\"]:rtg-animate-out data-[state=\"closed\"]:rtg-fade-out-0 data-[state=\"closed\"]:rtg-zoom-out-95",
		"rtg-translate-y-0.5"
	]
}, On = class extends w {
	constructor(...e) {
		super(...e), this.enableDefaultStyle = !0, this.styleContent = !0, this.side = "bottom", this.state = "closed";
	}
	get _popover() {
		let e = this.parentElement;
		for (; e && !(e instanceof An);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=popover-content]");
	}
	handleClickOutside(e) {
		let t = this._popover;
		t && !t.contains(e.target) && (t.isOpen = !1);
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement), window.addEventListener("click", this.handleClickOutside.bind(this));
	}
	updated(e) {
		this._popover?.isOpen || window.removeEventListener("click", this.handleClickOutside.bind(this));
	}
	preventClickPropagation(e) {
		e.stopPropagation();
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="popover-content"
        data-state=${this.state}
        class=${P(Dn.content, this.className)}
        @click="${this.preventClickPropagation}"
      ></div>
    `;
	}
};
C([o({ type: Boolean }), S("design:type", Object)], On.prototype, "enableDefaultStyle", void 0), C([o({ type: Boolean }), S("design:type", Object)], On.prototype, "styleContent", void 0), C([o({ type: String }), S("design:type", String)], On.prototype, "side", void 0), C([o({
	attribute: "data-state",
	type: String
}), S("design:type", String)], On.prototype, "state", void 0), On = C([a("rtg-popover-content")], On);
//#endregion
//#region src/components/ui/popover/popover-trigger.ts
var kn = class extends w {
	constructor(...e) {
		super(...e), this.handleClick = () => {
			let e = this._popover;
			e && (e.isOpen = !e.isOpen);
		};
	}
	get _popover() {
		let e = this.parentElement;
		for (; e && !(e instanceof An);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=popover-trigger]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this.addEventListener("click", (e) => {
			this.handleClick(), e.stopPropagation();
		});
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	render() {
		return n`
      <div
        part="popover-trigger"
        class=${P(Dn.trigger, this.className)}
      ></div>
    `;
	}
};
kn = C([a("rtg-popover-trigger")], kn);
//#endregion
//#region src/components/ui/popover/popover.ts
var An = class extends w {
	constructor(...e) {
		super(...e), this.isOpen = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=popover]");
	}
	get _contentElement() {
		return this.querySelector("rtg-popover-content");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		this._contentElement.state = this.isOpen ? "open" : "closed", this._contentElement.requestUpdate();
	}
	render() {
		return n`
      <div part="popover" class=${P(Dn.root, this.className)}></div>
    `;
	}
};
C([c(), S("design:type", Boolean)], An.prototype, "isOpen", void 0), An = C([a("rtg-popover")], An);
//#endregion
//#region src/components/ui/date-picker/date-picker.styles.ts
var jn = {
	root: [""],
	trigger: [""],
	triggerButton: [
		Mt({ variant: "outline" }).replace("rtg-justify-center", ""),
		"rtg-justify-start",
		"rtg-w-date-picker-trigger-button-space-w",
		"rtg-text-left rtg-font-date-picker-trigger-button-font-weight",
		"data-[empty=true]:rtg-text-date-picker-trigger-button-color-text-empty"
	],
	content: ["rtg-p-date-picker-content-space-p", "rtg-w-auto"]
}, Mn = class extends e {
	constructor(...e) {
		super(...e), this.selectedDate = null;
	}
	handleDateSelected(e) {
		this.selectedDate = e.detail.startDate, this.requestUpdate();
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <rtg-popover
        class=${P("date-picker", jn.root, this.className)}
        @date-selected=${this.handleDateSelected}
      >
        <rtg-popover-trigger
          as-child
          class=${P("date-picker-trigger", jn.trigger)}
        >
          <button
            data-variant="outline"
            data-size="default"
            data-empty=${this.selectedDate ? "false" : "true"}
            class=${P("date-picker-trigger-button", jn.triggerButton)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-calendar-icon lucide-calendar"
            >
              <path d="M8 2v4" />
              <path d="M16 2v4" />
              <rect width="18" height="18" x="3" y="4" rx="2" />
              <path d="M3 10h18" />
            </svg>

            ${this.selectedDate ? this.selectedDate.toLocaleDateString("en-US", {
			month: "long",
			day: "numeric",
			year: "numeric"
		}).replace(/(\d+)/, (e, t) => {
			let n = parseInt(t, 10);
			return n + (n > 3 ? "th" : [
				"st",
				"nd",
				"rd"
			][n - 1] || "th");
		}) : n`<span>Pick a date</span>`}
          </button>
        </rtg-popover-trigger>

        <rtg-popover-content
          class=${P("date-picker-content", jn.content)}
        >
          <rtg-calendar mode="single"></rtg-calendar>
        </rtg-popover-content>
      </rtg-popover>
    `;
	}
};
C([o({ type: Object }), S("design:type", Object)], Mn.prototype, "selectedDate", void 0), Mn = C([a("rtg-date-picker")], Mn);
//#endregion
//#region src/components/ui/dialog/dialog.styles.ts
var Nn = {
	root: [""],
	trigger: [""],
	close: [""],
	overlay: [
		"rtg-fixed rtg-inset-0 rtg-z-50",
		"rtg-bg-dialog-overlay-color-bg",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0"
	],
	content: {
		base: [
			"rtg-fixed rtg-top-[50%] rtg-left-[50%] rtg-z-50",
			"rtg-grid rtg-gap-dialog-content-space-gap",
			"rtg-p-dialog-content-space-p",
			"rtg-w-dialog-content-space-w rtg-max-w-dialog-content-space-max-w-sm sm:rtg-max-w-dialog-content-space-max-w",
			"rtg-bg-dialog-content-color-bg",
			"rtg-rounded-dialog-content-radius rtg-border-dialog-content-width-border rtg-border-dialog-content-color-border rtg-outline-none",
			"rtg-shadow-dialog-content-shadow",
			"rtg-duration-200",
			"rtg-translate-x-[-50%] rtg-translate-y-[-50%]",
			"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
			"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
		],
		close: {
			base: [
				"rtg-absolute rtg-top-4 rtg-right-4",
				"rtg-rounded-dialog-close-radius",
				"rtg-ring-offset-dialog-close-color-ring-offset",
				"rtg-transition-opacity",
				"focus:rtg-ring-dialog-close-width-ring-focus focus:rtg-ring-dialog-close-color-ring-focus focus:rtg-ring-offset-dialog-close-width-ring-offset focus:rtg-outline-hidden",
				"disabled:rtg-pointer-events-none",
				"data-[state=open]:rtg-bg-dialog-close-color-bg data-[state=open]:rtg-text-dialog-close-color-text"
			],
			icon: [
				"rtg-shrink-0",
				"rtg-size-dialog-close-icon-space-size",
				"rtg-pointer-events-none"
			]
		}
	},
	header: [
		"rtg-flex rtg-flex-col rtg-gap-dialog-header-space-gap",
		"rtg-text-center",
		"sm:rtg-text-left"
	],
	footer: ["rtg-flex rtg-flex-col-reverse rtg-gap-dialog-footer-space-gap", "sm:rtg-flex-row sm:rtg-justify-end"],
	title: ["rtg-text-dialog-title-font rtg-font-dialog-title-font-weight"],
	description: ["rtg-text-dialog-description-font rtg-font-dialog-description-font-weight rtg-text-dialog-description-color-text"]
}, Pn = "closed", Fn = class extends w {
	get _dialog() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof Gn) return e;
			e = e.parentElement;
		}
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=dialog-close]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this.addEventListener("click", () => {
			let e = this._dialog;
			e && (e.dataset.state = Pn);
		});
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dialog-close"
        class=${P(Nn.close, this.className)}
      ></div>
    `;
	}
};
Fn = C([a("rtg-dialog-close")], Fn);
//#endregion
//#region src/components/ui/dialog/dialog-content.ts
var In = "closed", Ln = class extends w {
	constructor(...e) {
		super(...e), this.state = In, this.showCloseButton = !1, this.handleCloseButtonClick = () => {
			let e = this._dialog;
			e && (e.dataset.state = In);
		};
	}
	get _containerElement() {
		return this.querySelector("div[part=dialog-content-slot]");
	}
	get ـcomponentElement() {
		return this.querySelector("div[part=dialog-content]");
	}
	get _dialog() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof Gn) return e;
			e = e.parentElement;
		}
		return e;
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		requestAnimationFrame(() => {
			e.get("state") === In ? this.ـcomponentElement.style.display = "grid" : this.ـcomponentElement.style.display = "none";
		});
	}
	render() {
		return n`
      <div
        rtgdlg-content
        part="dialog-content"
        class=${P(Nn.content.base, this.className)}
      >
        <div part="dialog-content-slot"></div>

        ${this.showCloseButton ? n`
              <button
                data-slot="dialog-content-close"
                type="button"
                @click=${this.handleCloseButtonClick}
                class=${P(Nn.content.close.base)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${P(Nn.content.close.icon, "lucide lucide-x-icon lucide-x")}
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>

                <span class="rtg-sr-only">Close</span>
              </button>
            ` : ""}
      </div>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], Ln.prototype, "state", void 0), C([o({
	attribute: "show-close-button",
	type: Boolean
}), S("design:type", Object)], Ln.prototype, "showCloseButton", void 0), Ln = C([a("rtg-dialog-content")], Ln);
//#endregion
//#region src/components/ui/dialog/dialog-footer.ts
var Rn = class extends w {
	get _containerElement() {
		return this.querySelector("div[part=dialog-footer]");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="dialog-footer"
        class=${P(Nn.footer, this.className)}
      ></div>
    `;
	}
};
Rn = C([a("rtg-dialog-footer")], Rn);
//#endregion
//#region src/components/ui/dialog/dialog-header.ts
var zn = class extends e {
	constructor(...e) {
		super(...e), this._title = "", this.description = "";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dialog-header"
        class=${P(Nn.header, this.className)}
      >
        <h2 class=${P(Nn.title, this.className)}>${this._title}</h2>

        <p class=${P(Nn.description, this.className)}>
          ${this.description}
        </p>
      </div>
    `;
	}
};
C([o({
	attribute: "title",
	type: String
}), S("design:type", Object)], zn.prototype, "_title", void 0), C([o({ type: String }), S("design:type", Object)], zn.prototype, "description", void 0), zn = C([a("rtg-dialog-header")], zn);
//#endregion
//#region src/components/ui/dialog/dialog-overly.ts
var Bn = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dialog-overly"
        class=${P(Nn.overlay, this.className)}
      ></div>
    `;
	}
};
Bn = C([a("rtg-dialog-overlay")], Bn);
//#endregion
//#region src/components/ui/dialog/dialog-trigger.ts
var Vn = "open", Hn = class extends w {
	constructor(...e) {
		super(...e), this.handleClick = () => {
			let e = this._dialog;
			e && (e.dataset.state = Vn);
		};
	}
	get _dialog() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof Gn) return e;
			e = e.parentElement;
		}
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=dialog-trigger]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this.addEventListener("click", (e) => {
			e.stopPropagation(), this.handleClick();
		});
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dialog-trigger"
        class=${P(Nn.trigger, this.className)}
      ></div>
    `;
	}
};
Hn = C([a("rtg-dialog-trigger")], Hn);
//#endregion
//#region src/components/ui/dialog/dialog.ts
var Un = "open", Wn = "closed", Gn = class extends w {
	constructor(...e) {
		super(...e), this.state = Wn;
	}
	get _containerElement() {
		return this.querySelector("div[rtgdlg-root]");
	}
	get _content() {
		return this.querySelector("rtg-dialog-content") || null;
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.state);
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	render() {
		return n`
      <div
        rtgdlg-root
        part="dialog"
        class=${P(Nn.root, this.className)}
      >
        ${this.state === Un ? n` <rtg-dialog-overlay></rtg-dialog-overlay>` : r}
      </div>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], Gn.prototype, "state", void 0), Gn = C([a("rtg-dialog")], Gn);
//#endregion
//#region src/components/ui/drawer/drawer.helpers.ts
var Kn = {
	open: "open",
	closed: "closed"
}, qn = {
	root: [""],
	trigger: [""],
	close: [""],
	overlay: [
		"rtg-fixed rtg-inset-0 rtg-z-50",
		"rtg-bg-drawer-overlay-color-bg",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0"
	],
	content: {
		base: [
			"rtg-fixed rtg-inset-x-0 rtg-bottom-0 rtg-z-50",
			"rtg-flex rtg-flex-col",
			"rtg-mt-drawer-content-space-mt",
			"rtg-h-auto rtg-max-h-[80vh]",
			"rtg-bg-drawer-content-color-bg",
			"rtg-rounded-t-drawer-content-radius rtg-border-t-drawer-content-width-border rtg-border-t-drawer-content-color-border"
		],
		thumb: [
			"rtg-shrink-0",
			"rtg-mx-auto rtg-mt-drawer-thumb-space-mt",
			"rtg-w-drawer-thumb-space-w rtg-h-drawer-thumb-space-h",
			"rtg-bg-drawer-thumb-color-bg",
			"rtg-rounded-drawer-thumb-radius"
		]
	},
	header: [
		"rtg-flex rtg-flex-col rtg-gap-drawer-header-space-gap-sm md:rtg-gap-drawer-header-space-gap",
		"rtg-p-drawer-header-space-p",
		"rtg-text-center"
	],
	footer: ["rtg-flex rtg-flex-col rtg-gap-drawer-footer-space-gap", "rtg-p-drawer-footer-space-p rtg-mt-auto"],
	title: ["rtg-text-drawer-title-font rtg-font-drawer-title-font-weight rtg-text-drawer-title-color-text"],
	description: ["rtg-text-drawer-description-font rtg-font-drawer-description-font-weight rtg-text-drawer-description-color-text"]
}, Jn = class extends w {
	get _drawer() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof nr) return e;
			e = e.parentElement;
		}
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=drawer-close]");
	}
	async firstUpdated(e) {
		super.firstUpdated(e), await this.updateComplete;
		let t = this._containerElement;
		if (t) {
			this.moveLightDomChildrenInto(t);
			let e = t.querySelector("button, [data-close], [role=button]");
			e && e.addEventListener("click", (e) => {
				e.stopPropagation();
				let t = this._drawer;
				t && (t.dataset.state = Kn.closed);
			});
		}
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="drawer-close"
        class=${P(qn.close, this.className)}
      ></div>
    `;
	}
};
Jn = C([a("rtg-drawer-close")], Jn);
//#endregion
//#region src/components/ui/drawer/drawer-content.ts
var Yn = class extends w {
	constructor(...e) {
		super(...e), this.state = Kn.closed;
	}
	connectedCallback() {
		super.connectedCallback();
		let e = document.createElement("style");
		e.textContent = "\n      @keyframes slideInUp {\n        from { transform: translateY(100%); }\n        to { transform: translateY(0); }\n      }\n      @keyframes slideOutDown {\n        from { transform: translateY(0); }\n        to { transform: translateY(100%); }\n      }\n      .drawer-animation {\n        touch-action: none;\n        will-change: transform;\n        transition: transform 0.5s cubic-bezier(0.32, 0.72, 0, 1);\n      }\n      .drawer-open {\n        animation: slideInUp 0.5s cubic-bezier(0.32, 0.72, 0, 1) forwards;\n      }\n      .drawer-closed {\n        animation: slideOutDown 0.5s cubic-bezier(0.32, 0.72, 0, 1) forwards;\n      }\n    ", this.querySelector("style[data-injected]") || (e.setAttribute("data-injected", "true"), this.prepend(e));
	}
	get _containerElement() {
		return this.querySelector("div[part=drawer-content-slot]");
	}
	get ـcomponentElement() {
		return this.querySelector("div[part=drawer-content]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		requestAnimationFrame(() => {
			e.get("state") === Kn.closed ? this.ـcomponentElement.style.display = "flex" : this.ـcomponentElement.style.display = "none";
		});
	}
	render() {
		return n`
      <div
        rtgdlg-content
        part="drawer-content"
        class=${P(qn.content.base, this.state === Kn.open ? "drawer-open" : "drawer-closed", this.className)}
      >
        <div part="drawer-thumb" class=${P(qn.content.thumb)}></div>
        <div part="drawer-content-slot"></div>
      </div>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], Yn.prototype, "state", void 0), Yn = C([a("rtg-drawer-content")], Yn);
//#endregion
//#region src/components/ui/drawer/drawer-description.ts
var Xn = class extends w {
	get _containerElement() {
		return this.querySelector("p[part=drawer-description");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <p
        part="drawer-description"
        class=${P(qn.description, this.className)}
      ></p>
    `;
	}
};
Xn = C([a("rtg-drawer-description")], Xn);
//#endregion
//#region src/components/ui/drawer/drawer-footer.ts
var Zn = class extends w {
	get _containerElement() {
		return this.querySelector("div[part=drawer-footer]");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="drawer-footer"
        class=${P(qn.footer, this.className)}
      ></div>
    `;
	}
};
Zn = C([a("rtg-drawer-footer")], Zn);
//#endregion
//#region src/components/ui/drawer/drawer-header.ts
var Qn = class extends w {
	get _containerElement() {
		return this.querySelector("div[part=drawer-header");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="drawer-header"
        class=${P(qn.header, this.className)}
      ></div>
    `;
	}
};
Qn = C([a("rtg-drawer-header")], Qn);
//#endregion
//#region src/components/ui/drawer/drawer-overlay.ts
var $n = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="drawer-overly"
        class=${P(qn.overlay, this.className)}
      ></div>
    `;
	}
};
$n = C([a("rtg-drawer-overlay")], $n);
//#endregion
//#region src/components/ui/drawer/drawer-title.ts
var er = class extends w {
	get _containerElement() {
		return this.querySelector("h2[part=drawer-title");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <h2
        part="drawer-title"
        class=${P(qn.title, this.className)}
      ></h2>
    `;
	}
};
er = C([a("rtg-drawer-title")], er);
//#endregion
//#region src/components/ui/drawer/drawer-trigger.ts
var tr = class extends w {
	constructor(...e) {
		super(...e), this.handleClick = () => {
			let e = this._drawer;
			e && (e.dataset.state = Kn.open);
		};
	}
	get _drawer() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof nr) return e;
			e = e.parentElement;
		}
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=drawer-trigger]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this.addEventListener("click", (e) => {
			e.stopPropagation(), this.handleClick();
		});
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="drawer-trigger"
        class=${P(qn.trigger, this.className)}
      ></div>
    `;
	}
};
tr = C([a("rtg-drawer-trigger")], tr);
//#endregion
//#region src/components/ui/drawer/drawer.ts
var nr = class extends w {
	constructor(...e) {
		super(...e), this.state = Kn.closed, this.handleOutsideClick = (e) => {
			let t = this._content;
			this.state === Kn.open && t && (t.contains(e.target) || (this.state = Kn.closed, this.dispatchEvent(new CustomEvent("drawer-close"))));
		};
	}
	get _containerElement() {
		return this.querySelector("div[rtgdlg-root]");
	}
	get _content() {
		return this.querySelector("rtg-drawer-content") || null;
	}
	connectedCallback() {
		super.connectedCallback(), this.setupOutsideClickHandler();
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeOutsideClickHandler();
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.state), e.has("state") && this.setupOutsideClickHandler();
	}
	setupOutsideClickHandler() {
		this.state === Kn.open ? document.addEventListener("click", this.handleOutsideClick) : this.removeOutsideClickHandler();
	}
	removeOutsideClickHandler() {
		document.removeEventListener("click", this.handleOutsideClick);
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	render() {
		return n`
      <div
        rtgdlg-root
        part="drawer"
        class=${P(qn.root, this.className)}
      >
        ${this.state === Kn.open ? n` <rtg-drawer-overlay></rtg-drawer-overlay>` : r}
      </div>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], nr.prototype, "state", void 0), nr = C([a("rtg-drawer")], nr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu.styles.ts
var W = {
	root: ["rtg-relative"],
	trigger: [""],
	content: [
		"rtg-overflow-x-hidden rtg-overflow-y-auto rtg-z-50 rtg-absolute",
		"rtg-p-dropdown-menu-content-space-p",
		"rtg-min-w-dropdown-menu-content-space-min-w",
		"rtg-text-dropdown-menu-content-color-text",
		"rtg-bg-dropdown-menu-content-color-bg",
		"rtg-rounded-dropdown-menu-content-radius rtg-border-dropdown-menu-content-width-border rtg-border-dropdown-menu-content-color-border",
		"rtg-shadow-dropdown-menu-content-shadow",
		"rtg-translate-y-0.5",
		"rtg-slide-in-from-top-2",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
	],
	group: [""],
	item: [
		"rtg-flex rtg-relative",
		"rtg-gap-dropdown-menu-item-space-gap rtg-items-center",
		"rtg-px-dropdown-menu-item-space-px rtg-py-dropdown-menu-item-space-py",
		"rtg-text-dropdown-menu-item-font",
		"rtg-rounded-dropdown-menu-item-radius rtg-outline-hidden",
		"rtg-cursor-default",
		"rtg-select-none",
		"hover:rtg-bg-dropdown-menu-item-color-bg-hover hover:rtg-text-dropdown-menu-item-color-text-hover",
		"focus:rtg-bg-dropdown-menu-item-color-bg-focus focus:rtg-text-dropdown-menu-item-color-text-focus",
		"data-[disabled]:rtg-opacity-dropdown-menu-item-opacity-disabled data-[disabled]:rtg-pointer-events-none",
		"[&_svg]:rtg-shrink-0 [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-dropdown-menu-item-icon-space-size [&_svg:not([class*=\"rtg-text-\"])]:rtg-text-dropdown-menu-item-icon-color-text [&_svg]:rtg-pointer-events-none"
	],
	checkboxItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-dropdown-menu-checkbox-item-space-gap rtg-items-center",
			"rtg-pl-dropdown-menu-checkbox-item-space-pl rtg-pr-dropdown-menu-checkbox-item-space-pr rtg-py-dropdown-menu-checkbox-item-space-py",
			"rtg-text-dropdown-menu-checkbox-item-font",
			"rtg-rounded-dropdown-menu-checkbox-item-radius rtg-outline-hidden",
			"rtg-cursor-default",
			"rtg-select-none",
			"aria-selected:rtg-bg-dropdown-menu-checkbox-item-color-bg-focus aria-selected:rtg-text-dropdown-menu-checkbox-item-color-text-focus",
			"data-[disabled]:rtg-opacity-dropdown-menu-checkbox-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		span: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-dropdown-menu-checkbox-item-icon-container-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-dropdown-menu-checkbox-item-icon-space-size",
			"rtg-pointer-events-none"
		]
	},
	radioItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-dropdown-menu-radio-item-space-gap rtg-items-center",
			"rtg-pl-dropdown-menu-radio-item-space-pl rtg-pr-dropdown-menu-radio-item-space-pr rtg-py-dropdown-menu-radio-item-space-py",
			"rtg-text-dropdown-menu-radio-item-font",
			"rtg-rounded-dropdown-menu-radio-item-radius rtg-outline-hidden",
			"rtg-cursor-default",
			"rtg-select-none",
			"aria-selected:rtg-bg-dropdown-menu-radio-item-color-bg-focus aria-selected:rtg-text-dropdown-menu-radio-item-color-text-focus",
			"data-[disabled]:rtg-opacity-dropdown-menu-radio-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		span: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-dropdown-menu-radio-item-icon-container-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-dropdown-menu-radio-item-icon-space-size",
			"rtg-pointer-events-none",
			"rtg-fill-current"
		]
	},
	label: ["rtg-px-dropdown-menu-label-space-px rtg-py-dropdown-menu-label-space-py", "rtg-text-dropdown-menu-label-font rtg-font-dropdown-menu-label-font-weight"],
	separator: [
		"rtg-mx-dropdown-menu-separator-space-mx rtg-my-dropdown-menu-separator-space-my",
		"rtg-h-dropdown-menu-separator-space-h",
		"rtg-bg-dropdown-menu-separator-color-bg"
	],
	shortcut: ["rtg-ml-auto", "rtg-text-dropdown-menu-shortcut-font rtg-text-dropdown-menu-shortcut-color-text"]
}, rr = class extends w {
	constructor(...e) {
		super(...e), this._id = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-checkbox-item-container]");
	}
	get _dropdownMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof fr);) e = e.parentElement;
		return e;
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this._dropdownMenu.isOpen = !1, this.checked = !this.checked;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-item
        part="dropdown-menu-item"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        aria-checked="${this.checked}"
        aria-selected="${this.selected}"
        aria-hidden="${this.hidden}"
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        class=${P(W.checkboxItem.base, this.className)}
      >
        <span class=${P(W.checkboxItem.span)}>
          ${this.checked ? n`
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${P(W.checkboxItem.icon, "lucide lucide-check-icon lucide-check")}
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              ` : r}
        </span>
        <div part="dropdown-menu-checkbox-item-container"></div>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], rr.prototype, "_id", void 0), C([
	o({
		attribute: "data-value",
		type: String
	}),
	S("design:type", Object),
	S("design:paramtypes", [])
], rr.prototype, "value", null), C([o({ type: Boolean }), S("design:type", Object)], rr.prototype, "selected", void 0), C([o({ type: Boolean }), S("design:type", Object)], rr.prototype, "checked", void 0), C([o({
	attribute: "data-disabled",
	type: Boolean
}), S("design:type", Object)], rr.prototype, "disabled", void 0), rr = C([a("rtg-dropdown-menu-checkbox-item")], rr);
//#endregion
//#region src/components/ui/popover/popover.types.ts
var ir = "closed", ar = class extends w {
	constructor() {
		super(), this.state = ir, this.isOpen = !1, this.handleWindowChange = this.handleWindowChange.bind(this);
	}
	get _dropdownMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof fr);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-content]");
	}
	connectedCallback() {
		super.connectedCallback(), window.addEventListener("resize", this.handleWindowChange), window.addEventListener("scroll", this.handleWindowChange, !0);
	}
	disconnectedCallback() {
		window.removeEventListener("resize", this.handleWindowChange), window.removeEventListener("scroll", this.handleWindowChange, !0), super.disconnectedCallback();
	}
	handleWindowChange() {
		this.isOpen && requestAnimationFrame(() => this.positionContent());
	}
	updated(e) {
		super.updated(e), this.state === "open" ? (this.isOpen = !0, requestAnimationFrame(() => this.positionContent())) : this.isOpen = !1;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	positionContent() {
		let e = this._dropdownMenu, t = this._containerElement, n = e?._triggerElement;
		if (!e || !t || !n || !this.isOpen) return;
		let r = document.documentElement.clientWidth, i = document.documentElement.clientHeight, a = e.getBoundingClientRect(), o = n.getBoundingClientRect();
		t.style.position = "absolute", t.style.minWidth = `${Math.max(o.width, t.offsetWidth)}px`, t.style.maxWidth = `${Math.min(t.offsetWidth, r - 16)}px`;
		let s = t.getBoundingClientRect(), c = r - o.left >= s.width + 8, l = o.right >= s.width + 8, u = i - o.bottom >= s.height + 8, d = o.top >= s.height + 8;
		c || !l && u ? (t.style.left = `${o.left - a.left}px`, t.style.right = "auto") : (t.style.left = "auto", t.style.right = `${a.right - o.right}px`), u || !d && c ? (t.style.top = `${o.bottom - a.top}px`, t.style.bottom = "auto") : (t.style.top = "auto", t.style.bottom = `${a.bottom - o.top}px`), requestAnimationFrame(() => {
			let e = t.getBoundingClientRect();
			if (e.right > r - 8) {
				let n = e.right - (r - 8), i = parseFloat(t.style.left || "0");
				Number.isNaN(i) || (t.style.left = `${Math.max(0, i - n)}px`);
			}
			if (e.left < 8) {
				let n = 8 - e.left, r = parseFloat(t.style.left || "0");
				Number.isNaN(r) || (t.style.left = `${Math.max(0, r + n)}px`);
			}
			if (e.bottom > i - 8) {
				let n = e.bottom - (i - 8), r = parseFloat(t.style.bottom || "0");
				Number.isNaN(r) || (t.style.bottom = `${Math.max(0, r + n)}px`);
			}
			if (e.top < 8) {
				let n = 8 - e.top, r = parseFloat(t.style.top || "0");
				Number.isNaN(r) || (t.style.top = `${Math.max(0, r + n)}px`);
			}
		});
	}
	render() {
		return n`
      <div
        data-slot="dropdown-menu-content"
        part="dropdown-menu-content"
        style="display: ${this.isOpen ? "block" : "none"};"
        class=${P(W.content, this.className)}
      ></div>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], ar.prototype, "state", void 0), C([c(), S("design:type", Object)], ar.prototype, "isOpen", void 0), ar = C([a("rtg-dropdown-menu-content"), S("design:paramtypes", [])], ar);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-group.ts
var or = class extends w {
	constructor(...e) {
		super(...e), this.heading = "", this._id = "", this._hidden = "";
	}
	get _containerElement() {
		return this.querySelector("div[rtgcmd-group-items]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`${this._hidden === "true" ? r : n`
          <div
            rtgcmd-group
            part="dropdown-menu-group"
            role="presentation"
            class=${P(W.group, this.className)}
          >
            <div rtgcmd-group-heading class=${P(W.label)}>
              ${this.heading}
            </div>

            <div rtgcmd-group-items role="group"></div>
          </div>
        `}`;
	}
};
C([o({ type: String }), S("design:type", Object)], or.prototype, "heading", void 0), C([o({
	attribute: "id",
	type: String
}), S("design:type", Object)], or.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], or.prototype, "_hidden", void 0), or = C([a("rtg-dropdown-menu-group")], or);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-item.ts
var sr = class extends w {
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.selected = !1, this.disabled = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-item]");
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _dropdownMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof fr);) e = e.parentElement;
		return e;
	}
	handleMouseEvent(e) {
		console.log(e, this.value), (e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	handleClickDefault() {
		this._dropdownMenu.isOpen = !1;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n` ${this._hidden === "true" ? r : n`
          <div
            rtgcmd-item
            part="dropdown-menu-item"
            role="option"
            data-selected="${this.selected}"
            data-value="${this.value}"
            ?data-disabled=${this.disabled}
            aria-selected="${this.selected}"
            aria-hidden="${this.hidden}"
            @mouseover="${this.handleMouseEvent}"
            @mouseleave="${this.handleMouseEvent}"
            @focus="${this.handleMouseEvent}"
            @click="${this.handleClickDefault}"
            class=${P(W.item, this.className)}
          ></div>
        `}`;
	}
};
C([o({ type: String }), S("design:type", Object)], sr.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], sr.prototype, "_hidden", void 0), C([
	o({
		attribute: "data-value",
		type: String
	}),
	S("design:type", Object),
	S("design:paramtypes", [])
], sr.prototype, "value", null), C([o({ type: Boolean }), S("design:type", Object)], sr.prototype, "selected", void 0), C([o({
	attribute: "data-disabled",
	type: Boolean
}), S("design:type", Object)], sr.prototype, "disabled", void 0), sr = C([a("rtg-dropdown-menu-item")], sr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-radio-item.ts
var cr = class extends w {
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-radio-item-container]");
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked || (this.checked = !0, this.dispatchEvent(new CustomEvent("radio-selected", {
			bubbles: !0,
			composed: !0
		})));
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-item
        part="dropdown-menu-radio"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        aria-selected="${this.selected}"
        aria-checked="${this.checked}"
        aria-hidden="${this.hidden}"
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        class=${P(W.radioItem.base, this.className)}
      >
        <span class=${P(W.radioItem.span)}>
          ${this.checked ? n`<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${P(W.radioItem.icon, "lucide lucide-circle-icon lucide-circle")}
              >
                <circle cx="12" cy="12" r="10" />
              </svg>` : r}
        </span>
        <div part="dropdown-menu-radio-item-container"></div>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], cr.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], cr.prototype, "_hidden", void 0), C([
	o({
		attribute: "data-value",
		type: String
	}),
	S("design:type", Object),
	S("design:paramtypes", [])
], cr.prototype, "value", null), C([o({ type: Boolean }), S("design:type", Object)], cr.prototype, "selected", void 0), C([o({ type: Boolean }), S("design:type", Object)], cr.prototype, "checked", void 0), C([o({
	attribute: "data-disabled",
	type: Boolean
}), S("design:type", Object)], cr.prototype, "disabled", void 0), cr = C([a("rtg-dropdown-menu-radio-item")], cr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-seperator.ts
var lr = class extends w {
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-seperator]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`<div
      rtgcmd-separator
      part="dropdown-menu-seperator"
      role="separator"
      class=${P(W.separator, this.className)}
    ></div>`;
	}
};
lr = C([a("rtg-dropdown-menu-separator")], lr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-shortcut.ts
var ur = class extends w {
	get _containerElement() {
		return this.querySelector("span[part=dropdown-menu-shortcut]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this.classList = P(W.shortcut), this;
	}
	render() {
		return n`
      <span
        part="dropdown-menu-shortcut"
        class=${P(W.shortcut, this.className)}
      >
      </span>
    `;
	}
};
ur = C([a("rtg-dropdown-menu-shortcut")], ur);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-trigger.ts
var dr = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n``;
	}
};
dr = C([a("rtg-dropdown-menu-trigger")], dr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu.ts
var G, fr = class extends w {
	static {
		G = this;
	}
	constructor(...e) {
		super(...e), this.isOpen = !1, this.handleClickOutside = (e) => {
			let t = e.target;
			!this._containerElement?.contains(t) && !this._triggerElement?.contains(t) && (this.isOpen = !1, G._openInstance === this && (G._openInstance = null));
		};
	}
	static {
		this._openInstance = null;
	}
	get _triggerElement() {
		return this.querySelector("rtg-dropdown-menu-trigger");
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu]");
	}
	get _content() {
		return this.querySelector("rtg-dropdown-menu-content");
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside), this.addEventListener("radio-selected", this._handleRadioSelected);
	}
	toggleDropdown(e) {
		e.stopPropagation();
		let t = this.isOpen;
		this.isOpen = !this.isOpen, this.isOpen ? (G._openInstance && G._openInstance !== this && (G._openInstance.isOpen = !1), G._openInstance = this) : t && G._openInstance === this && (G._openInstance = null);
	}
	disconnectedCallback() {
		G._openInstance === this && (G._openInstance = null), document.removeEventListener("click", this.handleClickOutside), super.disconnectedCallback();
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "close");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement), this._triggerElement?.addEventListener("click", (e) => this.toggleDropdown(e));
	}
	_handleRadioSelected(e) {
		this.isOpen = !1, this.querySelectorAll("rtg-dropdown-menu-radio-item").forEach((t) => {
			t !== e.target && (t.checked = !1);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dropdown-menu"
        class=${P(W.root, this.className)}
      ></div>
    `;
	}
};
C([c(), S("design:type", Object)], fr.prototype, "isOpen", void 0), fr = G = C([a("rtg-dropdown-menu")], fr);
//#endregion
//#region src/components/ui/empty/_empty.ts
var pr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"empty\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty" ?data-border="${this.border}"></div>`;
	}
};
C([o({ type: Boolean }), S("design:type", Boolean)], pr.prototype, "border", void 0), pr = C([a("rtg-empty")], pr);
//#endregion
//#region src/components/ui/empty/_empty-content.ts
var mr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"empty-content\"]");
	}
	firstUpdated() {
		let e = this._contentSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty-content"></div>`;
	}
};
mr = C([a("rtg-empty-content")], mr);
//#endregion
//#region src/components/ui/empty/_empty-description.ts
var hr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"empty-description\"]");
	}
	firstUpdated() {
		let e = this._descriptionSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty-description"></div>`;
	}
};
hr = C([a("rtg-empty-description")], hr);
//#endregion
//#region src/components/ui/empty/_empty-header.ts
var gr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _headerSlot() {
		return this.querySelector("[data-slot=\"empty-header\"]");
	}
	firstUpdated() {
		let e = this._headerSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty-header"></div>`;
	}
};
gr = C([a("rtg-empty-header")], gr);
//#endregion
//#region src/components/ui/empty/_empty-media.ts
var _r = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _mediaSlot() {
		return this.querySelector("[data-slot=\"empty-media\"]");
	}
	firstUpdated() {
		let e = this._mediaSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <div data-slot="empty-media" data-variant="${this.variant}"></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], _r.prototype, "variant", void 0), _r = C([a("rtg-empty-media")], _r);
//#endregion
//#region src/components/ui/empty/_empty-title.ts
var vr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _titleSlot() {
		return this.querySelector("[data-slot=\"empty-title\"]");
	}
	firstUpdated() {
		let e = this._titleSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty-title"></div>`;
	}
};
vr = C([a("rtg-empty-title")], vr);
//#endregion
//#region src/components/ui/field/_field-set.ts
var yr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _setSlot() {
		return this.querySelector("[data-slot=\"field-set\"]");
	}
	firstUpdated() {
		let e = this._setSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<fieldset data-slot="field-set"></fieldset>`;
	}
};
yr = C([a("rtg-field-set")], yr);
//#endregion
//#region src/components/ui/field/_field-legend.ts
var br = class extends e {
	constructor(...e) {
		super(...e), this.variant = "legend";
	}
	createRenderRoot() {
		return this;
	}
	get _legendSlot() {
		return this.querySelector("[data-slot=\"field-legend\"]");
	}
	firstUpdated() {
		let e = this._legendSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <legend data-slot="field-legend" data-variant=${this.variant}></legend>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], br.prototype, "variant", void 0), br = C([a("rtg-field-legend")], br);
//#endregion
//#region src/components/ui/field/_field-group.ts
var xr = class extends e {
	constructor(...e) {
		super(...e), this.type = "field";
	}
	createRenderRoot() {
		return this;
	}
	get _groupSlot() {
		return this.querySelector("[data-slot=\"field-group\"]");
	}
	firstUpdated() {
		let e = this._groupSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="field-group" data-type=${this.type}></div>`;
	}
};
C([o({ type: String }), S("design:type", Object)], xr.prototype, "type", void 0), xr = C([a("rtg-field-group")], xr);
//#endregion
//#region src/components/ui/field/_field.ts
var Sr = class extends e {
	constructor(...e) {
		super(...e), this.orientation = "vertical";
	}
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"field\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <div
        data-slot="field"
        data-orientation=${this.orientation}
        data-disabled=${this.disabled ? "true" : r}
        data-invalid=${this.invalid ? "true" : r}
        role="group"
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Sr.prototype, "orientation", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Sr.prototype, "disabled", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Sr.prototype, "invalid", void 0), Sr = C([a("rtg-field")], Sr);
//#endregion
//#region src/components/ui/field/_field-content.ts
var Cr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"field-content\"]");
	}
	firstUpdated() {
		let e = this._contentSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="field-content"></div>`;
	}
};
Cr = C([a("rtg-field-content")], Cr);
//#endregion
//#region src/components/ui/label/_label.ts
var wr = class extends e {
	get _rootSlot() {
		return this.querySelector("[data-slot=\"label\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<label data-slot="label" for=${this.for ?? r}></label>`;
	}
};
C([o({ type: String }), S("design:type", String)], wr.prototype, "for", void 0), wr = C([a("rtg-label")], wr);
//#endregion
//#region src/components/ui/field/_field-label.ts
var Tr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _labelSlot() {
		return this.querySelector("[data-slot=\"field-label\"]");
	}
	firstUpdated() {
		let e = this._labelSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <rtg-label data-slot="field-label" for=${this.for ?? r}></rtg-label>
    `;
	}
};
C([o({ type: String }), S("design:type", String)], Tr.prototype, "for", void 0), Tr = C([a("rtg-field-label")], Tr);
//#endregion
//#region src/components/ui/field/_field-title.ts
var Er = class extends e {
	createRenderRoot() {
		return this;
	}
	get _titleSlot() {
		return this.querySelector("[data-slot=\"field-label\"]");
	}
	firstUpdated() {
		let e = this._titleSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="field-label"></div>`;
	}
};
Er = C([a("rtg-field-title")], Er);
//#endregion
//#region src/components/ui/field/_field-description.ts
var Dr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"field-description\"]");
	}
	firstUpdated() {
		let e = this._descriptionSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="field-description"></p>`;
	}
};
Dr = C([a("rtg-field-description")], Dr);
//#endregion
//#region src/components/ui/field/_field-separator.ts
var Or = class extends e {
	constructor(...e) {
		super(...e), this._observer = null;
	}
	createRenderRoot() {
		return this;
	}
	get _separatorSlot() {
		return this.querySelector("[data-slot=\"field-separator\"]");
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"field-separator-content\"]");
	}
	_getExternalNodes() {
		let e = this._separatorSlot;
		return Array.from(this.childNodes).filter((t) => !(t === e || t.nodeType === Node.COMMENT_NODE || t.nodeType === Node.TEXT_NODE && !t.textContent?.trim()));
	}
	_processChildren() {
		let e = this._separatorSlot;
		if (!e) return;
		let t = this._getExternalNodes();
		if (t.length > 0) {
			let n = this._contentSlot;
			n || (n = document.createElement("span"), n.setAttribute("data-slot", "field-separator-content"), e.appendChild(n)), t.forEach((e) => n.appendChild(e)), e.setAttribute("data-content", "true");
		} else {
			let t = this._contentSlot;
			t && e.removeChild(t), e.setAttribute("data-content", "false");
		}
	}
	firstUpdated() {
		this._processChildren(), this._observer = new MutationObserver(() => {
			this._observer.disconnect(), this._processChildren(), this._observer.observe(this, { childList: !0 });
		}), this._observer.observe(this, { childList: !0 });
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._observer?.disconnect(), this._observer = null;
	}
	render() {
		return n`
      <div data-slot="field-separator">
        <rtg-separator></rtg-separator>
        <span data-slot="field-separator-content"></span>
      </div>
    `;
	}
};
Or = C([a("rtg-field-separator")], Or);
//#endregion
//#region src/components/ui/field/_field-error.ts
var kr = class extends e {
	constructor(...e) {
		super(...e), this._hasUserContent = !1;
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._hasUserContent = this.innerHTML.trim().length > 0;
	}
	_renderContent() {
		if (!this.errors?.length) return null;
		let e = [...new Map(this.errors.map((e) => [e?.message, e])).values()];
		return e.length === 1 ? e[0]?.message ? e[0].message : null : n`
      <ul data-slot="field-error-content">
        ${e.map((e, t) => e?.message ? n`<li key=${t}>${e.message}</li>` : r)}
      </ul>
    `;
	}
	render() {
		let e = this._hasUserContent, t = this._renderContent();
		return e ? n` <div data-slot="field-error" role="alert">${Array.from(this.childNodes)}</div>` : t ? n` <div data-slot="field-error" role="alert">${t}</div>` : (this.style.display = "none", r);
	}
};
C([o({ type: Array }), S("design:type", Array)], kr.prototype, "errors", void 0), kr = C([a("rtg-field-error")], kr);
//#endregion
//#region src/components/ui/form/form-controller.ts
var Ar = class {
	constructor() {
		this.values = {}, this.errors = {}, this.validators = {}, this.subscribers = /* @__PURE__ */ new Set();
	}
	registerField({ name: e, defaultValue: t = "", validator: n }) {
		e in this.values || (this.values[e] = t), n && (this.validators[e] = n);
	}
	unregisterField(e) {
		delete this.values[e], delete this.errors[e], delete this.validators[e];
	}
	setValue(e, t) {
		e in this.validators || console.warn(`[FormController] setValue called before validator was registered for "${e}"`), this.values[e] = t, this.validateField(e), this.notify();
	}
	getValue(e) {
		return this.values[e];
	}
	getError(e) {
		return this.errors[e] ?? null;
	}
	validateField(e) {
		let t = this.validators[e], n = this.values[e], r = t ? t(n) : null;
		return this.errors[e] = r, this.notify(), !r;
	}
	validateAll() {
		let e = !0;
		return Object.keys(this.validators).forEach((t) => {
			this.validateField(t) || (e = !1);
		}), e;
	}
	subscribe(e) {
		return this.subscribers.add(e), () => this.subscribers.delete(e);
	}
	notify() {
		this.subscribers.forEach((e) => e());
	}
	getValues() {
		return { ...this.values };
	}
	getErrors() {
		return { ...this.errors };
	}
}, jr = ee("rtg-form-context"), Mr = class extends w {
	constructor(...e) {
		super(...e), this.form = new Ar(), this.handleSubmit = (e) => {
			if (e.preventDefault(), this.form.validateAll()) {
				let e = this.form.getValues();
				alert(JSON.stringify(e, null, 2));
			}
		};
	}
	createRenderRoot() {
		return this;
	}
	async firstUpdated(e) {
		await this.updateComplete, Array.from(this.childNodes).forEach((e) => {
			e !== this.formElement && this.formElement.appendChild(e);
		}), this.querySelectorAll("rtg-form-field").forEach((e) => {
			let t = e.getAttribute("name"), n = e.validators?.[0];
			this.form.registerField({
				name: t,
				validator: n
			});
		});
	}
	render() {
		return n`
      <form
        part="form-controller"
        class="${P("", this.className)}"
        @submit=${this.handleSubmit}
        ${h((e) => this.formElement = e)}
      ></form>
    `;
	}
};
C([
	c(),
	m({ context: jr }),
	S("design:type", Object)
], Mr.prototype, "form", void 0), Mr = C([a("rtg-form-controller")], Mr);
//#endregion
//#region src/components/ui/form/form-item-context.ts
var Nr = ee("rtg-form-item-context"), Pr = "rtg-space-form-space-y", Fr = "rtg-text-form-description-font rtg-text-form-description-color-text rtg-mt-form-description-space-mt", Ir = "rtg-space-y-form-field-space-y", Lr = "rtg-space-y-form-item-space-y", Rr = "rtg-text-form-label-font rtg-mb-form-label-space-mb rtg-font-form-label-font-weight rtg-peer-disabled:rtg-cursor-not-allowed peer-disabled:rtg-opacity-form-label-opacity-peer-disabled", zr = "rtg-text-form-message-font-size rtg-text-form-message-color-text", Br = class extends w {
	createRenderRoot() {
		return this;
	}
	get _desc() {
		return this.querySelector("p[part=form-description]");
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._desc);
	}
	render() {
		return n`
      <p
        id="${this.itemContext.id}-description"
        part="form-description"
        class="${P(Fr, this.className)}"
      ></p>
    `;
	}
};
C([p({ context: Nr }), S("design:type", Object)], Br.prototype, "itemContext", void 0), Br = C([a("rtg-form-description")], Br);
//#endregion
//#region src/components/ui/form/form-field-context.ts
var Vr = ee("rtg-form-field-context"), Hr = class extends w {
	constructor(...e) {
		super(...e), this.name = "", this.validators = [], this.defaultValue = "", this.fieldName = "", this.registered = !1;
	}
	createRenderRoot() {
		return this;
	}
	get _container() {
		return this.querySelector("div[part=form-field]");
	}
	updated() {
		if (this.registered || !this.form || !this.name) return;
		this.form.registerField({
			name: this.name,
			validator: (e) => {
				for (let t of this.validators ?? []) {
					let n = t(e);
					if (n) return n;
				}
				return null;
			},
			defaultValue: this.defaultValue
		}), this.registered = !0, this.moveLightDomChildrenInto(this._container);
		let e = this._container?.querySelector("rtg-input, input, textarea, select");
		e && (e.value = this.defaultValue ?? "", this.form.setValue(this.name, this.defaultValue ?? ""), e.addEventListener("input", () => {
			this.form.setValue(this.name, e.value);
		}));
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.isConnected || this.form?.unregisterField(this.name);
	}
	render() {
		return n`<div
      part="form-field"
      class="${P(Ir, this.className)}"
    ></div>`;
	}
};
C([p({ context: jr }), S("design:type", Ar === void 0 ? Object : Ar)], Hr.prototype, "form", void 0), C([o({ type: String }), S("design:type", Object)], Hr.prototype, "name", void 0), C([o({ type: Array }), S("design:type", Array)], Hr.prototype, "validators", void 0), C([o({ type: String }), S("design:type", Object)], Hr.prototype, "defaultValue", void 0), C([m({ context: Vr }), S("design:type", Object)], Hr.prototype, "fieldName", void 0), Hr = C([a("rtg-form-field")], Hr);
//#endregion
//#region src/components/ui/form/rtg-form-item.ts
var Ur = class extends w {
	constructor(...e) {
		super(...e), this._generatedId = crypto.randomUUID(), this.itemContext = { id: this._generatedId };
	}
	createRenderRoot() {
		return this;
	}
	get _container() {
		return this.querySelector("div[part=form-item]");
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._container);
	}
	render() {
		return n`<div
      part="form-item"
      class="${P(Lr, this.className)}"
    ></div>`;
	}
};
C([m({ context: Nr }), S("design:type", Object)], Ur.prototype, "itemContext", void 0), Ur = C([a("rtg-form-item")], Ur);
//#endregion
//#region src/components/ui/form/rtg-form-label.ts
var Wr = class extends w {
	constructor(...e) {
		super(...e), this.hasError = !1, this.unsubscribe = null;
	}
	get _field() {
		let e = this.parentElement;
		for (; e && !(e instanceof Hr);) e = e.parentElement;
		return e;
	}
	createRenderRoot() {
		return this;
	}
	get _label() {
		return this.querySelector("label[part=form-label]");
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._label);
	}
	connectedCallback() {
		super.connectedCallback();
		let e = this._field.name;
		this.hasError = !!this.form.getError(e), this.unsubscribe = this.form.subscribe(() => {
			let t = this.form.getError(e);
			this.hasError = !!t, this.requestUpdate();
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.unsubscribe && this.unsubscribe();
	}
	render() {
		return n`
      <label
        part="form-label"
        for="${this._field.name}"
        class="${P(Rr, this.hasError && "rtg-text-form-label-color-text-error", this.className)}"
      ></label>
    `;
	}
};
C([p({ context: jr }), S("design:type", Ar === void 0 ? Object : Ar)], Wr.prototype, "form", void 0), C([c(), S("design:type", Object)], Wr.prototype, "hasError", void 0), Wr = C([a("rtg-form-label")], Wr);
//#endregion
//#region src/components/ui/form/rtg-form-message.ts
var Gr = class extends e {
	constructor(...e) {
		super(...e), this.error = null, this.unsubscribe = null;
	}
	get _field() {
		let e = this.parentElement;
		for (; e && !(e instanceof Hr);) e = e.parentElement;
		return e;
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this.error = this.form.getError(this._field.name), this.unsubscribe = this.form.subscribe(() => {
			this.error = this.form.getErrors()[this._field.name], this.requestUpdate();
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.unsubscribe && this.unsubscribe();
	}
	render() {
		return this.error ? n`<p
      id="${this._field.name}-message"
      class="${P(zr, this.className)}"
    >
      ${this.error}
    </p>` : null;
	}
};
C([p({ context: jr }), S("design:type", Ar === void 0 ? Object : Ar)], Gr.prototype, "form", void 0), C([c(), S("design:type", Object)], Gr.prototype, "error", void 0), Gr = C([a("rtg-form-message")], Gr);
//#endregion
//#region src/components/ui/form/rtg-form.ts
var Kr = class extends w {
	constructor(...e) {
		super(...e), this.form = new Ar(), this.onSubmit = () => {}, this.handleSubmit = (e) => {
			e.preventDefault(), this.form.validateAll() && this.onSubmit(this.form.getValues());
		};
	}
	createRenderRoot() {
		return this;
	}
	get _formElement() {
		return this.querySelector("form[part=form-root]");
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._formElement);
	}
	render() {
		return n`
      <form
        part="form-root"
        id="rtg-form"
        @submit=${this.handleSubmit}
        class="${P(Pr, this.className)}"
      ></form>
    `;
	}
};
C([m({ context: jr }), S("design:type", Object)], Kr.prototype, "form", void 0), C([o({ type: Function }), S("design:type", Function)], Kr.prototype, "onSubmit", void 0), Kr = C([a("rtg-form")], Kr);
//#endregion
//#region src/components/ui/hoverCard/hover-card.styles.ts
var qr = {
	root: [""],
	trigger: [""],
	content: [
		"rtg-fixed rtg-z-50",
		"rtg-p-hover-card-content-space-p",
		"rtg-w-hover-card-content-space-w",
		"rtg-text-hover-card-content-color-text",
		"rtg-bg-hover-card-content-color-bg",
		"rtg-rounded-hover-card-content-radius rtg-border-hover-card-content-width-border rtg-border-hover-card-content-color-border rtg-outline-hidden",
		"rtg-shadow-hover-card-content-shadow",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95",
		"data-[side=bottom]:rtg-slide-in-from-top-2 data-[side=left]:rtg-slide-in-from-right-2 data-[side=right]:rtg-slide-in-from-left-2 data-[side=top]:rtg-slide-in-from-bottom-2"
	]
}, Jr = class extends w {
	constructor(...e) {
		super(...e), this.state = "closed", this.isOpen = !1, this.onStateChange = (e) => {
			let t = e.detail.isOpen;
			this.state = t ? "open" : "closed";
		}, this.handlePointerLeaveCheck = (e) => {
			this.contains(e.relatedTarget) || (this.isOpen = !1);
		};
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("hover-card-state-change", this.onStateChange), this.addEventListener("mouseenter", this.handlePointerLeaveCheck), this.addEventListener("mouseleave", this.handlePointerLeaveCheck);
	}
	disconnectedCallback() {
		document.removeEventListener("hover-card-state-change", this.onStateChange), this.removeEventListener("mouseenter", this.handlePointerLeaveCheck), this.removeEventListener("mouseleave", this.handlePointerLeaveCheck), super.disconnectedCallback();
	}
	updated(e) {
		super.updated(e), this.isOpen = this.state === "open";
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.renderRoot.querySelector("#rtg-hover-card-content"));
	}
	render() {
		return n`
      <div
        id="rtg-hover-card-content"
        part="hover-card-content"
        class=${P(qr.content, this.className)}
        style="display: ${this.isOpen ? "block" : "none"};"
      ></div>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", String)], Jr.prototype, "state", void 0), C([c(), S("design:type", Object)], Jr.prototype, "isOpen", void 0), Jr = C([a("rtg-hover-card-content")], Jr);
//#endregion
//#region src/components/ui/hoverCard/hover-card-trigger.ts
var Yr = class extends w {
	getAttributesToExclude() {
		return ["value", "defaultValue"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.removeDuplicateContent();
	}
	render() {
		return n`
      <div
        id="rtg-hover-card-trigger"
        part="rtg-hover-card-trigger"
        class=${P(qr.trigger, this.className)}
      >
        ${Array.from(this.children)}
      </div>
    `;
	}
};
Yr = C([a("rtg-hover-card-trigger")], Yr);
//#endregion
//#region src/components/ui/hoverCard/hover-card.ts
var Xr = class extends w {
	constructor(...e) {
		super(...e), this.isOpen = !1, this.hoverTimeout = null, this.openCard = () => {
			this.hoverTimeout &&= (clearTimeout(this.hoverTimeout), null), this.isOpen || (this.isOpen = !0, this._content?.dispatchEvent(new CustomEvent("hover-card-state-change", { detail: { isOpen: !0 } })));
		}, this.closeCard = () => {
			this.hoverTimeout = setTimeout(() => {
				this.isOpen = !1, this._content?.dispatchEvent(new CustomEvent("hover-card-state-change", { detail: { isOpen: !1 } }));
			}, 150);
		};
	}
	get _containerElement() {
		return this.renderRoot.querySelector("#rtg-hover-card-container");
	}
	get _content() {
		return this.renderRoot.querySelector("rtg-hover-card-content");
	}
	get _trigger() {
		return this.renderRoot.querySelector("rtg-hover-card-trigger");
	}
	getAttributesToExclude() {
		return [];
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "closed");
	}
	connectedCallback() {
		super.connectedCallback();
	}
	disconnectedCallback() {
		let e = this._trigger, t = this._content;
		e?.removeEventListener("mouseenter", this.openCard), e?.removeEventListener("mouseleave", this.closeCard), t?.removeEventListener("mouseenter", this.openCard), t?.removeEventListener("mouseleave", this.closeCard), this.hoverTimeout && clearTimeout(this.hoverTimeout), super.disconnectedCallback();
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		let t = this._containerElement;
		this.moveLightDomChildrenInto(t);
		let n = this._trigger, r = this._content;
		n?.addEventListener("mouseenter", this.openCard), n?.addEventListener("mouseleave", this.closeCard), r?.addEventListener("mouseenter", this.openCard), r?.addEventListener("mouseleave", this.closeCard);
	}
	render() {
		return n`
      <div
        id="rtg-hover-card-container"
        part="hover-card"
        class=${P(qr.root, this.className)}
      ></div>
    `;
	}
};
C([c(), S("design:type", Object)], Xr.prototype, "isOpen", void 0), Xr = C([a("rtg-hover-card")], Xr);
//#endregion
//#region src/components/ui/input-group/_input-group.ts
var Zr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"input-group\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="input-group" role="group"></div>`;
	}
};
Zr = C([a("rtg-input-group")], Zr);
//#endregion
//#region src/components/ui/input-group/_input-group-addon.ts
var Qr = class extends e {
	constructor(...e) {
		super(...e), this.align = "inline-start";
	}
	createRenderRoot() {
		return this;
	}
	get _addonSlot() {
		return this.querySelector("[data-slot=\"input-group-addon\"]");
	}
	firstUpdated() {
		let e = this._addonSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <div
        data-slot="input-group-addon"
        data-align="${this.align}"
        ?data-border="${this.border}"
        role="group"
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Qr.prototype, "align", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Qr.prototype, "border", void 0), Qr = C([a("rtg-input-group-addon")], Qr);
//#endregion
//#region src/components/ui/input-group/_input-group-button.ts
var $r = class extends e {
	constructor(...e) {
		super(...e), this.variant = "ghost", this.size = "xs", this.type = "button";
	}
	createRenderRoot() {
		return this;
	}
	get _buttonSlot() {
		return this.querySelector("[data-slot=\"input-group-button\"]");
	}
	firstUpdated() {
		let e = this._buttonSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <rtg-button
        data-slot="input-group-button"
        .variant=${this.variant}
        .size=${this.size}
        .type=${this.type}
        ?disabled=${this.disabled}
        ?invalid=${this.invalid}
        .href=${this.href}
        .target=${this.target}
        .onclick=${this.onClick}
      ></rtg-button>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], $r.prototype, "variant", void 0), C([o({ type: String }), S("design:type", Object)], $r.prototype, "size", void 0), C([o({ type: String }), S("design:type", Object)], $r.prototype, "type", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], $r.prototype, "disabled", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], $r.prototype, "invalid", void 0), C([o({ type: String }), S("design:type", String)], $r.prototype, "href", void 0), C([o({ type: String }), S("design:type", Object)], $r.prototype, "target", void 0), C([o({
	attribute: !1,
	type: Function
}), S("design:type", Function)], $r.prototype, "onClick", void 0), $r = C([a("rtg-input-group-button")], $r);
//#endregion
//#region src/components/ui/input/_input.ts
var K = class extends e {
	constructor(...e) {
		super(...e), this.id = "", this.type = "text", this._onClick = (e) => {
			this.onClick && this.onClick(e);
		}, this._onInput = (e) => {
			let t = e.target;
			this.value = t.value, this.onInput && this.onInput(e);
		}, this._onChange = (e) => {
			let t = e.target;
			this.value = t.value, this.onChange && this.onChange(e);
		}, this._onFocus = (e) => {
			this.dispatchEvent(new FocusEvent("focus", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onFocus && this.onFocus(e);
		}, this._onBlur = (e) => {
			this.dispatchEvent(new FocusEvent("blur", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onBlur && this.onBlur(e);
		};
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._inputId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._inputId = this.id, this.removeAttribute("id");
	}
	render() {
		return n`
      <input
        data-slot="input"
        accept=${this.type === "file" && this.accept ? this.accept : r}
        autocomplete=${this.autocomplete ?? r}
        ?disabled=${this.disabled}
        form=${this.form ?? r}
        id=${this._inputId && this._inputId !== "" ? this._inputId : r}
        max=${this.max ?? r}
        maxlength=${this.maxlength ?? r}
        min=${this.min ?? r}
        minlength=${this.minlength ?? r}
        multiple=${this.multiple ?? r}
        name=${this.name ?? r}
        pattern=${this.max ?? r}
        placeholder=${this.placeholder ?? r}
        ?readonly=${this.readonly}
        ?required=${this.required}
        step=${this.step ?? r}
        type=${this.type}
        value=${this.value ?? r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        aria-label=${this.ariaLabel ?? r}
        aria-required=${this.required ? "true" : r}
        @click=${this._onClick}
        @input=${this._onInput}
        @change=${this._onChange}
        @focus=${this._onFocus}
        @blur=${this._onBlur}
      />
    `;
	}
};
C([o({ type: String }), S("design:type", String)], K.prototype, "accept", void 0), C([o({ type: String }), S("design:type", Object)], K.prototype, "autocomplete", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], K.prototype, "disabled", void 0), C([o({ type: String }), S("design:type", String)], K.prototype, "form", void 0), C([o({ type: String }), S("design:type", Object)], K.prototype, "id", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], K.prototype, "invalid", void 0), C([o({ type: Number }), S("design:type", Number)], K.prototype, "max", void 0), C([o({ type: Number }), S("design:type", Number)], K.prototype, "maxlength", void 0), C([o({ type: Number }), S("design:type", Number)], K.prototype, "min", void 0), C([o({ type: Number }), S("design:type", Number)], K.prototype, "minlength", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], K.prototype, "multiple", void 0), C([o({ type: String }), S("design:type", String)], K.prototype, "name", void 0), C([o({ type: String }), S("design:type", String)], K.prototype, "pattern", void 0), C([o({ type: String }), S("design:type", String)], K.prototype, "placeholder", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], K.prototype, "readonly", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], K.prototype, "required", void 0), C([o({ type: Number }), S("design:type", Number)], K.prototype, "step", void 0), C([o({ type: String }), S("design:type", Object)], K.prototype, "type", void 0), C([o({ type: String }), S("design:type", String)], K.prototype, "value", void 0), C([o({ attribute: !1 }), S("design:type", Function)], K.prototype, "onClick", void 0), C([o({ attribute: !1 }), S("design:type", Function)], K.prototype, "onInput", void 0), C([o({ attribute: !1 }), S("design:type", Function)], K.prototype, "onChange", void 0), C([o({ attribute: !1 }), S("design:type", Function)], K.prototype, "onFocus", void 0), C([o({ attribute: !1 }), S("design:type", Function)], K.prototype, "onBlur", void 0), K = C([a("rtg-input")], K);
//#endregion
//#region src/components/ui/input-group/_input-group-input.ts
var q = class extends e {
	constructor(...e) {
		super(...e), this.id = "", this.type = "text";
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._inputId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._inputId = this.id, this.removeAttribute("id");
	}
	render() {
		return n`
      <rtg-input
        data-slot="input-group-input"
        .accept=${this.accept}
        .autocomplete=${this.autocomplete}
        ?disabled=${this.disabled}
        .form=${this.form}
        id=${this._inputId && this._inputId !== "" ? this._inputId : r}
        ?invalid=${this.invalid}
        .max=${this.max}
        .maxlength=${this.maxlength}
        .min=${this.min}
        .minlength=${this.minlength}
        ?multiple=${this.multiple}
        .name=${this.name}
        .pattern=${this.pattern}
        .placeholder=${this.placeholder}
        ?readonly=${this.readonly}
        ?required=${this.required}
        .step=${this.step}
        .type=${this.type}
        .value=${this.value}
        .onClick=${this.onClick}
        .onInput=${this.onInput}
        .onChange=${this.onChange}
        .onFocus=${this.onFocus}
        .onBlur=${this.onBlur}
      ></rtg-input>
    `;
	}
};
C([o({ type: String }), S("design:type", String)], q.prototype, "accept", void 0), C([o({ type: String }), S("design:type", Object)], q.prototype, "autocomplete", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], q.prototype, "disabled", void 0), C([o({ type: String }), S("design:type", String)], q.prototype, "form", void 0), C([o({ type: String }), S("design:type", Object)], q.prototype, "id", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], q.prototype, "invalid", void 0), C([o({ type: Number }), S("design:type", Number)], q.prototype, "max", void 0), C([o({ type: Number }), S("design:type", Number)], q.prototype, "maxlength", void 0), C([o({ type: Number }), S("design:type", Number)], q.prototype, "min", void 0), C([o({ type: Number }), S("design:type", Number)], q.prototype, "minlength", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], q.prototype, "multiple", void 0), C([o({ type: String }), S("design:type", String)], q.prototype, "name", void 0), C([o({ type: String }), S("design:type", String)], q.prototype, "pattern", void 0), C([o({ type: String }), S("design:type", String)], q.prototype, "placeholder", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], q.prototype, "readonly", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], q.prototype, "required", void 0), C([o({ type: Number }), S("design:type", Number)], q.prototype, "step", void 0), C([o({ type: String }), S("design:type", Object)], q.prototype, "type", void 0), C([o({ type: String }), S("design:type", String)], q.prototype, "value", void 0), C([o({ attribute: !1 }), S("design:type", Function)], q.prototype, "onClick", void 0), C([o({ attribute: !1 }), S("design:type", Function)], q.prototype, "onInput", void 0), C([o({ attribute: !1 }), S("design:type", Function)], q.prototype, "onChange", void 0), C([o({ attribute: !1 }), S("design:type", Function)], q.prototype, "onFocus", void 0), C([o({ attribute: !1 }), S("design:type", Function)], q.prototype, "onBlur", void 0), q = C([a("rtg-input-group-input")], q);
//#endregion
//#region src/components/ui/input-group/_input-group-text.ts
var ei = class extends e {
	createRenderRoot() {
		return this;
	}
	get _textSlot() {
		return this.querySelector("[data-slot=\"input-group-text\"]");
	}
	firstUpdated() {
		let e = this._textSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<span data-slot="input-group-text"></span>`;
	}
};
ei = C([a("rtg-input-group-text")], ei);
//#endregion
//#region src/components/ui/textarea/_textarea.ts
var J = class extends e {
	constructor(...e) {
		super(...e), this.id = "", this._onInput = (e) => {
			let t = e.target;
			this.value = t.value, this.onInput && this.onInput(e);
		}, this._onChange = (e) => {
			let t = e.target;
			this.value = t.value, this.onChange && this.onChange(e);
		}, this._onFocus = (e) => {
			this.dispatchEvent(new FocusEvent("focus", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onFocus && this.onFocus(e);
		}, this._onBlur = (e) => {
			this.dispatchEvent(new FocusEvent("blur", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onBlur && this.onBlur(e);
		};
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._textareaId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._textareaId = this.id, this.removeAttribute("id");
	}
	render() {
		return n`
      <textarea
        data-slot="textarea"
        autocapitalize=${this.autocapitalize ? this.autocapitalize : r}
        autocomplete=${this.autocomplete ?? r}
        autocorrect=${this.autocorrect ?? r}
        autofocus=${this.autofocus ?? r}
        cols=${this.cols ?? r}
        ?disabled=${this.disabled}
        form=${this.form ?? r}
        id=${this._textareaId && this._textareaId !== "" ? this._textareaId : r}
        maxlength=${this.maxlength ?? r}
        minlength=${this.minlength ?? r}
        name=${this.name ?? r}
        placeholder=${this.placeholder ?? r}
        ?readonly=${this.readonly}
        ?required=${this.required}
        rows=${this.rows ?? r}
        spellcheck=${this.spellcheck ?? r}
        wrap=${this.wrap ?? r}
        value=${this.value ? this.value : r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        aria-label=${this.ariaLabel ?? r}
        aria-required=${this.required ? "true" : r}
        @input=${this._onInput}
        @change=${this._onChange}
        @focus=${this._onFocus}
        @blur=${this._onBlur}
      ></textarea>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], J.prototype, "autocomplete", void 0), C([o({ type: Number }), S("design:type", Number)], J.prototype, "cols", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], J.prototype, "disabled", void 0), C([o({ type: String }), S("design:type", String)], J.prototype, "form", void 0), C([o({ type: String }), S("design:type", Object)], J.prototype, "id", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], J.prototype, "invalid", void 0), C([o({ type: Number }), S("design:type", Number)], J.prototype, "maxlength", void 0), C([o({ type: Number }), S("design:type", Number)], J.prototype, "minlength", void 0), C([o({ type: String }), S("design:type", String)], J.prototype, "name", void 0), C([o({ type: String }), S("design:type", String)], J.prototype, "placeholder", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], J.prototype, "readonly", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], J.prototype, "required", void 0), C([o({ type: Number }), S("design:type", Number)], J.prototype, "rows", void 0), C([o({ type: String }), S("design:type", Object)], J.prototype, "wrap", void 0), C([o({ type: String }), S("design:type", String)], J.prototype, "value", void 0), C([o({ attribute: !1 }), S("design:type", Function)], J.prototype, "onInput", void 0), C([o({ attribute: !1 }), S("design:type", Function)], J.prototype, "onChange", void 0), C([o({ attribute: !1 }), S("design:type", Function)], J.prototype, "onFocus", void 0), C([o({ attribute: !1 }), S("design:type", Function)], J.prototype, "onBlur", void 0), J = C([a("rtg-textarea")], J);
//#endregion
//#region src/components/ui/input-group/_input-group-textarea.ts
var Y = class extends e {
	constructor(...e) {
		super(...e), this.id = "";
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._textareaId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._textareaId = this.id, this.removeAttribute("id");
	}
	render() {
		return n`
      <rtg-textarea
        data-slot="input-group-textarea"
        autocapitalize=${this.autocapitalize ? this.autocapitalize : r}
        autocomplete=${this.autocomplete ?? r}
        autocorrect=${this.autocorrect ?? r}
        autofocus=${this.autofocus ?? r}
        cols=${this.cols ?? r}
        ?disabled=${this.disabled}
        form=${this.form ?? r}
        id=${this._textareaId && this._textareaId !== "" ? this._textareaId : r}
        ?invalid=${this.invalid}
        maxlength=${this.maxlength ?? r}
        minlength=${this.minlength ?? r}
        name=${this.name ?? r}
        placeholder=${this.placeholder ?? r}
        ?readonly=${this.readonly}
        ?required=${this.required}
        rows=${this.rows ?? r}
        spellcheck=${this.spellcheck ?? r}
        wrap=${this.wrap ?? r}
        value=${this.value ? this.value : r}
        .oninput=${this.onInput}
        .onchange=${this.onChange}
        .onfocus=${this.onFocus}
        .onblur=${this.onBlur}
      ></rtg-textarea>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Y.prototype, "autocomplete", void 0), C([o({ type: Number }), S("design:type", Number)], Y.prototype, "cols", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Y.prototype, "disabled", void 0), C([o({ type: String }), S("design:type", String)], Y.prototype, "form", void 0), C([o({ type: String }), S("design:type", Object)], Y.prototype, "id", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Y.prototype, "invalid", void 0), C([o({ type: Number }), S("design:type", Number)], Y.prototype, "maxlength", void 0), C([o({ type: Number }), S("design:type", Number)], Y.prototype, "minlength", void 0), C([o({ type: String }), S("design:type", String)], Y.prototype, "name", void 0), C([o({ type: String }), S("design:type", String)], Y.prototype, "placeholder", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Y.prototype, "readonly", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Y.prototype, "required", void 0), C([o({ type: Number }), S("design:type", Number)], Y.prototype, "rows", void 0), C([o({ type: String }), S("design:type", Object)], Y.prototype, "wrap", void 0), C([o({ type: String }), S("design:type", String)], Y.prototype, "value", void 0), C([o({ attribute: !1 }), S("design:type", Function)], Y.prototype, "onInput", void 0), C([o({ attribute: !1 }), S("design:type", Function)], Y.prototype, "onChange", void 0), C([o({ attribute: !1 }), S("design:type", Function)], Y.prototype, "onFocus", void 0), C([o({ attribute: !1 }), S("design:type", Function)], Y.prototype, "onBlur", void 0), Y = C([a("rtg-input-group-textarea")], Y);
//#endregion
//#region src/components/ui/input-otp/_input-otp.ts
var X = class extends e {
	constructor() {
		super(), this.autocomplete = "one-time-code", this.id = "", this.inputmode = "numeric", this._activeSlot = null, this._hasFocus = !1, this._value = "", this._children = [], this._handleBlur = (e) => {
			this._hasFocus = !1, this._activeSlot = null, this._sync(), this.dispatchEvent(new FocusEvent("blur", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onBlur?.(e);
		}, this._handleFocus = (e) => {
			this._hasFocus = !0, this._activeSlot === null && (this._activeSlot = this._computeInitialActiveSlot()), this._sync(), this.dispatchEvent(new FocusEvent("focus", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onFocus?.(e);
		}, this._handleKeyDown = (e) => {
			if (this.disabled || !this._hasFocus) return;
			this._activeSlot === null && (this._activeSlot = this._computeInitialActiveSlot());
			let t = e.key, n = this._currentValue ?? "";
			if (t === "ArrowLeft") {
				e.preventDefault(), this._activeSlot = this._clampIndex(this._activeSlot - 1), this._sync();
				return;
			}
			if (t === "ArrowRight") {
				e.preventDefault(), this._activeSlot = this._clampIndex(this._activeSlot + 1), this._sync();
				return;
			}
			if (t === "Home") {
				e.preventDefault(), this._activeSlot = 0, this._sync();
				return;
			}
			if (t === "End") {
				e.preventDefault(), this._activeSlot = Math.max(0, n.length - 1), this._sync();
				return;
			}
			if (t === "Backspace") {
				e.preventDefault(), this._deleteChar();
				return;
			}
			if (t === "Delete") {
				if (e.preventDefault(), this._activeSlot !== null) {
					let e = n.split("");
					e[this._activeSlot] = "", this._updateValue(e.join("")), this._sync();
				}
				return;
			}
			if (e.ctrlKey || e.metaKey || t.length !== 1) return;
			let r = this._regex();
			r && !r.test(t) || (e.preventDefault(), this._insertChar(t));
		}, this._handlePaste = (e) => {
			if (this.disabled) return;
			e.preventDefault();
			let t = e.clipboardData?.getData("text") ?? "";
			this.pasteTransformer && (t = this.pasteTransformer(t));
			let n = this._regex(), r = Array.from(t).filter((e) => n ? n.test(e) : !0);
			if (!r.length) return;
			let i = (this._currentValue ?? "").split("").slice(0, this.maxlength);
			for (; i.length < this.maxlength;) i.push("");
			let a = this._activeSlot ?? this._computeInitialActiveSlot();
			for (let e of r) {
				if (a >= this.maxlength) break;
				i[a] = e, a++;
			}
			let o = i.join("");
			this._updateValue(o), this._activeSlot = Math.min(a, this.maxlength - 1), this._checkComplete(), this._sync(), this.onPaste?.(e);
		}, this._children = Array.from(this.childNodes);
	}
	createRenderRoot() {
		return this;
	}
	get _containerSlot() {
		return this.querySelector("[data-slot=\"input-otp-container\"]");
	}
	get _wrapperSlot() {
		return this.querySelector("[data-slot=\"input-otp-wrapper\"]");
	}
	get _slots() {
		return Array.from(this.querySelectorAll("rtg-input-otp-slot"));
	}
	get _isControlled() {
		return this.value !== void 0;
	}
	get _currentValue() {
		return this._isControlled ? this.value : this._value;
	}
	_inputEl() {
		return this.querySelector("[data-slot=\"input-otp\"]");
	}
	_regex() {
		return this.pattern ? new RegExp(this.pattern) : null;
	}
	_clampIndex(e) {
		return Math.max(0, Math.min(e, this.maxlength - 1));
	}
	_computeInitialActiveSlot() {
		let e = (this._currentValue ?? "").length;
		return e >= this.maxlength ? this.maxlength - 1 : e;
	}
	_createCaret() {
		let e = document.createElement("div");
		e.dataset.slot = "input-otp-slot-caret-wrapper";
		let t = document.createElement("div");
		return t.dataset.slot = "input-otp-slot-caret", e.appendChild(t), e;
	}
	_sync() {
		let e = this._currentValue ?? "";
		this._slots.forEach((t) => {
			let n = t._slotSlot;
			if (!n) return;
			let r = e[t.index] ?? "", i = this._hasFocus && !this.disabled && t.index === this._activeSlot;
			n.dataset.state = i ? "active" : "inactive", r ? n.textContent = r : n.textContent = "";
			let a = i && !r, o = n.querySelector("[data-slot=\"input-otp-caret-wrapper\"]");
			a && !o && n.appendChild(this._createCaret()), !a && o && o.remove();
		});
	}
	_updateValue(e) {
		this._isControlled || (this._value = e), this.onChange?.(e);
	}
	_checkComplete() {
		this._currentValue?.length === this.maxlength && this.onComplete?.(this._currentValue);
	}
	_insertChar(e) {
		if (this._activeSlot === null) return;
		let t = this._activeSlot, n = (this._currentValue ?? "").split("");
		n[t] = e;
		let r = n.join("").slice(0, this.maxlength);
		this._updateValue(r), this._activeSlot = this._clampIndex(this._activeSlot + 1), this._checkComplete();
	}
	_deleteChar() {
		if (this._activeSlot === null) return;
		let e = this._activeSlot, t = (this._currentValue ?? "").split("");
		e > 0 && !t[e] && e--, t[e] = "", this._activeSlot = e, this._updateValue(t.join(""));
	}
	updated(e) {
		e.has("id") && (this.id && (this._inputId = this.id), this.removeAttribute("id")), e.has("value") && this._isControlled && (this._value = this.value ?? ""), this._sync();
	}
	firstUpdated() {
		this._inputId = this.id, this.removeAttribute("id"), this._value = this.value ?? this.defaultValue ?? "";
		let e = this._containerSlot, t = this._wrapperSlot;
		!e || !t || (this._children.forEach((n) => {
			e.insertBefore(n, t);
		}), this.addEventListener("rtg-input-otp-slot:focus", (e) => {
			if (this.disabled) return;
			let { index: t } = e.detail;
			this._activeSlot = t, this._hasFocus = !0, this._inputEl()?.focus(), this._sync();
		}));
	}
	render() {
		return n`
      <div data-slot="input-otp-container">
        <div data-slot="input-otp-wrapper">
          <input
            data-slot="input-otp"
            autocomplete=${this.autocomplete}
            ?disabled=${this.disabled}
            form=${this.form ?? r}
            id=${this._inputId && this._inputId !== "" ? this._inputId : r}
            inputmode=${this.inputmode}
            maxlength=${this.maxlength}
            name=${this.name ?? r}
            pattern=${this.pattern ?? r}
            ?required=${this.required}
            spellcheck="false"
            value=${this._currentValue ?? r}
            @blur=${this._handleBlur}
            @focus=${this._handleFocus}
            @keydown=${this._handleKeyDown}
            @paste=${this._handlePaste}
          />
        </div>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], X.prototype, "autocomplete", void 0), C([o({
	attribute: "default-value",
	type: String
}), S("design:type", String)], X.prototype, "defaultValue", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], X.prototype, "disabled", void 0), C([o({ type: String }), S("design:type", String)], X.prototype, "form", void 0), C([o({ type: String }), S("design:type", Object)], X.prototype, "id", void 0), C([o({ type: String }), S("design:type", Object)], X.prototype, "inputmode", void 0), C([o({ type: Number }), S("design:type", Number)], X.prototype, "maxlength", void 0), C([o({ type: String }), S("design:type", String)], X.prototype, "name", void 0), C([o({ type: String }), S("design:type", String)], X.prototype, "pattern", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], X.prototype, "required", void 0), C([o({ type: String }), S("design:type", String)], X.prototype, "value", void 0), C([o({ attribute: !1 }), S("design:type", Function)], X.prototype, "onChange", void 0), C([o({ attribute: !1 }), S("design:type", Function)], X.prototype, "onComplete", void 0), C([o({ attribute: !1 }), S("design:type", Function)], X.prototype, "onBlur", void 0), C([o({ attribute: !1 }), S("design:type", Function)], X.prototype, "onFocus", void 0), C([o({ attribute: !1 }), S("design:type", Function)], X.prototype, "onPaste", void 0), C([o({ attribute: !1 }), S("design:type", Function)], X.prototype, "pasteTransformer", void 0), C([c(), S("design:type", Object)], X.prototype, "_activeSlot", void 0), C([c(), S("design:type", Object)], X.prototype, "_hasFocus", void 0), C([c(), S("design:type", Object)], X.prototype, "_value", void 0), X = C([a("rtg-input-otp"), S("design:paramtypes", [])], X);
//#endregion
//#region src/components/ui/input-otp/_input-otp-group.ts
var ti = class extends e {
	createRenderRoot() {
		return this;
	}
	get _groupSlot() {
		return this.querySelector("[data-slot=\"input-otp-group\"]");
	}
	firstUpdated() {
		let e = this._groupSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="input-otp-group"></div>`;
	}
};
ti = C([a("rtg-input-otp-group")], ti);
//#endregion
//#region src/components/ui/input-otp/_input-otp-slot.ts
var ni = class extends e {
	constructor(...e) {
		super(...e), this._handleClick = () => {
			this.dispatchEvent(new CustomEvent("rtg-input-otp-slot:focus", {
				detail: { index: this.index },
				bubbles: !0
			}));
		};
	}
	createRenderRoot() {
		return this;
	}
	get _slotSlot() {
		return this.querySelector("[data-slot=\"input-otp-slot\"]");
	}
	render() {
		return n`
      <div
        data-slot="input-otp-slot"
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        @click=${this._handleClick}
      ></div>
    `;
	}
};
C([o({ type: Number }), S("design:type", Number)], ni.prototype, "index", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], ni.prototype, "invalid", void 0), ni = C([a("rtg-input-otp-slot")], ni);
//#endregion
//#region src/components/ui/input-otp/_input-otp-separator.ts
var ri = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div data-slot="input-otp-separator" role="separator">
        ${Gt()}
      </div>
    `;
	}
};
ri = C([a("rtg-input-otp-separator")], ri);
//#endregion
//#region src/components/ui/item/_item.ts
var ii = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default", this.size = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"item\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return this.href ? n`
        <a
          data-slot="item"
          data-variant="${this.variant}"
          data-size="${this.size}"
          href="${this.href}"
          target="${this.target ?? r}"
        ></a>
      ` : n`
      <div
        data-slot="item"
        data-variant="${this.variant}"
        data-size="${this.size}"
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], ii.prototype, "variant", void 0), C([o({ type: String }), S("design:type", Object)], ii.prototype, "size", void 0), C([o({ type: String }), S("design:type", String)], ii.prototype, "href", void 0), C([o({ type: String }), S("design:type", Object)], ii.prototype, "target", void 0), ii = C([a("rtg-item")], ii);
//#endregion
//#region src/components/ui/item/_item-actions.ts
var ai = class extends e {
	createRenderRoot() {
		return this;
	}
	get _actionsSlot() {
		return this.querySelector("[data-slot=\"item-actions\"]");
	}
	firstUpdated() {
		let e = this._actionsSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-actions"></div>`;
	}
};
ai = C([a("rtg-item-actions")], ai);
//#endregion
//#region src/components/ui/item/_item-content.ts
var oi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"item-content\"]");
	}
	firstUpdated() {
		let e = this._contentSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-content"></div>`;
	}
};
oi = C([a("rtg-item-content")], oi);
//#endregion
//#region src/components/ui/item/_item-description.ts
var si = class extends e {
	createRenderRoot() {
		return this;
	}
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"item-description\"]");
	}
	firstUpdated() {
		let e = this._descriptionSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="item-description"></p>`;
	}
};
si = C([a("rtg-item-description")], si);
//#endregion
//#region src/components/ui/item/_item-footer.ts
var ci = class extends e {
	createRenderRoot() {
		return this;
	}
	get _footerSlot() {
		return this.querySelector("[data-slot=\"item-footer\"]");
	}
	firstUpdated() {
		let e = this._footerSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-footer"></div>`;
	}
};
ci = C([a("rtg-item-footer")], ci);
//#endregion
//#region src/components/ui/item/_item-group.ts
var li = class extends e {
	createRenderRoot() {
		return this;
	}
	get _groupSlot() {
		return this.querySelector("[data-slot=\"item-group\"]");
	}
	firstUpdated() {
		let e = this._groupSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-group" role="list"></div>`;
	}
};
li = C([a("rtg-item-group")], li);
//#endregion
//#region src/components/ui/item/_item-header.ts
var ui = class extends e {
	createRenderRoot() {
		return this;
	}
	get _headerSlot() {
		return this.querySelector("[data-slot=\"item-header\"]");
	}
	firstUpdated() {
		let e = this._headerSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-header"></div>`;
	}
};
ui = C([a("rtg-item-header")], ui);
//#endregion
//#region src/components/ui/item/_item-media.ts
var di = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _mediaSlot() {
		return this.querySelector("[data-slot=\"item-media\"]");
	}
	firstUpdated() {
		let e = this._mediaSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <div data-slot="item-media" data-variant="${this.variant}"></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], di.prototype, "variant", void 0), di = C([a("rtg-item-media")], di);
//#endregion
//#region src/components/ui/item/_item-separator.ts
var fi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _separatorSlot() {
		return this.querySelector("[data-slot=\"item-separator\"]");
	}
	firstUpdated() {
		let e = this._separatorSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <rtg-separator
        data-slot="item-separator"
        orientation="horizontal"
      ></rtg-separator>
    `;
	}
};
fi = C([a("rtg-item-separator")], fi);
//#endregion
//#region src/components/ui/item/_item-title.ts
var pi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _titleSlot() {
		return this.querySelector("[data-slot=\"item-title\"]");
	}
	firstUpdated() {
		let e = this._titleSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-title"></div>`;
	}
};
pi = C([a("rtg-item-title")], pi);
//#endregion
//#region src/components/ui/kbd/_kbd.ts
var mi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"kbd\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<kbd data-slot="kbd"></kbd>`;
	}
};
mi = C([a("rtg-kbd")], mi);
//#endregion
//#region src/components/ui/kbd/_kbd-group.ts
var hi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _groupSlot() {
		return this.querySelector("[data-slot=\"kbd-group\"]");
	}
	firstUpdated() {
		let e = this._groupSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<kbd data-slot="kbd-group"></kbd>`;
	}
};
hi = C([a("rtg-kbd-group")], hi);
//#endregion
//#region src/components/ui/menubar/menubar.styles.ts
var Z = {
	root: [
		"rtg-flex",
		"rtg-gap-menubar-space-gap rtg-items-center",
		"rtg-p-menubar-space-p",
		"rtg-h-menubar-space-h",
		"rtg-bg-menubar-color-bg",
		"rtg-rounded-menubar-radius rtg-border-menubar-width-border rtg-border-menubar-color-border"
	],
	menu: [""],
	group: [""],
	trigger: [
		"rtg-flex",
		"rtg-items-center",
		"rtg-px-menubar-trigger-space-px rtg-py-menubar-trigger-space-py",
		"rtg-text-menubar-trigger-font rtg-font-menubar-trigger-font-weight",
		"rtg-rounded-menubar-trigger-radius rtg-outline-hidden",
		"rtg-select-none",
		"focus:rtg-text-menubar-trigger-color-text-focus focus:rtg-bg-menubar-trigger-color-bg-focus",
		"hover:rtg-text-menubar-trigger-color-text-active hover:rtg-bg-menubar-trigger-color-bg-active"
	],
	content: [
		"rtg-absolute rtg-overflow-hidden rtg-z-50",
		"rtg-p-menubar-content-space-p",
		"rtg-min-w-menubar-content-space-min-w",
		"rtg-text-menubar-content-color-text",
		"rtg-bg-menubar-content-color-bg",
		"rtg-rounded-menubar-content-radius rtg-border-menubar-content-width-border rtg-border-menubar-content-color-border",
		"rtg-shadow-menubar-content-shadow",
		"rtg-translate-y-2",
		"rtg-slide-in-from-top-2",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
	],
	item: [
		"rtg-flex rtg-relative",
		"rtg-gap-menubar-item-space-gap rtg-items-center",
		"rtg-px-menubar-item-space-px rtg-py-menubar-item-space-py",
		"rtg-text-menubar-item-font",
		"rtg-rounded-menubar-item-radius rtg-outline-hidden",
		"rtg-cursor-default rtg-select-none",
		"aria-selected:rtg-text-menubar-item-color-text-active aria-selected:rtg-bg-menubar-item-color-bg-active",
		"data-[disabled]:rtg-opacity-menubar-item-opacity-disabled data-[disabled]:rtg-pointer-events-none",
		"[&_svg]:rtg-shrink-0 [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-menubar-item-icon-space-size [&_svg:not([class*=\"rtg-text-\"])]:rtg-text-menubar-item-icon-color-text [&_svg]:rtg-pointer-events-none"
	],
	checkboxItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-menubar-checkbox-item-space-gap rtg-items-center",
			"rtg-pl-menubar-checkbox-item-space-pl rtg-pr-menubar-checkbox-item-space-pr rtg-py-menubar-checkbox-item-space-py",
			"rtg-text-menubar-checkbox-item-font",
			"rtg-rounded-menubar-checkbox-item-radius rtg-outline-hidden",
			"rtg-cursor-default rtg-select-none",
			"aria-selected:rtg-text-menubar-checkbox-item-color-text-active aria-selected:rtg-bg-menubar-checkbox-item-color-bg-active",
			"data-[disabled]:rtg-opacity-menubar-checkbox-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		indicator: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-menubar-checkbox-item-indicator-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-menubar-checkbox-item-icon-space-size",
			"rtg-pointer-events-none"
		]
	},
	radioItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-menubar-radio-item-space-gap rtg-items-center",
			"rtg-pl-menubar-radio-item-space-pl rtg-pr-menubar-radio-item-space-pr rtg-py-menubar-radio-item-space-py",
			"rtg-text-menubar-radio-item-font",
			"rtg-rounded-menubar-radio-item-radius rtg-outline-hidden",
			"rtg-cursor-default rtg-select-none",
			"aria-selected:rtg-text-menubar-radio-item-color-text-active aria-selected:rtg-bg-menubar-radio-item-color-bg-active",
			"data-[disabled]:rtg-opacity-menubar-radio-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		indicator: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-menubar-radio-item-indicator-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-menubar-radio-item-icon-space-size",
			"rtg-pointer-events-none",
			"rtg-fill-current"
		]
	},
	label: ["rtg-px-menubar-label-space-px rtg-py-menubar-label-space-py", "rtg-text-menubar-label-font rtg-font-menubar-label-font-weight"],
	separator: [
		"rtg-mx-menubar-separator-space-mx rtg-my-menubar-separator-space-my",
		"rtg-h-menubar-separator-space-h",
		"rtg-bg-menubar-separator-color-bg"
	],
	shortcut: ["rtg-ml-auto", "rtg-text-menubar-shortcut-font rtg-text-menubar-shortcut-color-text"]
}, gi, _i = class extends w {
	static {
		gi = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-checkbox-item]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.shadowRoot?.querySelector("div[rtgcmd-group]");
		return e ? this._id = `${e.getAttribute("id")}li${gi._counter++}` : this._id = `rtgcmdrxgxli${gi._counter++}`, this._id;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked = !this.checked;
	}
	render() {
		return n`
      <div
        part="menubar-checkbox-item"
        class=${P(Z.checkboxItem.base, this.disabled && "rtg-opacity-menubar-item-opacity-disabled rtg-pointer-events-none", this.className)}
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        rtgcmd-item
        role="option"
        aria-selected="${this.selected}"
        data-selected="${this.selected}"
        data-value="${this.value}"
        id="${this.identifier}"
        aria-hidden="${this.hidden}"
      >
        <span class=${P(Z.checkboxItem.indicator)}>
          ${this.checked ? n`
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${P(Z.checkboxItem.icon, "lucide lucide-check-icon lucide-check")}
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              ` : r}
        </span>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], _i.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], _i.prototype, "_hidden", void 0), C([
	o({
		attribute: "data-value",
		type: String
	}),
	S("design:type", Object),
	S("design:paramtypes", [])
], _i.prototype, "value", null), C([o({ type: Boolean }), S("design:type", Object)], _i.prototype, "selected", void 0), C([o({ type: Boolean }), S("design:type", Object)], _i.prototype, "checked", void 0), C([o({ type: Boolean }), S("design:type", Object)], _i.prototype, "disabled", void 0), _i = gi = C([a("rtg-menubar-checkbox-item")], _i);
//#endregion
//#region src/components/ui/menubar/menubar-menu.ts
var vi = class extends w {
	constructor(...e) {
		super(...e), this.isOpen = !1, this.uniqueIds = [], this.selectedMenu = "", this.isHovering = !1, this.id = "", this.closeTimeout = null, this.toggleMenubar = (e) => {
			e.stopPropagation(), document.querySelectorAll("rtg-menubar-menu").forEach((e) => {
				e !== this && (e.isOpen = !1);
			}), this.isOpen = !this.isOpen;
		}, this.handleClickOutside = (e) => {
			let t = e.target;
			this.contains(t) || (this.isOpen = !1);
		}, this.handleMenuMouseEnter = () => {
			this.clearCloseTimeout(), this.closeAllMenus(), this.isOpen = !0, this.isHovering = !0;
		}, this.handleMenuMouseLeave = (e) => {
			let t = e.relatedTarget;
			if (this.isDescendant(t, "rtg-menubar-content")) {
				this.clearCloseTimeout();
				return;
			}
			this.scheduleClose();
		};
	}
	get _content() {
		return this.querySelector("rtg-menubar-content");
	}
	get _button() {
		return this.querySelector("rtg-menubar-trigger");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside), this.addEventListener("radio-selected", this._handleRadioSelected);
	}
	disconnectedCallback() {
		document.removeEventListener("click", this.handleClickOutside), this.clearCloseTimeout(), super.disconnectedCallback();
	}
	clearCloseTimeout() {
		this.closeTimeout !== null && (clearTimeout(this.closeTimeout), this.closeTimeout = null);
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "close");
	}
	_handleRadioSelected(e) {
		this.querySelectorAll("rtg-menubar-radio-item").forEach((t) => {
			let n = t;
			t !== e.target && (n.checked = !1);
		});
	}
	firstUpdated() {
		this.setupContentListeners();
		let e = this.querySelector("div[part=menubar-menu-slot]"), t = this.querySelector("div[part=button-slot]");
		e && this._content && e.appendChild(this._content), t && this._button && t.appendChild(this._button);
	}
	raiseEvent() {
		let e = new CustomEvent("unique-ids-generated", {
			detail: { ids: this.uniqueIds },
			bubbles: !0,
			composed: !0
		});
		this.dispatchEvent(e);
	}
	closeAllMenus() {
		document.querySelectorAll("rtg-menubar-menu").forEach((e) => {
			e.isOpen = !1, e.isHovering = !1;
		});
	}
	scheduleClose() {
		this.clearCloseTimeout(), this.closeTimeout = window.setTimeout(() => {
			this.isOpen = !1, this.isHovering = !1, this.closeTimeout = null;
		}, 150);
	}
	isDescendant(e, t) {
		let n = e.parentElement;
		for (; n;) {
			if (n.tagName.toLowerCase() === t.toLowerCase()) return !0;
			n = n.parentElement;
		}
		return !1;
	}
	setupContentListeners() {
		let e = this._content;
		e && (e.addEventListener("mouseenter", () => {
			this.clearCloseTimeout(), this.isOpen = !0;
		}), e.addEventListener("mouseleave", () => {
			this.scheduleClose();
		}));
	}
	render() {
		return n`
      <div class=${P(Z.menu, this.className)}>
        <div
          id="${this.id}"
          data-state="${this.isOpen}"
          data-orientation="horizontal"
          role="menuitem"
          part="menuitem"
          aria-haspopup="menu"
          aria-expanded="${!!this.isOpen}"
          @mouseenter="${this.handleMenuMouseEnter}"
          @mouseleave="${this.handleMenuMouseLeave}"
          @click="${this.toggleMenubar}"
        >
          <div part="button-slot"></div>
        </div>

        <div part="menubar-menu-slot"></div>
      </div>
    `;
	}
};
C([c(), S("design:type", Object)], vi.prototype, "isOpen", void 0), C([c(), S("design:type", Array)], vi.prototype, "uniqueIds", void 0), C([c(), S("design:type", String)], vi.prototype, "selectedMenu", void 0), C([c(), S("design:type", Object)], vi.prototype, "isHovering", void 0), C([o({ type: String }), S("design:type", Object)], vi.prototype, "id", void 0), vi = C([a("rtg-menubar-menu")], vi);
//#endregion
//#region src/components/ui/menubar/menubar-content.ts
var yi = class extends w {
	constructor(...e) {
		super(...e), this.state = ir, this.id = "", this.side = "bottom", this.isOpen = !1;
	}
	get _menubarMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof vi);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-content]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		requestAnimationFrame(() => {
			this.moveLightDomChildrenInto(this._containerElement);
		});
	}
	connectedCallback() {
		super.connectedCallback(), this.isOpen && document.addEventListener("mousedown", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("mousedown", this.handleClickOutside), super.disconnectedCallback();
	}
	updated(e) {
		super.updated(e), this.state === "open" ? this.isOpen = !0 : this.isOpen = !1, e.has("isOpen") && (this.isOpen ? document.addEventListener("mousedown", this.handleClickOutside) : document.removeEventListener("mousedown", this.handleClickOutside));
	}
	handleClickOutside(e) {
		let t = this.querySelector("button");
		this && !this.contains(e.target) && !t?.contains(e.target) && (this.isOpen = !1);
	}
	render() {
		return n`
      <div
        class=${P(Z.content, this.className)}
        id="${this.id}"
        data-side="${this.side}"
        data-align="start"
        data-state="${this.isOpen}"
        role="menu"
        part="menubar-content"
        aria-orientation="vertical"
        aria-labelledby="${this.id}"
        dir="ltr"
        style="display: ${this.isOpen ? "block" : "none"};"
      ></div>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], yi.prototype, "state", void 0), C([o({ type: String }), S("design:type", Object)], yi.prototype, "id", void 0), C([o({ type: String }), S("design:type", Object)], yi.prototype, "side", void 0), C([c(), S("design:type", Object)], yi.prototype, "isOpen", void 0), yi = C([a("rtg-menubar-content")], yi);
//#endregion
//#region src/components/ui/menubar/menubar-group.ts
var bi, xi = class extends w {
	static {
		bi = this;
	}
	constructor(...e) {
		super(...e), this.heading = "", this._id = "", this._hidden = "";
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-group-slot]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.shadowRoot?.querySelector("div[rtgcmd-list]");
		return e ? this._id = `${e.getAttribute("id")}g${bi._counter++}` : this._id = `rtgcmdrxlxg${bi._counter++}`, this._id;
	}
	render() {
		return n`${this._hidden === "true" ? r : n`
          <div
            class=${P(Z.group, this.className)}
            id="${this.identifier}"
            role="presentation"
            part="menubar-group"
          >
            <div
              class=${P(Z.label)}
              id="${this.identifier}h"
              aria-hidden="true"
            >
              ${this.heading}
            </div>

            <div
              role="group"
              part="menubar-group-slot"
              aria-labelledby="${this.identifier}h"
            ></div>
          </div>
        `}`;
	}
};
C([o({ type: String }), S("design:type", Object)], xi.prototype, "heading", void 0), C([o({
	attribute: "id",
	type: String
}), S("design:type", Object)], xi.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], xi.prototype, "_hidden", void 0), xi = bi = C([a("rtg-menubar-group")], xi);
//#endregion
//#region src/components/ui/menubar/menubar-item.ts
var Si, Ci = class extends w {
	static {
		Si = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.disabled = !1, this.selected = !1;
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-item]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.shadowRoot?.querySelector("div[rtgcmd-group]");
		return e ? this._id = `${e.getAttribute("id")}li${Si._counter++}` : this._id = `rtgcmdrxgxli${Si._counter++}`, this._id;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	render() {
		return n` ${this._hidden === "true" ? r : n`
          <div
            part="menubar-item"
            class=${P(Z.item, this.disabled && "rtg-opacity-menubar-item-opacity-disabled rtg-pointer-events-none", this.className)}
            @mouseover="${this.handleMouseEvent}"
            @mouseleave="${this.handleMouseEvent}"
            @focus="${this.handleMouseEvent}"
            role="option"
            aria-selected="${this.selected}"
            data-selected="${this.selected}"
            data-value="${this.value}"
            id="${this.identifier}"
            aria-hidden="${this.hidden}"
          ></div>
        `}`;
	}
};
C([o({ type: String }), S("design:type", Object)], Ci.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], Ci.prototype, "_hidden", void 0), C([o({ type: Boolean }), S("design:type", Object)], Ci.prototype, "disabled", void 0), C([
	o({
		attribute: "data-value",
		type: String
	}),
	S("design:type", Object),
	S("design:paramtypes", [])
], Ci.prototype, "value", null), C([o({ type: Boolean }), S("design:type", Object)], Ci.prototype, "selected", void 0), Ci = Si = C([a("rtg-menubar-item")], Ci);
//#endregion
//#region src/components/ui/menubar/menubar-radio-item.ts
var wi, Ti = class extends w {
	static {
		wi = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-radio-item]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.shadowRoot?.querySelector("div[rtgcmd-group]");
		return e ? this._id = `${e.getAttribute("id")}li${wi._counter++}` : this._id = `rtgcmdrxgxli${wi._counter++}`, this._id;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked || (this.checked = !0, this.dispatchEvent(new CustomEvent("radio-selected", {
			bubbles: !0,
			composed: !0
		})));
	}
	render() {
		return n`
      <div
        part="menubar-radio-item"
        class=${P(Z.radioItem.base, this.disabled && "rtg-opacity-menubar-item-opacity-disabled rtg-pointer-events-none", this.className)}
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        rtgcmd-item
        role="option"
        aria-selected="${this.selected}"
        data-selected="${this.selected}"
        data-value="${this.value}"
        id="${this.identifier}"
        aria-hidden="${this.hidden}"
      >
        <span class=${P(Z.radioItem.indicator)}>
          ${this.checked ? n`<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${P(Z.radioItem.icon, "lucide lucide-circle-icon lucide-circle")}
              >
                <circle cx="12" cy="12" r="10" />
              </svg>` : r}
        </span>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Ti.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], Ti.prototype, "_hidden", void 0), C([
	o({
		attribute: "data-value",
		type: String
	}),
	S("design:type", Object),
	S("design:paramtypes", [])
], Ti.prototype, "value", null), C([o({ type: Boolean }), S("design:type", Object)], Ti.prototype, "selected", void 0), C([o({ type: Boolean }), S("design:type", Object)], Ti.prototype, "checked", void 0), C([o({ type: Boolean }), S("design:type", Object)], Ti.prototype, "disabled", void 0), Ti = wi = C([a("rtg-menubar-radio-item")], Ti);
//#endregion
//#region src/components/ui/menubar/menubar-separator.ts
var Ei, Di = class extends w {
	static {
		Ei = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "";
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-separator]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.querySelector("div[rtgcmd-list]");
		return e ? this._id = `${e.getAttribute("id")}s${Ei._counter++}` : this._id = `rtgcmdrxlxs${Ei._counter++}`, this._id;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`${this._hidden === "true" ? r : n`
          <div
            class=${P(Z.separator, this.className)}
            id="${this.identifier}"
            role="separator"
            part="menubar-separator"
            rtgcmd-separator
          ></div>
        `}`;
	}
};
C([o({ type: String }), S("design:type", Object)], Di.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], Di.prototype, "_hidden", void 0), Di = Ei = C([a("rtg-menubar-separator")], Di);
//#endregion
//#region src/components/ui/menubar/menubar-shortcut.ts
var Oi = class extends w {
	get _containerElement() {
		return this.querySelector("span[part=menubar-shortcut]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this.classList = P(Z.shortcut), this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <span
        class=${P(Z.shortcut, this.className)}
        part="menubar-shortcut"
      >
      </span>
    `;
	}
};
Oi = C([a("rtg-menubar-shortcut")], Oi);
//#endregion
//#region src/components/ui/menubar/menubar-trigger.ts
var ki = class extends w {
	get _containerElement() {
		return this.querySelector("button[part=menubar-trigger]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	render() {
		return n`
      <button
        class=${P(Z.trigger, this.className)}
        type="button"
        role="menuitem"
        part="menubar-trigger"
      ></button>
    `;
	}
};
ki = C([a("rtg-menubar-trigger")], ki);
//#endregion
//#region src/components/ui/menubar/menubar.ts
var Ai = class extends w {
	get _containerElement() {
		return this.querySelector("div[part=menubar]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        role="menubar"
        part="menubar"
        class=${P(Z.root, this.className)}
        tabindex="0"
        data-orientation="horizontal"
      ></div>
    `;
	}
};
Ai = C([a("rtg-menubar")], Ai);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu.styles.ts
var ji = {
	content: [
		"rtg-absolute",
		"rtg-top-navigation-menu-content-space-top",
		"rtg-flex",
		"rtg-justify-center"
	],
	menu: [
		"rtg-relative",
		"rtg-z-10",
		"rtg-flex",
		"rtg-max-w-navigation-menu-space-max-w",
		"rtg-flex-1",
		"rtg-items-center",
		"rtg-justify-center"
	],
	menuList: [
		"rtg-flex",
		"rtg-flex-1",
		"rtg-list-none",
		"rtg-items-center",
		"rtg-justify-center",
		"rtg-space-x-navigation-menu-list-space-x",
		"group"
	],
	menuItem: [
		"rtg-flex",
		"rtg-cursor-pointer",
		"rtg-items-center",
		"rtg-rounded-navigation-menu-item-radius",
		"rtg-bg-navigation-menu-item-color-bg",
		"rtg-py-navigation-menu-list-space-py",
		"rtg-px-navigation-menu-list-space-px",
		"hover:rtg-bg-navigation-menu-item-color-bg-hover"
	],
	menuItemIcon: [
		"lucide",
		"lucide-chevron-down",
		"rtg-relative",
		"rtg-ml-navigation-menu-item-icon-space-ml",
		"rtg-h-navigation-menu-item-icon-space-h",
		"rtg-w-navigation-menu-item-icon-space-w",
		"rtg-transition-transform",
		"rtg-duration-navigation-menu-item-icon-motion-duration"
	],
	link: [
		"rtg-flex",
		"rtg-h-navigation-menu-link-space-h",
		"rtg-bg-navigation-menu-link-color-bg",
		"hover:rtg-bg-navigation-menu-link-color-bg-hover",
		"rtg-rounded-navigation-menu-link-radius",
		"rtg-px-navigation-menu-link-space-px",
		"rtg-py-navigation-menu-link-space-py",
		"rtg-w-navigation-menu-link-space-w",
		"rtg-select-none",
		"rtg-flex-col",
		"rtg-justify-end",
		"rtg-no-underline",
		"rtg-outline-none"
	],
	contentContainer: [
		"rtg-bg-navigation-menu-content-container-color-bg",
		"origin-top-center",
		"rtg-relative",
		"rtg-mt-navigation-menu-content-container-space-mt",
		"rtg-w-navigation-menu-content-container-space-w",
		"rtg-overflow-hidden",
		"rtg-rounded-navigation-menu-content-container-radius",
		"rtg-border-navigation-menu-content-container-width-border",
		"rtg-border-navigation-menu-content-container-color-border",
		"rtg-navigation-menu-content-container-shadow"
	]
}, Mi = class extends w {
	get _containerElement() {
		return this.querySelector("ul[part=navigation-menu-list]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div class="${P("relative", this.className)}">
        <ul
          part="navigation-menu-list"
          data-orientation="horizontal"
          class=${P(ji.menuList)}
          dir="ltr"
        ></ul>
        <div></div>
      </div>
    `;
	}
};
Mi = C([a("rtg-navigation-menu-list")], Mi);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu-item.ts
var Ni = class extends w {
	constructor(...e) {
		super(...e), this.value = "", this.navigationLink = !0, this.isOpen = !1, this.uniqueIds = [], this.isHovering = !1, this.handleClickOutside = (e) => {
			let t = e.target;
			this.contains(t) || (this.isOpen = !1);
		};
	}
	raiseEvent() {
		let e = new CustomEvent("unique-ids-generated", {
			detail: { ids: this.uniqueIds },
			bubbles: !0,
			composed: !0
		});
		this.dispatchEvent(e);
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this.querySelector("div[part=content-slot]"), [this._content]), this.moveLightDomChildrenInto(this.querySelector("div[part=button-slot]"), [this._button]);
	}
	closeAllMenus() {
		document.querySelectorAll("rtg-navigation-menu-item").forEach((e) => {
			e.isOpen = !1, e.isHovering = !1;
		});
	}
	toggleMenubar(e) {
		e.stopPropagation(), document.querySelectorAll("rtg-navigation-menu-item").forEach((e) => {
			e !== this && (e.isOpen = !1);
		}), this.isOpen = !this.isOpen;
	}
	get _content() {
		return this.querySelector("rtg-navigation-menu-content");
	}
	get _button() {
		return this.querySelector("rtg-navigation-menu-trigger");
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "close");
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("click", this.handleClickOutside), super.disconnectedCallback();
	}
	handleHover() {
		this.closeAllMenus(), this.isHovering || (this.isHovering = !0, this.isOpen = !0);
	}
	handleMouseLeave() {
		this.isHovering = !1, this.isOpen = !1;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <li
        @mouseenter="${this.handleHover}"
        @mouseleave="${this.handleMouseLeave}"
        part="navigation-menu-item"
        class="${P("rtg-relative", this.className)}"
      >
        ${this.navigationLink ? n`<div
                class=${P(ji.menuItem)}
                @click="${this.toggleMenubar}"
              >
                <div part="button-slot"></div>
                ${this.navigationLink ? n`<svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class=${P(ji.menuItemIcon, this.isOpen ? "rtg-rotate-180" : "")}
                      aria-hidden="true"
                    >
                      <path d="m6 9 6 6 6-6"></path>
                    </svg>` : r}
              </div>
              <div part="content-slot" style="position:absolute"></div>` : ""}
      </li>
    `;
	}
};
C([o({ type: String }), S("design:type", String)], Ni.prototype, "value", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Ni.prototype, "navigationLink", void 0), C([c(), S("design:type", Object)], Ni.prototype, "isOpen", void 0), C([c(), S("design:type", Array)], Ni.prototype, "uniqueIds", void 0), C([c(), S("design:type", Object)], Ni.prototype, "isHovering", void 0), Ni = C([a("rtg-navigation-menu-item")], Ni);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu-content.ts
var Pi = class extends w {
	constructor(...e) {
		super(...e), this.state = "close", this.id = "", this.side = "bottom", this.isOpen = !0;
	}
	get _menubarMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof Ni);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=navigation-menu-content-container]");
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	connectedCallback() {
		super.connectedCallback(), this.isOpen && document.addEventListener("mousedown", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("mousedown", this.handleClickOutside), super.disconnectedCallback();
	}
	updated(e) {
		super.updated(e), this.state === "open" ? this.isOpen = !0 : this.isOpen = !1, e.has("isOpen") && (this.isOpen ? document.addEventListener("mousedown", this.handleClickOutside) : document.removeEventListener("mousedown", this.handleClickOutside));
	}
	handleClickOutside(e) {
		let t = this.querySelector("button");
		this && !this.contains(e.target) && !t?.contains(e.target) && (this.isOpen = !1);
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		requestAnimationFrame(() => {
			this.moveLightDomChildrenInto(this._containerElement);
		});
	}
	render() {
		return n`
      <div
        class="${P(ji.content, this.className)}"
        style="display: ${this.isOpen ? "block" : "none"};top:0px;left:0px;"
        part="navigation-menu-content"
      >
        <div
          data-state="${this.isOpen}"
          data-orientation="horizontal"
          class="${P(ji.contentContainer, this.className)}"
        >
          <div
            id="${this.id}"
            aria-labelledby="${this.id}"
            data-orientation="horizontal"
            dir="ltr"
            part="navigation-menu-content-container"
          ></div>
        </div>
      </div>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], Pi.prototype, "state", void 0), C([o({ type: String }), S("design:type", Object)], Pi.prototype, "id", void 0), C([o({ type: String }), S("design:type", Object)], Pi.prototype, "side", void 0), C([c(), S("design:type", Object)], Pi.prototype, "isOpen", void 0), Pi = C([a("rtg-navigation-menu-content")], Pi);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu-link.ts
var Fi = class extends w {
	constructor(...e) {
		super(...e), this.href = "/";
	}
	get _containerElement() {
		return this.querySelector("a[part=navigation-menu-link]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <a
        part="navigation-menu-link"
        class="${P(ji.link, this.className)}"
        href="${this.href}"
        data-radix-collection-item=""
        data-tabindex=""
        tabindex="-1"
      >
      </a>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Fi.prototype, "href", void 0), Fi = C([a("rtg-navigation-menu-link")], Fi);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu-trigger.ts
var Ii = class extends w {
	get _containerElement() {
		return this.querySelector("div[part=navigation-menu-trigger]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	render() {
		return n`
      <div part="navigation-menu-trigger" class="${P(this.className)}"></div>
    `;
	}
};
Ii = C([a("rtg-navigation-menu-trigger")], Ii);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu.ts
var Li = class extends w {
	get _containerElement() {
		return this.querySelector("nav[part=navigation-menu]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {}
	render() {
		return n`
      <nav
        part="navigation-menu"
        aria-label="Main"
        data-orientation="horizontal"
        dir="ltr"
        class="${P(ji.menu, this.className)}"
      ></nav>
    `;
	}
};
Li = C([a("rtg-navigation-menu")], Li);
//#endregion
//#region src/components/ui/pagination/pagination.styles.ts
var Ri = {
	root: [
		"rtg-flex",
		"rtg-justify-center",
		"rtg-mx-auto",
		"rtg-w-full"
	],
	content: ["rtg-flex", "rtg-flex-row rtg-gap-pagination-content-space-gap rtg-items-center"],
	item: [""],
	link: Mt,
	previous: {
		base: ["rtg-gap-pagination-previous-space-gap", "rtg-px-pagination-previous-space-px sm:rtg-pl-pagination-previous-space-px"],
		span: ["rtg-hidden sm:rtg-block"]
	},
	next: {
		base: ["rtg-gap-pagination-next-space-gap", "rtg-px-pagination-next-space-px sm:rtg-pr-pagination-next-space-px"],
		span: ["rtg-hidden sm:rtg-block"]
	},
	ellipsis: {
		base: ["rtg-flex rtg-justify-center rtg-items-center", "rtg-size-pagination-ellipsis-space-size"],
		icon: ["rtg-size-pagination-ellipsis-icon-space-size"],
		span: ["rtg-sr-only"]
	}
}, zi = class extends w {
	get _containerElement() {
		return this.querySelector("ul[part=pagination-content]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <ul
        data-slot="pagination-content"
        part="pagination-content"
        class=${P(Ri.content, this.className)}
      ></ul>
    `;
	}
};
zi = C([a("rtg-pagination-content")], zi);
//#endregion
//#region src/components/ui/pagination/pagination-ellipsis.ts
var Bi = class extends w {
	get _containerElement() {
		return this.querySelector("span[part=pagination-ellipsis]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <span
        aria-hidden
        data-slot="pagination-ellipsis"
        part="pagination-ellipsis"
        class=${P(Ri.ellipsis.base, this.className)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class=${P(Ri.ellipsis.icon, "lucide lucide-ellipsis-icon lucide-ellipsis")}
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>

        <span class=${P(Ri.ellipsis.span)}>More pages</span>
      </span>
    `;
	}
};
Bi = C([a("rtg-pagination-ellipsis")], Bi);
//#endregion
//#region src/components/ui/pagination/pagination-link.ts
var Vi = class extends w {
	constructor(...e) {
		super(...e), this.state = "close", this.isActive = !1, this.size = "icon", this.href = "javascript:void(0)";
	}
	get _containerElement() {
		return this.querySelector("a[part=pagination-link]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		super.updated(e), this.state === "open" ? this.isActive = !0 : this.isActive = !1;
	}
	render() {
		return n`
      <a
        aria-current=${this.isActive ? "page" : void 0}
        data-slot="pagination-link"
        data-state=${this.isActive}
        part="pagination-link"
        id="${this.id}"
        href="${this.href}"
        class=${P(Ri.link({
			variant: this.isActive ? "outline" : "ghost",
			size: this.size
		}), this.className)}
      >
      </a>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], Vi.prototype, "state", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Vi.prototype, "isActive", void 0), C([o({ type: String }), S("design:type", typeof Exclude > "u" ? Object : Exclude)], Vi.prototype, "size", void 0), C([o({ type: String }), S("design:type", String)], Vi.prototype, "href", void 0), Vi = C([a("rtg-pagination-link")], Vi);
//#endregion
//#region src/components/ui/pagination/pagination-item.ts
var Hi = class extends w {
	constructor(...e) {
		super(...e), this.uniqueIds = [], this.isActive = !1;
	}
	get _containerElement() {
		return this.querySelector("li[part=pagination-item]");
	}
	get _content() {
		let e = this._containerElement?.children;
		if (e) {
			for (let t = 0; t < e.length; t++) if (e[t] instanceof Vi) return e[t];
		}
		return null;
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isActive ? "open" : "close");
	}
	handleClick(e) {
		e.stopPropagation(), document.querySelectorAll("rtg-pagination-item").forEach((e) => {
			e !== this && (e.isActive = !1);
		}), this.isActive = !this.isActive;
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._containerElement);
		let e = this._containerElement?.children, t = [];
		for (let n = 0; n < e.length - 1; n += 1) {
			let r = e[n], i = crypto.randomUUID();
			t.push(i), r.dataset.pairId = i;
		}
		this.uniqueIds = t, this._content && this._content.removeEventListener("unique-ids-generated", () => {
			this.requestUpdate();
		});
	}
	raiseEvent() {
		let e = new CustomEvent("unique-ids-generated", {
			detail: { ids: this.uniqueIds },
			bubbles: !0,
			composed: !0
		});
		this.dispatchEvent(e);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <li
        data-slot="pagination-item"
        part="pagination-item"
        class=${P(Ri.item, this.className)}
        @click="${this.handleClick}"
      ></li>
    `;
	}
};
C([c(), S("design:type", Array)], Hi.prototype, "uniqueIds", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Hi.prototype, "isActive", void 0), Hi = C([a("rtg-pagination-item")], Hi);
//#endregion
//#region src/components/ui/pagination/pagination-next.ts
var Ui = class extends w {
	constructor(...e) {
		super(...e), this.href = "javascript:void(0)";
	}
	get _containerElement() {
		return this.querySelector("div[part=pagination-next]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <rtg-pagination-link
        aria-label="Go to next page"
        size="default"
        href=${this.href}
        class=${P(Ri.next.base, this.className)}
      >
        <span class=${P(Ri.next.span)}>Next</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-chevron-right-icon lucide-chevron-right"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>

        <div part="pagination-next"></div>
      </rtg-pagination-link>
    `;
	}
};
C([o({ type: String }), S("design:type", String)], Ui.prototype, "href", void 0), Ui = C([a("rtg-pagination-next")], Ui);
//#endregion
//#region src/components/ui/pagination/pagination-previous.ts
var Wi = class extends w {
	constructor(...e) {
		super(...e), this.href = "javascript:void(0)";
	}
	get _containerElement() {
		return this.querySelector("div[part=pagination-previous]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <rtg-pagination-link
        aria-label="Go to previous page"
        size="default"
        href=${this.href}
        class=${P(Ri.previous.base, this.className)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-chevron-left-icon lucide-chevron-left"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>

        <span class=${P(Ri.previous.span)}>Previous</span>

        <div part="pagination-previous"></div>
      </rtg-pagination-link>
    `;
	}
};
C([o({ type: String }), S("design:type", String)], Wi.prototype, "href", void 0), Wi = C([a("rtg-pagination-previous")], Wi);
//#endregion
//#region src/components/ui/pagination/pagination.ts
var Gi = class extends w {
	get _containerElement() {
		return this.querySelector("nav[part=pagination]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <nav
        role="navigation"
        aria-label="pagination"
        data-slot="pagination"
        part="pagination"
        class=${P(Ri.root, this.className)}
      ></nav>
    `;
	}
};
Gi = C([a("rtg-pagination")], Gi);
//#endregion
//#region src/components/ui/password-input/_password-input.ts
var Q = class extends e {
	constructor(...e) {
		super(...e), this.id = "", this._showPassword = !1, this._handleToggle = () => {
			this._showPassword = !this._showPassword;
		};
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._inputId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._inputId = this.id, this.removeAttribute("id");
	}
	_renderIcon() {
		return this._showPassword ? n`
        <svg
          data-slot="password-input-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-eye-icon lucide-eye"
        >
          <path
            d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
          />
          <circle cx="12" cy="12" r="3" />
        </svg>
      ` : n`
      <svg
        data-slot="password-input-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-eye-off-icon lucide-eye-off"
      >
        <path
          d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"
        />
        <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
        <path
          d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"
        />
        <path d="m2 2 20 20" />
      </svg>
    `;
	}
	render() {
		return n`
      <rtg-input-group
        data-slot="password-input"
        data-state=${this._showPassword ? "show" : "hide"}
      >
        <rtg-input-group-input
          data-slot="password-input-input"
          .autocomplete=${this.autocomplete}
          ?disabled=${this.disabled}
          .form=${this.form}
          id=${this._inputId && this._inputId !== "" ? this._inputId : r}
          ?invalid=${this.invalid}
          .maxlength=${this.maxlength}
          .minlength=${this.minlength}
          .name=${this.name}
          .pattern=${this.pattern}
          .placeholder=${this.placeholder}
          ?readonly=${this.readonly}
          ?required=${this.required}
          .type=${this._showPassword ? "text" : "password"}
          .value=${this.value}
          .onClick=${this.onClick}
          .onInput=${this.onInput}
          .onChange=${this.onChange}
          .onFocus=${this.onFocus}
          .onBlur=${this.onBlur}
        ></rtg-input-group-input>

        <rtg-input-group-addon
          data-slot="password-input-addon"
          align="inline-end"
        >
          <rtg-input-group-button
            data-slot="password-input-button"
            variant="ghost"
            size="icon-xs"
            ?disabled=${this.disabled}
            aria-label=${this._showPassword ? "Hide password" : "Show password"}
            .onClick=${this._handleToggle}
          >
            ${this._renderIcon()}
          </rtg-input-group-button>
        </rtg-input-group-addon>
      </rtg-input-group>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Q.prototype, "autocomplete", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Q.prototype, "disabled", void 0), C([o({ type: String }), S("design:type", String)], Q.prototype, "form", void 0), C([o({ type: String }), S("design:type", Object)], Q.prototype, "id", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Q.prototype, "invalid", void 0), C([o({ type: Number }), S("design:type", Number)], Q.prototype, "maxlength", void 0), C([o({ type: Number }), S("design:type", Number)], Q.prototype, "minlength", void 0), C([o({ type: String }), S("design:type", String)], Q.prototype, "name", void 0), C([o({ type: String }), S("design:type", String)], Q.prototype, "pattern", void 0), C([o({ type: String }), S("design:type", String)], Q.prototype, "placeholder", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Q.prototype, "readonly", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], Q.prototype, "required", void 0), C([o({ type: String }), S("design:type", String)], Q.prototype, "value", void 0), C([o({ attribute: !1 }), S("design:type", Function)], Q.prototype, "onClick", void 0), C([o({ attribute: !1 }), S("design:type", Function)], Q.prototype, "onInput", void 0), C([o({ attribute: !1 }), S("design:type", Function)], Q.prototype, "onChange", void 0), C([o({ attribute: !1 }), S("design:type", Function)], Q.prototype, "onFocus", void 0), C([o({ attribute: !1 }), S("design:type", Function)], Q.prototype, "onBlur", void 0), C([c(), S("design:type", Object)], Q.prototype, "_showPassword", void 0), Q = C([a("rtg-password-input")], Q);
//#endregion
//#region src/components/ui/progress/progress.styles.ts
var Ki = {
	root: [
		"rtg-relative rtg-overflow-hidden",
		"rtg-w-progress-space-w rtg-h-progress-space-h",
		"rtg-bg-progress-color-bg",
		"rtg-rounded-progress-radius"
	],
	indicator: [
		"rtg-flex-1",
		"rtg-w-progress-indicator-space-w rtg-h-progress-indicator-space-h",
		"rtg-bg-progress-indicator-color-bg",
		"rtg-transition-all"
	]
}, qi = class extends e {
	constructor(...e) {
		super(...e), this.value = 15;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="progress"
        aria-valuenow="${this.value}"
        aria-valuemax="100"
        aria-valuemin="0"
        role="progressbar"
        data-state="indeterminate"
        data-max="100"
        class="${P(Ki.root, this.className)}"
      >
        <div
          data-state="indeterminate"
          data-max="100"
          class="${P(Ki.indicator, this.className)}"
          style="transform: translateX(-${100 - (this.value || 0)}%);"
        ></div>
      </div>
    `;
	}
};
C([o({ type: Number }), S("design:type", Number)], qi.prototype, "value", void 0), qi = C([a("rtg-progress")], qi);
//#endregion
//#region src/components/ui/radio-group/radio-group.styles.ts
var Ji = {
	root: ["rtg-grid", "rtg-gap-radio-group-space-gap"],
	item: {
		wrapper: [
			"rtg-inline-flex",
			"rtg-justify-center rtg-items-center",
			"rtg-size-radio-group-item-space-size"
		],
		item: [
			"rtg-aspect-square",
			"rtg-shrink-0",
			"rtg-size-radio-group-item-space-size",
			"rtg-bg-radio-group-item-color-bg",
			"rtg-rounded-radio-group-item-radius rtg-border-radio-group-item-width-border rtg-border-radio-group-item-color-border rtg-outline-none",
			"rtg-transition-[color,box-shadow]",
			"focus-visible:rtg-border-radio-group-item-color-border-focus focus-visible:rtg-ring-radio-group-item-width-ring-focus focus-visible:rtg-ring-radio-group-item-color-ring-focus",
			"disabled:rtg-opacity-radio-group-item-opacity-disabled disabled:rtg-cursor-not-allowed",
			"aria-invalid:rtg-border-radio-group-item-color-border-invalid aria-invalid:rtg-ring-radio-group-item-width-ring-invalid aria-invalid:rtg-ring-radio-group-item-color-ring-invalid"
		],
		indicator: ["rtg-flex rtg-relative", "rtg-justify-center rtg-items-center"],
		icon: [
			"rtg-absolute rtg-top-1/2 rtg-left-1/2",
			"rtg-size-radio-group-indicator-space-size",
			"rtg--translate-x-1/2 rtg--translate-y-1/2",
			"rtg-fill-radio-group-indicator-color-fill"
		]
	}
}, Yi = "unChecked", Xi = class extends w {
	constructor(...e) {
		super(...e), this.checked = !1, this.tabindex = 0, this.value = "", this.id = "radio-group-item", this.state = Yi, this.disabled = !1, this.invalid = !1;
	}
	get _containerElement() {
		return this.querySelector("button[part=radio-group-item]");
	}
	_onClick(e) {
		e.defaultPrevented || this.checked || (this.checked = !0, this.dispatchEvent(new CustomEvent("radio-selected", {
			bubbles: !0,
			composed: !0
		})));
	}
	createRenderRoot() {
		return this.classList = P(Ji.item.wrapper), this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <button
        type="button"
        part="radio-group-item"
        role="radio"
        aria-checked="${this.checked}"
        aria-invalid=${this.invalid}
        data-state=${this.checked ? "checked" : "unchecked"}
        value="${this.value}"
        ?disabled=${this.disabled}
        @click="${this._onClick}"
        class=${P(Ji.item.item, this.className)}
        id="${this.id}"
        tabindex="${this.tabindex}"
      >
        ${this.checked ? n`<span
              data-slot="radio-group-indicator"
              part="radio-group-indicator"
              class=${P(Ji.item.indicator)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${P(Ji.item.icon, "lucide lucide-circle-icon lucide-circle")}
              >
                <circle cx="12" cy="12" r="10" />
              </svg>
            </span>` : r}
      </button>
    `;
	}
};
C([o({
	type: Boolean,
	reflect: !0
}), S("design:type", Object)], Xi.prototype, "checked", void 0), C([o({ type: Number }), S("design:type", Object)], Xi.prototype, "tabindex", void 0), C([o({ type: String }), S("design:type", Object)], Xi.prototype, "value", void 0), C([o({ type: String }), S("design:type", Object)], Xi.prototype, "id", void 0), C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], Xi.prototype, "state", void 0), C([o({ type: Boolean }), S("design:type", Object)], Xi.prototype, "disabled", void 0), C([o({
	attribute: "aria-invalid",
	type: Boolean
}), S("design:type", Object)], Xi.prototype, "invalid", void 0), Xi = C([a("rtg-radio-group-item")], Xi);
//#endregion
//#region src/components/ui/radio-group/radio-group.ts
var Zi = class extends w {
	constructor(...e) {
		super(...e), this.defaultValue = "";
	}
	get _containerElement() {
		return this.querySelector("div[part=radio-group]");
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("radio-selected", this._handleRadioSelected);
	}
	_handleRadioSelected(e) {
		this.querySelectorAll("rtg-radio-group-item").forEach((t) => {
			t !== e.target && (t.checked = !1);
		});
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return this.querySelectorAll("rtg-radio-group-item").forEach((e) => {
			e.checked = e.value == this.defaultValue;
		}), n`
      <div
        part="radio-group"
        class=${P(Ji.root, this.className)}
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Zi.prototype, "defaultValue", void 0), Zi = C([a("rtg-radio-group")], Zi);
//#endregion
//#region src/components/ui/scroll-area/scroll-area.style.ts
var Qi = [
	"rtg-relative",
	"rtg-border rtg-border-scrollarea-color-border",
	"rtg-bg-scrollarea-color-bg"
], $i = class extends w {
	createRenderRoot() {
		return this;
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this.viewportEl);
	}
	render() {
		return n`
      <div
        dir="ltr"
        data-slot="scroll-area"
        class=${P(Qi, this.className)}
      >
        <style>
          [data-radix-scroll-area-viewport] {
            -webkit-overflow-scrolling: touch;
          }

          /* Webkit scrollbar (Chrome/Safari) */
          [data-radix-scroll-area-viewport]::-webkit-scrollbar {
            width: 0px;
            height: 0px;
          }

          [data-radix-scroll-area-viewport]:hover::-webkit-scrollbar {
            width: var(--sb-sem-width-scrollbar-hover);
          }

          [data-radix-scroll-area-viewport]::-webkit-scrollbar-thumb {
            background-color: hsl(var(--sb-sem-color-border));
            border-radius: var(--sb-sem-radius-indicator);
          }

          [data-radix-scroll-area-viewport]::-webkit-scrollbar-track {
            background: transparent;
          }
        </style>
        <div
          data-radix-scroll-area-viewport
          data-slot="scroll-area-viewport"
          class="rtg-size-full"
          style="overflow: hidden scroll;"
        ></div>
      </div>
    `;
	}
};
C([s("[data-radix-scroll-area-viewport]"), S("design:type", typeof HTMLElement > "u" ? Object : HTMLElement)], $i.prototype, "viewportEl", void 0), $i = C([a("rtg-scroll-area")], $i);
//#endregion
//#region src/components/ui/select/select-controller.ts
var ea = class {
	constructor() {
		this.state = {
			isOpen: !1,
			selectedValue: "",
			selectedText: ""
		}, this.listeners = /* @__PURE__ */ new Set();
	}
	subscribe(e) {
		this.listeners.add(e);
	}
	unsubscribe(e) {
		this.listeners.delete(e);
	}
	notify() {
		this.listeners.forEach((e) => e());
	}
	get isOpen() {
		return this.state.isOpen;
	}
	get selectedValue() {
		return this.state.selectedValue;
	}
	get selectedText() {
		return this.state.selectedText;
	}
	open() {
		this.state.isOpen || (this.state.isOpen = !0, this.notify());
	}
	close() {
		this.state.isOpen && (this.state.isOpen = !1, this.notify());
	}
	toggle() {
		this.state.isOpen = !this.state.isOpen, this.notify();
	}
	select(e, t, n) {
		this.state.selectedValue = e, this.state.selectedText = t, this.state.isOpen = !1, this.notify();
	}
}, ta = {
	root: [""],
	group: [""],
	value: [
		"rtg-flex",
		"rtg-gap-select-value-space-gap rtg-items-center",
		"rtg-line-clamp-1"
	],
	trigger: {
		trigger: [
			"rtg-flex",
			"rtg-gap-select-trigger-space-gap rtg-justify-between rtg-items-center",
			"rtg-px-select-trigger-space-px rtg-py-select-trigger-space-py",
			"rtg-w-full rtg-h-select-trigger-space-h",
			"rtg-text-select-trigger-font rtg-whitespace-nowrap",
			"rtg-bg-select-trigger-color-bg",
			"rtg-rounded-select-trigger-radius rtg-border-select-trigger-width-border rtg-border-select-trigger-color-border rtg-outline-none",
			"rtg-transition-[color,box-shadow]",
			"hover:rtg-bg-select-trigger-color-bg-hover",
			"focus-visible:rtg-border-select-trigger-color-border-focus focus-visible:rtg-ring-select-trigger-width-ring-focus focus-visible:rtg-ring-select-trigger-color-ring-focus",
			"rtg-select-disabled:rtg-opacity-select-trigger-opacity-disabled rtg-select-disabled:rtg-cursor-not-allowed",
			"aria-invalid:rtg-border-select-trigger-color-border-invalid aria-invalid:rtg-ring-select-trigger-width-ring-invalid aria-invalid:rtg-ring-select-trigger-color-ring-invalid",
			"data-[placeholder]:rtg-text-select-trigger-placeholder-color-text"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-select-trigger-icon-space-size",
			"rtg-text-select-trigger-icon-color-text",
			"rtg-opacity-select-trigger-icon-opacity",
			"rtg-pointer-events-none"
		]
	},
	content: {
		content: [
			"rtg-absolute rtg-overflow-x-hidden rtg-overflow-y-auto rtg-z-50",
			"rtg-w-fit",
			"rtg-text-select-content-color-text",
			"rtg-bg-select-content-color-bg",
			"rtg-rounded-select-content-radius rtg-border-select-content-width-border rtg-border-select-content-color-border",
			"rtg-shadow-select-content-shadow",
			"rtg-slide-in-from-top-2",
			"rtg-translate-y-1",
			"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
			"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
		],
		viewport: [
			"rtg-p-select-content-viewport-space-p",
			"rtg-w-full",
			"rtg-scroll-my-1"
		]
	},
	label: ["rtg-px-select-label-space-px rtg-py-select-label-space-py", "rtg-text-select-label-font rtg-text-select-label-color-text"],
	item: {
		item: [
			"rtg-flex rtg-relative",
			"rtg-gap-select-item-space-gap rtg-items-center",
			"rtg-pl-select-item-space-pl rtg-pr-select-item-space-pr rtg-py-select-item-space-py",
			"rtg-w-full",
			"rtg-text-select-item-font",
			"rtg-rounded-select-item-radius rtg-outline-hidden",
			"rtg-cursor-default rtg-select-none",
			"hover:rtg-text-select-item-color-text-hover hover:rtg-bg-select-item-color-bg-hover",
			"focus:rtg-text-select-item-color-text-focus focus:rtg-bg-select-item-color-bg-focus",
			"data-[disabled]:rtg-opacity-select-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		indicator: [
			"rtg-flex rtg-absolute rtg-right-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-select-item-indicator-space-size"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-select-item-icon-space-size",
			"rtg-text-select-item-icon-color-text",
			"rtg-pointer-events-none"
		]
	},
	separator: [
		"rtg-mx-select-separator-space-mx rtg-my-select-separator-space-my",
		"rtg-h-select-separator-space-h",
		"rtg-bg-select-separator-color-bg",
		"rtg-pointer-events-none"
	]
}, na = class extends w {
	constructor(...e) {
		super(...e), this.uuid = T(), this.selectStore = new ea(), this.value = "", this.disabled = !1, this.handleClickOutside = (e) => {
			let t = this.querySelector("[data-select-uuid]"), n = e.target;
			t?.contains(n) || this.selectStore.close();
		};
	}
	updated(e) {
		super.updated(e), e.has("value") && this.value !== this.selectStore.selectedValue && this.syncValueToStore();
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("mousedown", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("mousedown", this.handleClickOutside), super.disconnectedCallback();
	}
	firstUpdated() {
		let e = this.querySelector("div[part=select]");
		this.moveLightDomChildrenInto(e), this.syncValueToStore();
	}
	syncValueToStore() {
		if (this.value) {
			let e = this.querySelector(`rtg-select-item[value="${this.value}"]`)?.textContent?.trim() || this.value;
			this.selectStore.select(this.value, e);
		} else this.selectStore.select("", "");
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select"
        data-select-uuid=${this.uuid}
        class=${P(ta.root, this.className)}
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], na.prototype, "value", void 0), C([o({
	type: Boolean,
	reflect: !0
}), S("design:type", Object)], na.prototype, "disabled", void 0), na = C([a("rtg-select")], na);
//#endregion
//#region src/components/ui/select/select-group.ts
var ra = class extends w {
	constructor(...e) {
		super(...e), this.focusedIndex = 0, this.childrenArray = [], this.onStoreChange = () => {
			let e = this._containerElement;
			e && (e.style.display = this._select.selectStore.isOpen ? "block" : "none", this._contentDiv && (this._contentDiv.style.display = this._select.selectStore.isOpen ? "block" : "none", this._select.selectStore.isOpen && requestAnimationFrame(() => {
				this.updateTriggerWidth();
			}))), this._select.selectStore.isOpen && this._select.selectStore.selectedValue && (this.focusedIndex = this.childrenArray.findIndex((e) => e.value === this._select.selectStore.selectedValue)), this.updateFocusedItem(), this.requestUpdate();
		}, this.handleKeyDown = (e) => {
			if (this._select.selectStore.isOpen) switch (e.preventDefault(), e.key) {
				case "ArrowDown":
					this.focusedIndex = (this.focusedIndex + 1) % this.childrenArray.length, this.updateFocusedItem();
					break;
				case "ArrowUp":
					this.focusedIndex = (this.focusedIndex - 1 + this.childrenArray.length) % this.childrenArray.length, this.updateFocusedItem();
					break;
				case "Enter":
					let e = this.childrenArray[this.focusedIndex], t = e.value, n = e.textContent?.trim() || "";
					this._select.selectStore.select(t, n);
					break;
			}
		};
	}
	get _select() {
		let e = this.parentElement;
		for (; e && !(e instanceof na);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), this._select.selectStore.subscribe(this.onStoreChange), document.addEventListener("keydown", this.handleKeyDown);
	}
	disconnectedCallback() {
		this._select.selectStore.unsubscribe(this.onStoreChange), document.removeEventListener("keydown", this.handleKeyDown), super.disconnectedCallback();
	}
	getTriggerButton() {
		let e = this._select;
		return e ? e.querySelector("button[part=select-trigger]") : null;
	}
	updateTriggerWidth() {
		let e = this.getTriggerButton(), t = this._contentDiv;
		if (e && t) {
			let n = e.offsetWidth;
			if (n > 0) {
				let e = Math.max(128, n);
				t.style.setProperty("--select-trigger-width", `${n}px`), t.style.setProperty("min-width", `${e}px`);
			}
		}
	}
	get _containerElement() {
		return this.querySelector("div[part=select-viewport]");
	}
	get _contentDiv() {
		return this.querySelector("div[data-slot=select-content]");
	}
	firstUpdated() {
		let e = Array.from(this.children).filter((e) => e.tagName.toLowerCase() === "rtg-select-item");
		this.childrenArray = e, e.forEach((e, t) => {
			e.tabIndex = t, e.selectItemIndex = t, e.isFocus = t === this.focusedIndex || e.value === this._select.selectStore.selectedValue, e.addEventListener("mouseover", (e) => this.handleMouseOver(e, t));
		}), this.moveLightDomChildrenInto(this._containerElement), requestAnimationFrame(() => {
			this.updateTriggerWidth();
		});
	}
	updateFocusedItem() {
		this.childrenArray.forEach((e, t) => {
			e.isFocus = t === this.focusedIndex, e.requestUpdate?.();
		});
	}
	handleMouseOver(e, t) {
		e.preventDefault(), this.focusedIndex = t;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select-group"
        data-slot="select-content"
        class="${P(ta.content.content, this.className)}"
        style=${"min-width: 128px; display: none;"}
      >
        <div
          part="select-viewport"
          class=${P(ta.content.viewport)}
        ></div>
      </div>
    `;
	}
};
C([c(), S("design:type", Object)], ra.prototype, "focusedIndex", void 0), ra = C([a("rtg-select-group")], ra);
//#endregion
//#region src/components/ui/select/select-item.ts
var ia = class extends w {
	constructor(...e) {
		super(...e), this.value = "", this.isSelected = !1, this.isFocus = !1, this.selectItemIndex = -1, this.onSelect = (e, t) => {}, this.class = "", this._onStoreChange = () => {
			this.isSelected = this.value.toLowerCase() === this._select.selectStore.selectedValue?.toLowerCase?.(), this.requestUpdate();
		}, this.handleClick = (e) => {
			e.stopPropagation();
			let t = this.getTextContent();
			this._select.selectStore.select(this.value, t), this.onSelect(this.value, this.selectItemIndex), this.dispatchEvent(new CustomEvent("change", {
				detail: { value: this.value },
				bubbles: !0,
				composed: !0
			}));
		};
	}
	get _select() {
		let e = this.parentElement;
		for (; e && !(e instanceof na);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), this._select.selectStore.subscribe(this._onStoreChange);
	}
	disconnectedCallback() {
		this._select.selectStore.unsubscribe(this._onStoreChange), super.disconnectedCallback();
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get _containerElement() {
		return this.querySelector("div[part=select-item-container]");
	}
	createRenderRoot() {
		return this;
	}
	getTextContent() {
		let e = this._containerElement;
		if (e && e.textContent) return e.textContent.trim();
		let t = this.querySelector("[part=select-item-indicator]"), n = this.cloneNode(!0);
		return t && n.querySelector("[part=select-item-indicator]")?.remove(), n.textContent?.trim() || "";
	}
	render() {
		return n`
      <div
        ${F(this.getFilteredAttributes())}
        part="select-item"
        @click=${this.handleClick}
        class=${P(ta.item.item, this.className)}
        data-hs-select-value=${this.value}
        aria-selected="${this.isSelected}"
        data-selected="${this.isSelected}"
      >
        ${this.isSelected ? n`
              <span
                part="select-item-indicator"
                class=${P(ta.item.indicator)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${P(ta.item.icon, "lucide lucide-check-icon lucide-check")}
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              </span>
            ` : ""}

        <div part="select-item-container"></div>
      </div>
    `;
	}
};
C([o(), S("design:type", Object)], ia.prototype, "value", void 0), C([o(), S("design:type", Object)], ia.prototype, "isSelected", void 0), C([o(), S("design:type", Object)], ia.prototype, "isFocus", void 0), C([o(), S("design:type", Object)], ia.prototype, "selectItemIndex", void 0), C([o({ type: Function }), S("design:type", Object)], ia.prototype, "onSelect", void 0), C([o(), S("design:type", Object)], ia.prototype, "class", void 0), ia = C([a("rtg-select-item")], ia);
//#endregion
//#region src/components/ui/select/select-label.ts
var aa = class extends w {
	get _containerElement() {
		return this.querySelector("div[part=select-label]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select-label"
        class=${P(ta.label, this.className)}
      ></div>
    `;
	}
};
aa = C([a("rtg-select-label")], aa);
//#endregion
//#region src/components/ui/select/select-list.ts
var oa = class extends w {
	constructor(...e) {
		super(...e), this.state = ir, this.isOpen = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=select-list]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select-list"
        class="${P("rtg-absolute rtg-z-50 rtg-max-h-72 rtg-w-full rtg-overflow-hidden rtg-overflow-y-auto rtg-rounded-lg rtg-border rtg-border-input rtg-bg-background p-1 [&::-webkit-scrollbar-thumb]:rtg-rounded-full [&::-webkit-scrollbar-thumb]:rtg-bg-accent [&::-webkit-scrollbar-track]:rtg-bg-gray-100 [&::-webkit-scrollbar]:rtg-w-2", this.className)}"
        data-hs-combo-box-output=""
        data-state="${this.state}"
        style="display: ${this.isOpen ? "block" : "none"}; top:115%"
      ></div>
    `;
	}
};
C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], oa.prototype, "state", void 0), C([c(), S("design:type", Object)], oa.prototype, "isOpen", void 0), oa = C([a("rtg-select-list")], oa);
//#endregion
//#region src/components/ui/select/select-seperator.ts
var sa = class extends e {
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        rtgcmd-separator
        part="select-separator"
        role="separator"
        class=${P(ta.separator, this.className)}
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], sa.prototype, "_id", void 0), C([o({
	attribute: "aria-hidden",
	type: String
}), S("design:type", Object)], sa.prototype, "_hidden", void 0), sa = C([a("rtg-select-separator")], sa);
//#endregion
//#region src/components/ui/select/select-trigger.ts
var ca = class extends w {
	constructor(...e) {
		super(...e), this.onStoreChange = () => {
			this.requestUpdate();
		}, this.handleClick = (e) => {
			e.stopPropagation(), !(this._select && this._select.disabled) && this._select && this._select.selectStore.toggle();
		};
	}
	get _select() {
		let e = this.parentElement;
		for (; e && !(e instanceof na);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), this._select.selectStore.subscribe(this.onStoreChange), this.classObserver = new MutationObserver(() => {
			this.requestUpdate();
		}), this.classObserver.observe(this, {
			attributes: !0,
			attributeFilter: ["class"]
		}), this._select && (this.parentObserver = new MutationObserver(() => {
			this.requestUpdate();
		}), this.parentObserver.observe(this._select, {
			attributes: !0,
			attributeFilter: ["disabled"]
		}));
	}
	disconnectedCallback() {
		this._select.selectStore.unsubscribe(this.onStoreChange), this.classObserver?.disconnect(), this.parentObserver?.disconnect();
	}
	get _containerElement() {
		return this.querySelector("span[part=select-trigger-container]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this._containerElement?.addEventListener("click", this.handleClick);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	getClassAttribute() {
		let e = this.getAttribute("class") || "", t = this.customClass || "", n = this.className || "";
		return e || t || n || "";
	}
	filterConflictingWidthClasses(e, t) {
		let n = /rtg-w-[\w-[\]]+/;
		return n.test(t) ? e.map((e) => e.split(/\s+/).filter((e) => !n.test(e)).join(" ")) : e;
	}
	render() {
		let e = this.getClassAttribute(), t = this.filterConflictingWidthClasses(ta.trigger.trigger, e), r = this._select?.disabled || !1;
		return n`
      <button
        type="button"
        part="select-trigger"
        role="tab"
        class=${P(...t, e, r ? "rtg-opacity-select-trigger-opacity-disabled rtg-cursor-not-allowed" : "")}
        tabindex=${r ? "-1" : "0"}
        ?disabled=${r}
        data-orientation="horizontal"
        data-radix-collection-item=""
        ?data-placeholder=${this._select.selectStore.selectedValue.length === 0}
        @click="${this.handleClick}"
      >
        <span part="select-trigger-container"></span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class=${P(ta.trigger.icon, "lucide lucide-chevron-down-icon lucide-chevron-down")}
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>
    `;
	}
};
ca = C([a("rtg-select-trigger")], ca);
//#endregion
//#region src/components/ui/select/select-value.ts
var la = class extends w {
	constructor(...e) {
		super(...e), this.placeholder = "select a value", this.onStoreChange = () => {
			this.requestUpdate();
		}, this.renderLabel = () => {
			let e = this._select?.selectStore;
			return e && e.selectedValue !== void 0 && e.selectedValue !== "" ? e.selectedText || e.selectedValue : this.placeholder;
		};
	}
	get _select() {
		let e = this.parentElement;
		for (; e && !(e instanceof na);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), this._select.selectStore.subscribe(this.onStoreChange), document.addEventListener("clicked-select-item", () => {
			this.requestUpdate();
		});
	}
	disconnectedCallback() {
		this._select.selectStore.unsubscribe(this.onStoreChange);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <span part="select-value" class=${P(ta.value, this.className)}>
        ${this.renderLabel()}
      </span>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], la.prototype, "placeholder", void 0), la = C([a("rtg-select-value")], la);
//#endregion
//#region src/components/ui/skeleton/skeleton.style.ts
var ua = "rtg-bg-skeleton-color-bg rtg-animate-skeleton-animate rtg-rounded-skeleton-radius", da = class extends w {
	createRenderRoot() {
		return this;
	}
	render() {
		return n` <div class=${P(ua, this.className)}></div> `;
	}
};
da = C([a("rtg-skeleton")], da);
//#endregion
//#region src/components/ui/spinner/_spinner.ts
var fa = class extends e {
	constructor(...e) {
		super(...e), this.variant = "circle";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return this.variant === "basic" ? n`
        <svg
          data-slot="spinner"
          data-variant="basic"
          role="status"
          aria-label="Loading"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-loader-icon lucide-loader"
        >
          <path d="M12 2v4" />
          <path d="m16.2 7.8 2.9-2.9" />
          <path d="M18 12h4" />
          <path d="m16.2 16.2 2.9 2.9" />
          <path d="M12 18v4" />
          <path d="m4.9 19.1 2.9-2.9" />
          <path d="M2 12h4" />
          <path d="m4.9 4.9 2.9 2.9" />
        </svg>
      ` : this.variant === "pinwheel" ? n`
        <svg
          data-slot="spinner"
          data-variant="pinwheel"
          role="status"
          aria-label="Loading"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-loader-pinwheel-icon lucide-loader-pinwheel"
        >
          <path d="M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0" />
          <path d="M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6" />
          <path d="M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6" />
          <circle cx="12" cy="12" r="10" />
        </svg>
      ` : n`
      <svg
        data-slot="spinner"
        data-variant="circle"
        role="status"
        aria-label="Loading"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-loader-circle-icon lucide-loader-circle"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], fa.prototype, "variant", void 0), fa = C([a("rtg-spinner")], fa);
//#endregion
//#region src/components/ui/switch/switch.style.ts
var pa = {
	root: [
		"rtg-inline-flex",
		"rtg-shrink-0 rtg-items-center",
		"rtg-w-switch-space-w rtg-h-switch-space-h",
		"rtg-rounded-switch-radius rtg-border-switch-width-border rtg-border-switch-color-border rtg-outline-none",
		"rtg-transition-all",
		"focus-visible:rtg-border-switch-color-border-focus focus-visible:rtg-ring-switch-width-ring-focus focus-visible:rtg-ring-switch-color-ring-focus",
		"data-[state=\"checked\"]:rtg-bg-switch-color-bg-checked data-[state=\"unchecked\"]:rtg-bg-switch-color-bg-unchecked",
		"data-[disabled=\"true\"]:rtg-opacity-switch-opacity-disabled data-[disabled=\"true\"]:rtg-cursor-not-allowed"
	],
	thumb: [
		"rtg-pointer-events-none",
		"rtg-block",
		"rtg-size-switch-thumb-space-size",
		"rtg-rounded-switch-thumb-radius",
		"rtg-ring-0",
		"rtg-transition-transform",
		"data-[state=\"checked\"]:rtg-bg-switch-thumb-color-bg-checked data-[state=\"unchecked\"]:rtg-bg-switch-thumb-color-bg-unchecked",
		"data-[state=\"checked\"]:rtg-translate-x-[calc(100%-2px)] data-[state=\"unchecked\"]:rtg-translate-x-0"
	]
}, ma = class extends e {
	constructor(...e) {
		super(...e), this.disabled = "false", this.state = "unchecked";
	}
	_toggleChecked() {
		this.disabled === "false" && (this.state = this.state === "checked" ? "unchecked" : "checked", this.dispatchEvent(new CustomEvent("change", { detail: this.state })));
	}
	createRenderRoot() {
		return this.classList = "rtg-w-switch-space-w rtg-h-switch-space-h", this;
	}
	render() {
		return n`
      <div
        part="switch"
        role="switch"
        data-testid="switch-atom"
        data-disabled=${this.disabled}
        data-state=${this.state}
        @click="${this._toggleChecked}"
        class=${P(pa.root, this.className)}
      >
        <div
          part="switch-thumb"
          data-state=${this.state}
          class=${P(pa.thumb)}
        ></div>
      </div>
    `;
	}
};
C([o({
	attribute: "data-disabled",
	type: String
}), S("design:type", String)], ma.prototype, "disabled", void 0), C([o({
	attribute: "data-state",
	type: String
}), S("design:type", String)], ma.prototype, "state", void 0), ma = C([a("rtg-switch")], ma);
//#endregion
//#region src/components/ui/table/table.styles.ts
var $ = {
	preview: ["rtg-flex rtg-bg-table-preview-color-bg rtg-w-table-preview-space-w rtg-items-center rtg-justify-center rtg-px-table-preview-space-px rtg-py-table-preview-space-py"],
	container: ["rtg-relative rtg-w-table-container-space-w rtg-overflow-auto"],
	table: ["rtg-w-table-space-w rtg-caption-bottom rtg-text-table-font"],
	caption: ["rtg-mt-table-caption-space-mt rtg-text-table-caption-font rtg-text-table-caption-color-text"],
	head: {
		root: ["[&_tr]:rtg-border-table-head-color-border [&_tr]:rtg-border-b-table-head-width-border"],
		row: ["rtg-border-b-table-head-width-border rtg-border-table-head-color-border rtg-transition-colors hover:rtg-bg-table-head-row-color-bg-hover"],
		cell: {
			base: ["rtg-h-table-head-cell-space-h rtg-px-table-head-cell-space-px rtg-align-middle rtg-font-table-head-cell-font-weight rtg-text-table-head-cell-color-text"],
			align: {
				left: "rtg-text-left",
				right: "rtg-text-right"
			}
		}
	},
	body: {
		root: ["[&_tr:last-child]:rtg-border-0"],
		row: ["rtg-border-b-table-body-width-border rtg-border-table-body-color-border rtg-transition-colors hover:rtg-bg-table-body-row-color-bg-hover"],
		cell: {
			base: ["rtg-px-table-body-cell-space-px rtg-py-table-body-cell-space-py rtg-align-middle"],
			align: {
				right: "rtg-text-right",
				left: "rtg-text-left"
			}
		}
	},
	footer: {
		root: ["rtg-border-t-table-footer-width-border rtg-border-table-footer-color-border rtg-bg-table-footer-color-bg rtg-font-table-footer-font-weight [&>tr]:rtg-last:border-b-0"],
		row: ["rtg-border-b-table-footer-width-border rtg-border-table-footer-color-border rtg-transition-colors hover:rtg-bg-table-footer-row-color-bg-hover"],
		cell: {
			base: ["rtg-px-table-footer-cell-space-px rtg-py-table-footer-cell-space-py rtg-align-middle"],
			align: {
				right: "rtg-text-right",
				left: "rtg-text-left"
			}
		}
	}
}, ha = class extends w {
	constructor(...e) {
		super(...e), this.dataTable = [], this.footerData = [], this.captionText = "";
	}
	get _containerElement() {
		return this.querySelector("table[part=table]");
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get columnKeys() {
		let e = this.dataTable?.[0];
		return e ? Object.keys(e).filter((e) => e !== "id") : [];
	}
	capitalizeLabel(e) {
		return e.charAt(0).toUpperCase() + e.slice(1);
	}
	render() {
		let e = this.columnKeys;
		return n`
      <div class=${P($.preview)}>
        <div class=${P($.container)}>
          <table part="table" class=${P($.table)}>
            ${this.captionText ? n`
                  <caption class=${P($.caption)}>
                    ${this.captionText}
                  </caption>
                ` : null}

            <thead class=${P($.head.root)}>
              <tr class=${P($.head.row)}>
                ${e.map((e, t, r) => {
			let i = t === r.length - 1;
			return n`
                    <th
                      class=${P($.head.cell.base, i ? $.head.cell.align.right : $.head.cell.align.left)}
                    >
                      ${this.capitalizeLabel(e)}
                    </th>
                  `;
		})}
              </tr>
            </thead>

            <tbody class=${P($.body.root)}>
              ${this.dataTable.map((t) => n`
                  <tr
                    data-id=${t.id ?? ""}
                    class=${P($.body.row)}
                  >
                    ${e.map((e, r, i) => {
			let a = r === i.length - 1;
			return n`
                        <td
                          class=${P($.body.cell.base, a && $.body.cell.align.right)}
                        >
                          ${t[e] ?? ""}
                        </td>
                      `;
		})}
                  </tr>
                `)}
            </tbody>

            ${this.footerData.length ? n`
                  <tfoot class=${P($.footer.root)}>
                    <tr class=${P($.footer.row)}>
                      ${e.map((e, t, r) => {
			let i = t === r.length - 1, a = this.footerData.find((t) => t.key === e);
			return n`
                          <td
                            class=${P($.footer.cell.base, i && $.footer.cell.align.right)}
                          >
                            ${a?.value ?? ""}
                          </td>
                        `;
		})}
                    </tr>
                  </tfoot>
                ` : null}
          </table>
        </div>
      </div>
    `;
	}
};
C([o({ type: Array }), S("design:type", typeof Array > "u" ? Object : Array)], ha.prototype, "dataTable", void 0), C([o({ type: Array }), S("design:type", typeof Array > "u" ? Object : Array)], ha.prototype, "footerData", void 0), C([o({ type: String }), S("design:type", String)], ha.prototype, "captionText", void 0), ha = C([a("rtg-table")], ha);
//#endregion
//#region src/components/ui/tabs/tabs.helpers.ts
function ga() {
	return `rtg-${Date.now().toString(36)}${Math.random().toString(36).substring(2, 7)}`;
}
function _a(e, t) {
	return `${e}-trigger-${t}`;
}
function va(e, t) {
	return `${e}-content-${t}`;
}
//#endregion
//#region src/components/ui/tabs/_tabs.ts
var ya = class extends e {
	constructor(...e) {
		super(...e), this._initialSyncDone = !1, this.orientation = "horizontal", this.dir = "ltr", this.activationMode = "automatic", this._baseId = ga(), this._onTriggerSelect = (e) => {
			let t = e.detail.value;
			this._isControlled ? this.onValueChange?.(t) : this._activeValue = t;
		};
	}
	connectedCallback() {
		super.connectedCallback(), this._mutationObserver = new MutationObserver(() => {
			this._sync();
		}), this._mutationObserver.observe(this, {
			childList: !0,
			subtree: !0
		});
	}
	disconnectedCallback() {
		this._mutationObserver?.disconnect(), super.disconnectedCallback();
	}
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"tabs\"]");
	}
	get _list() {
		return this.querySelector("rtg-tabs-list");
	}
	get _triggers() {
		return Array.from(this.querySelectorAll("rtg-tabs-trigger"));
	}
	get _contents() {
		return Array.from(this.querySelectorAll("rtg-tabs-content"));
	}
	get _isControlled() {
		return this.value !== void 0;
	}
	get _currentValue() {
		return this._isControlled ? this.value : this._activeValue;
	}
	_sync() {
		if (!this._rootSlot) return;
		if (this._list?._listSlot) {
			let e = this._list._listSlot;
			e.setAttribute("data-orientation", this.orientation), e.setAttribute("aria-orientation", this.orientation);
		}
		let e = this._triggers, t = this._contents;
		e.length !== 0 && (!this._initialSyncDone && !this._isControlled && !this._activeValue && (this._activeValue = this.defaultValue ?? e[0]?.value, this._initialSyncDone = !0), e.forEach((e) => {
			let n = e._triggerSlot;
			if (!n) return;
			n.setAttribute("data-orientation", this.orientation), n.id ||= _a(this._baseId, e.value);
			let r = e.value === this._currentValue;
			n.setAttribute("data-state", r ? "active" : "inactive"), n.tabIndex = r ? 0 : -1, n.setAttribute("aria-selected", String(r));
			let i = t.find((t) => t.value === e.value);
			i?._contentSlot && (i._contentSlot.id ||= va(this._baseId, i.value), i._contentSlot.setAttribute("aria-labelledby", n.id), n.setAttribute("aria-controls", i._contentSlot.id));
		}), t.forEach((e) => {
			let t = e._contentSlot;
			if (!t) return;
			t.setAttribute("data-orientation", this.orientation);
			let n = e.value === this._currentValue;
			t.setAttribute("data-state", n ? "active" : "inactive"), t.toggleAttribute("hidden", !n);
		}));
	}
	async firstUpdated() {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		}), this.addEventListener("rtg-tabs:trigger-select", this._onTriggerSelect), await this.updateComplete, await new Promise((e) => setTimeout(e, 0)), this._sync();
	}
	updated(e) {
		e.has("value") && this._isControlled && (this._activeValue = this.value), this._sync();
	}
	render() {
		return n`
      <div
        data-slot="tabs"
        data-orientation=${this.orientation}
        dir=${this.dir}
      ></div>
    `;
	}
};
C([o({
	attribute: "default-value",
	type: String
}), S("design:type", String)], ya.prototype, "defaultValue", void 0), C([o({ type: String }), S("design:type", String)], ya.prototype, "value", void 0), C([o({ attribute: !1 }), S("design:type", Function)], ya.prototype, "onValueChange", void 0), C([o({ type: String }), S("design:type", Object)], ya.prototype, "orientation", void 0), C([o({ type: String }), S("design:type", Object)], ya.prototype, "dir", void 0), C([o({
	attribute: "activation-mode",
	type: String
}), S("design:type", Object)], ya.prototype, "activationMode", void 0), C([c(), S("design:type", String)], ya.prototype, "_activeValue", void 0), ya = C([a("rtg-tabs")], ya);
//#endregion
//#region src/components/ui/tabs/_tabs-list.ts
var ba = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _listSlot() {
		return this.querySelector("[data-slot=\"tabs-list\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._listSlot && this._listSlot?.appendChild(e);
		});
	}
	render() {
		return n`
      <div
        data-slot="tabs-list"
        data-variant=${this.variant}
        role="tablist"
        tabindex="0"
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], ba.prototype, "variant", void 0), ba = C([a("rtg-tabs-list")], ba);
//#endregion
//#region src/components/ui/tabs/_tabs-trigger.ts
var xa = class extends e {
	constructor(...e) {
		super(...e), this.value = "", this._onClick = () => {
			this._emitSelect();
		}, this._onKeyDown = (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), this._emitSelect());
		};
	}
	createRenderRoot() {
		return this;
	}
	get _triggerSlot() {
		return this.querySelector("[data-slot=\"tabs-trigger\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._triggerSlot && this._triggerSlot?.appendChild(e);
		});
	}
	_emitSelect() {
		this.disabled || this.dispatchEvent(new CustomEvent("rtg-tabs:trigger-select", {
			detail: { value: this.value },
			bubbles: !0
		}));
	}
	render() {
		return n`
      <button
        data-slot="tabs-trigger"
        ?data-disabled=${this.disabled}
        role="tab"
        type="button"
        ?disabled=${this.disabled}
        @click=${this._onClick}
        @keydown=${this._onKeyDown}
      ></button>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], xa.prototype, "value", void 0), C([o({ type: Boolean }), S("design:type", Boolean)], xa.prototype, "disabled", void 0), xa = C([a("rtg-tabs-trigger")], xa);
//#endregion
//#region src/components/ui/tabs/_tabs-content.ts
var Sa = class extends e {
	constructor(...e) {
		super(...e), this.value = "";
	}
	createRenderRoot() {
		return this;
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"tabs-content\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._contentSlot && this._contentSlot?.appendChild(e);
		});
	}
	render() {
		return n`
      <div
        data-slot="tabs-content"
        role="tabpanel"
        tabindex="0"
        hidden
      ></div>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Sa.prototype, "value", void 0), Sa = C([a("rtg-tabs-content")], Sa);
//#endregion
//#region src/components/ui/toast/toast.style.ts
var Ca = {
	viewportRoot: ["rtg-fixed rtg-top-0 rtg-z-[100] rtg-flex rtg-max-h-screen rtg-w-toast-viewport-root-space-w rtg-flex-col-reverse rtg-px-toast-viewport-root-space-px rtg-py-toast-viewport-root-space-py sm:rtg-bottom-0 sm:rtg-right-0 sm:rtg-top-auto sm:rtg-flex-col md:rtg-max-w-toast-viewport-root-space-w-md"],
	viewportItem: {
		base: [
			"group rtg-pointer-events-auto rtg-relative rtg-flex rtg-w-toast-viewport-item-space-w rtg-items-center rtg-justify-between rtg-gap-toast-viewport-item-space-gap rtg-overflow-hidden rtg-rounded-toast-viewport-item-radius rtg-px-toast-viewport-item-space-px rtg-py-toast-viewport-item-space-py rtg-shadow-toast-viewport-item-shadow rtg-transition-all",
			"data-[swipe=cancel]:rtg-translate-x-0",
			"data-[swipe=end]:rtg-translate-x-[var(--radix-toast-swipe-end-x)]",
			"data-[swipe=move]:rtg-translate-x-[var(--radix-toast-swipe-move-x)]",
			"data-[swipe=move]:rtg-transition-none",
			"data-[state=open]:rtg-animate-toast-animate-in",
			"data-[state=closed]:rtg-animate-toast-animate-out",
			"data-[swipe=end]:rtg-animate-toast-animate-out",
			"data-[state=closed]:rtg-opacity-80",
			"data-[state=open]:rtg-translate-y-toast-viewport-item-translate-y-enter-desktop",
			"data-[state=open]:sm:rtg-translate-y-toast-viewport-item-translate-y-enter-mobile",
			"data-[state=closed]:rtg-translate-x-toast-viewport-item-translate-x-exit"
		],
		variants: {
			default: ["rtg-border rtg-border-toast-viewport-default-color-border rtg-bg-toast-viewport-default-color-bg rtg-text-toast-viewport-default-color-text"],
			destructive: ["rtg-bg-toast-viewport-destructive-color-bg rtg-text-toast-viewport-destructive-color-text"]
		}
	},
	action: {
		base: [
			"rtg-text-toast-action-font rtg-font-toast-action-font-weight rtg-text-toast-action-color-text",
			"rtg-h-toast-action-space-h rtg-px-toast-action-space-px rtg-py-toast-action-space-py",
			"rtg-inline-flex rtg-border rtg-border-toast-action-color-border rtg-shrink-0 rtg-items-center rtg-justify-center rtg-rounded-toast-action-radius rtg-transition-colors",
			"focus:rtg-outline-none focus:rtg-ring-toast-action-width-ring-focus focus:rtg-ring-toast-action-color-ring-focus",
			"disabled:rtg-pointer-events-none disabled:rtg-opacity-toast-action-opacity-disabled"
		],
		variants: {
			default: ["rtg-bg-toast-action-default-color-bg hover:rtg-bg-toast-action-default-color-bg-hover"],
			destructive: ["rtg-bg-toast-action-destructive-color-bg hover:rtg-bg-toast-action-destructive-color-bg-hover rtg-text-toast-action-destructive-color-text focus:rtg-ring-toast-action-destructive-color-ring-focus"]
		}
	},
	title: ["rtg-text-toast-title-font rtg-font-toast-title-font-weight [&+div]:rtg-text-toast-title-font"],
	description: ["rtg-text-toast-description-font rtg-opacity-toast-description-opacity"]
}, wa, Ta = "closed", Ea = class extends w {
	static {
		wa = this;
	}
	constructor(...e) {
		super(...e), this.variant = "default", this.state = Ta;
	}
	static {
		this.toastVariants = Ca.viewportItem;
	}
	get _containerElement() {
		return this.querySelector("li[part=toast-view-port-li]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n` <ol
      part="toast-view-port"
      tabindex="-1"
      @click="${(e) => e.stopPropagation()}"
      class="${P(Ca.viewportRoot, this.className, `${this.state === Ta ? "hidden" : "block"}  `)}"
    >
      <li
        part="toast-view-port-li"
        role="status"
        aria-live="off"
        aria-atomic="true"
        tabindex="0"
        data-state="${this.state}"
        data-swipe-direction="right"
        class="${P(wa.toastVariants.base, wa.toastVariants.variants[this.variant], this.className)}"
        data-radix-collection-item=""
        style="user-select: none; touch-action: none;"
      ></li>
    </ol>`;
	}
};
C([o({ type: String }), S("design:type", Object)], Ea.prototype, "variant", void 0), C([o({
	attribute: "data-state",
	type: String
}), S("design:type", Object)], Ea.prototype, "state", void 0), Ea = wa = C([a("rtg-toast-view-port")], Ea);
//#endregion
//#region src/components/ui/toast/toast-action.ts
var Da, Oa = class extends w {
	static {
		Da = this;
	}
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	static {
		this.toastVariants = Ca.action;
	}
	get _containerElement() {
		return this.querySelector("button[part=toast-action]");
	}
	getAttributesToExclude() {
		return [
			"click",
			"type",
			"variant"
		];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	getFilteredAttributes() {
		let e = this.getAttributesToExclude(), t = {};
		for (let n of this.attributes) e.includes(n.name) || (t[n.name] = n.value);
		return t;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <button
        ${F(this.getFilteredAttributes())}
        part="toast-action"
        type="button"
        class="${P(Da.toastVariants.base, Da.toastVariants.variants[this.variant], this.className, "rtg-w-max")}"
      ></button>
    `;
	}
};
C([o({ type: String }), S("design:type", Object)], Oa.prototype, "variant", void 0), Oa = Da = C([a("rtg-toast-action")], Oa);
//#endregion
//#region src/components/ui/toast/toast-description.ts
var ka = class extends w {
	get _containerElement() {
		return this.querySelector("div[part=toast-description]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        class="${P(Ca.description, this.className)}"
        part="toast-description"
      >
        <slot></slot>
      </div>
    `;
	}
};
ka = C([a("rtg-toast-description")], ka);
//#endregion
//#region src/components/ui/toast/toast-title.ts
var Aa = class extends w {
	get _containerElement() {
		return this.querySelector("div[part=toast-title]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="toast-title"
        class="${P(Ca.title, this.className)}"
      ></div>
    `;
	}
};
Aa = C([a("rtg-toast-title")], Aa);
//#endregion
//#region src/components/ui/toast/toast-trigger.ts
var ja = class extends w {
	constructor() {
		super(), this.handleClick = this.handleClick.bind(this);
	}
	get _containerElement() {
		return this.querySelector("div[part=toast-trigger]");
	}
	get _toast() {
		let e = this.parentElement;
		for (; e && !(e instanceof Ma);) e = e.parentElement;
		return e;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	handleClick(e) {
		e.stopPropagation(), this.dispatchEvent(new CustomEvent("open-toast", { bubbles: !0 })), this._toast.isOpen = !0;
	}
	render() {
		return n`
      <div
        @click=${this.handleClick}
        part="toast-trigger"
        class="${P(this.className)}"
      ></div>
    `;
	}
};
ja = C([a("rtg-toast-trigger"), S("design:paramtypes", [])], ja);
//#endregion
//#region src/components/ui/toast/toast.ts
var Ma = class extends w {
	constructor(...e) {
		super(...e), this.isOpen = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=toast]");
	}
	onClick() {
		this.isOpen = !this.isOpen;
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("close-toast", () => {
			this.isOpen = !1;
		}), this.addEventListener("open-toast", () => {
			this.isOpen = !0;
		});
	}
	get _content() {
		return this.querySelector("rtg-toast-view-port");
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "closed");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n` <div class="${P("", this.className)}" part="toast"></div> `;
	}
};
C([c(), S("design:type", Object)], Ma.prototype, "isOpen", void 0), Ma = C([a("rtg-toast")], Ma);
//#endregion
//#region src/components/ui/toggle-group/toggle-group.defs.ts
var Na = /* @__PURE__ */ function(e) {
	return e.MULTIPLE = "multiple", e.SINGLE = "single", e;
}({}), Pa = /* @__PURE__ */ function(e) {
	return e.DEFAULT = "default", e.OUTLINE = "outline", e;
}({}), Fa = /* @__PURE__ */ function(e) {
	return e.SMALL = "sm", e.MEDIUM = "md", e.LARGE = "lg", e;
}({}), Ia = jt("rtg-inline-flex rtg-items-center rtg-justify-center rtg-rounded-toggle-group-item-radius rtg-text-toggle-group-item-font rtg-font-toggle-group-item-font-weight rtg-transition-colors focus-visible:rtg-outline-none focus-visible:rtg-ring-toggle-group-item-width-ring-focus focus-visible:rtg-ring-toggle-group-item-color-ring-focus focus-visible:rtg-ring-offset-toggle-group-item-width-ring-offset-focus disabled:rtg-pointer-events-none disabled:rtg-opacity-toggle-group-item-opacity-disabled data-[state=on]:rtg-bg-toggle-group-item-color-bg-on data-[state=on]:rtg-text-toggle-group-item-color-text-on rtg-bg-transparent", { variants: {
	variant: {
		default: "hover:rtg-bg-toggle-group-item-default-color-bg-hover hover:rtg-text-toggle-group-item-default-color-text-hover",
		outline: "rtg-border rtg-border-toggle-group-item-outline-color-border hover:rtg-bg-toggle-group-item-outline-color-bg-hover hover:rtg-text-toggle-group-item-outline-color-text-hover"
	},
	size: {
		sm: "rtg-h-toggle-group-item-space-h-sm rtg-px-toggle-group-item-space-px-sm",
		md: "rtg-h-toggle-group-item-space-h-md rtg-px-toggle-group-item-space-px-md",
		lg: "rtg-h-toggle-group-item-space-h-lg rtg-px-toggle-group-item-space-px-lg"
	}
} }), La = "rtg-flex rtg-items-center rtg-justify-center rtg-gap-toggle-group-space-gap", Ra, za = class extends w {
	static {
		Ra = this;
	}
	get _parent() {
		let e = this.parentElement;
		for (; e && !(e instanceof Ba);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("button[part=toggle-group-item]");
	}
	get _siblings() {
		return Array.from(this.parentElement?.children || []).filter((e) => e !== this);
	}
	static {
		this.toggleGroupVariants = Ia;
	}
	getAttributesToExclude() {
		return ["disabled", "type"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.syncFromParent(), this.moveLightDomChildrenInto(this._containerElement);
	}
	constructor() {
		super(), this.checked = !1, this.id = T(), this.variant = Pa.DEFAULT, this.size = Fa.SMALL, this.disabled = !1, this.type = Na.SINGLE, this.variant = Pa.DEFAULT, this.size = Fa.SMALL;
	}
	syncFromParent() {
		let e = this._parent;
		if (!e) return;
		this.variant !== e.variant && (this.variant = e.variant), this.size !== e.size && (this.size = e.size);
		let t = e.selectedItems.includes(this.id);
		this.checked !== t && (this.checked = t), this.type !== e.type && (this.type = e.type);
	}
	syncSelection() {
		let e = this._parent;
		if (!e) return;
		let t = e.selectedItems.includes(this.id);
		this.checked !== t && (this.checked = t);
	}
	toggleSelection(e) {
		if (this.disabled || !this._parent) return;
		let t = this._parent, n = t.selectedItems.indexOf(e);
		this.type === Na.SINGLE ? (n === -1 ? t.selectedItems[0] = e : t.selectedItems.splice(n, 1), this._siblings.forEach((e) => e.syncSelection())) : n === -1 ? t.selectedItems.push(e) : t.selectedItems.splice(n, 1), this.syncSelection();
	}
	render() {
		return console.log({
			variant: this.variant,
			size: this.size,
			className: this.className
		}), g`
      <button
        part="toggle-group-item"
        id=${this.id}
        type="button"
        class="${P(Ra.toggleGroupVariants({
			variant: this.variant,
			size: this.size,
			className: this.className
		}))}"
        aria-pressed=${this.checked}
        data-state="${this.checked ? "on" : "off"}"
        ?disabled=${this.disabled}
        @click=${() => this.toggleSelection(this.id)}
      ></button>
    `;
	}
};
C([o({
	attribute: !0,
	type: Boolean,
	reflect: !0
}), S("design:type", Object)], za.prototype, "checked", void 0), C([o({
	attribute: !0,
	type: String,
	reflect: !0
}), S("design:type", Object)], za.prototype, "id", void 0), C([o(), S("design:type", Pa === void 0 ? Object : Pa)], za.prototype, "variant", void 0), C([o(), S("design:type", Fa === void 0 ? Object : Fa)], za.prototype, "size", void 0), C([o({ type: Boolean }), S("design:type", Object)], za.prototype, "disabled", void 0), C([o({ type: String }), S("design:type", Na === void 0 ? Object : Na)], za.prototype, "type", void 0), za = Ra = C([a("rtg-toggle-group-item"), S("design:paramtypes", [])], za);
//#endregion
//#region src/components/ui/toggle-group/toggle-group.ts
var Ba = class extends w {
	constructor(...e) {
		super(...e), this.disabled = !1, this.type = Na.SINGLE, this.required = !1, this.variant = Pa.DEFAULT, this.size = Fa.SMALL, this.selectedItems = [];
	}
	get _containerElement() {
		return this.querySelector("div[part=toggle-group]");
	}
	getAttributesToExclude() {
		return [
			"disabled",
			"type",
			"data-testid"
		];
	}
	connectedCallback() {
		super.connectedCallback();
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		(e.has("variant") || e.has("size") || e.has("disabled") || e.has("type")) && this.querySelectorAll("rtg-toggle-group-item").forEach((e) => {
			e.variant = this.variant, e.size = this.size, e.disabled = this.disabled, e.type = this.type;
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		let e = this.getFilteredAttributes();
		return console.log({
			variant: this.variant,
			size: this.size,
			className: this.className
		}), g`
      <div
        part="toggle-group"
        role="group"
        ${F(e)}
        class="${P(La, this.className)}"
        ?disable="${this.disabled}"
      ></div>
    `;
	}
};
C([o({ type: Boolean }), S("design:type", Object)], Ba.prototype, "disabled", void 0), C([o({ type: String }), S("design:type", Na === void 0 ? Object : Na)], Ba.prototype, "type", void 0), C([o({
	attribute: !0,
	type: Boolean,
	reflect: !0
}), S("design:type", Object)], Ba.prototype, "required", void 0), C([o(), S("design:type", Pa === void 0 ? Object : Pa)], Ba.prototype, "variant", void 0), C([o(), S("design:type", Fa === void 0 ? Object : Fa)], Ba.prototype, "size", void 0), C([o({ type: Array }), S("design:type", Array)], Ba.prototype, "selectedItems", void 0), Ba = C([a("rtg-toggle-group")], Ba);
//#endregion
//#region src/components/ui/toggle/toggle.defs.ts
var Va = /* @__PURE__ */ function(e) {
	return e.SMALL = "sm", e.MEDIUM = "md", e.LARGE = "lg", e;
}({}), Ha = /* @__PURE__ */ function(e) {
	return e.DEFAULT = "default", e.OUTLINE = "outline", e;
}({}), Ua = jt("rtg-inline-flex rtg-items-center rtg-justify-center rtg-rounded-toggle-radius rtg-text-toggle-font rtg-font-toggle-font-weight rtg-transition-colors focus-visible:rtg-outline-none focus-visible:rtg-ring-toggle-width-ring-focus focus-visible:rtg-ring-toggle-color-ring-focus focus-visible:rtg-ring-offset-toggle-width-ring-offset-focus disabled:rtg-pointer-events-none disabled:rtg-opacity-toggle-opacity-disabled data-[state=on]:rtg-bg-toggle-color-bg-on data-[state=on]:rtg-text-toggle-color-text-on rtg-bg-transparent", { variants: {
	variant: {
		default: "hover:rtg-bg-toggle-default-color-bg-hover hover:rtg-text-toggle-default-color-text-hover",
		outline: "rtg-border rtg-border-toggle-outline-color-border hover:rtg-bg-toggle-outline-color-bg-hover hover:rtg-text-toggle-outline-color-text-hover"
	},
	size: {
		sm: "rtg-h-toggle-space-h-sm rtg-px-toggle-space-px-sm",
		md: "rtg-h-toggle-space-h-md rtg-px-toggle-space-px-md",
		lg: "rtg-h-toggle-space-h-lg rtg-px-toggle-space-px-lg"
	}
} }), Wa, Ga = class extends w {
	static {
		Wa = this;
	}
	constructor(...e) {
		super(...e), this.disabled = !1, this.checked = !1, this.required = !1, this.variant = Ha.DEFAULT, this.size = Va.SMALL;
	}
	willUpdate(e) {
		e.has("variant") && (this.variant = this.normalizeEnum(this.variant, Ha, Ha.DEFAULT)), e.has("size") && (this.size = this.normalizeEnum(this.size, Va, Va.SMALL));
	}
	get _containerElement() {
		return this.querySelector("button[part=toggle]");
	}
	static {
		this.toggleVariants = Ua;
	}
	getAttributesToExclude() {
		return [
			"disabled",
			"checked",
			"variant",
			"size",
			"required",
			"data-testid"
		];
	}
	toggle() {
		this.disabled || (this.checked = !this.checked);
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		let e = this.getFilteredAttributes();
		return g`
      <button
        type="button"
        part="toggle"
        class="${P(Wa.toggleVariants({
			variant: this.variant,
			size: this.size,
			className: this.className
		}))}"
        aria-pressed=${this.checked}
        data-state="${this.checked ? "on" : "off"}"
        aria-label="Toggle bold"
        @click=${this.toggle}
        ?required=${this.required}
        ?disabled=${this.disabled}
        ${F(e)}
      ></button>
    `;
	}
};
C([o({ type: Boolean }), S("design:type", Object)], Ga.prototype, "disabled", void 0), C([o({
	attribute: !0,
	type: Boolean,
	reflect: !0
}), S("design:type", Object)], Ga.prototype, "checked", void 0), C([o({
	attribute: !0,
	type: Boolean,
	reflect: !0
}), S("design:type", Object)], Ga.prototype, "required", void 0), C([o({
	attribute: !0,
	type: String
}), S("design:type", Ha === void 0 ? Object : Ha)], Ga.prototype, "variant", void 0), C([o({
	attribute: !0,
	type: String
}), S("design:type", Va === void 0 ? Object : Va)], Ga.prototype, "size", void 0), Ga = Wa = C([a("rtg-toggle")], Ga);
//#endregion
//#region src/components/ui/typography/_typography-blockquote.ts
var Ka = class extends e {
	createRenderRoot() {
		return this;
	}
	get _blockquoteSlot() {
		return this.querySelector("[data-slot=\"typography-blockquote\"]");
	}
	firstUpdated() {
		let e = this._blockquoteSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<blockquote data-slot="typography-blockquote"></blockquote>`;
	}
};
Ka = C([a("rtg-typography-blockquote")], Ka);
//#endregion
//#region src/components/ui/typography/_typography-code.ts
var qa = class extends e {
	createRenderRoot() {
		return this;
	}
	get _codeSlot() {
		return this.querySelector("[data-slot=\"typography-code\"]");
	}
	firstUpdated() {
		let e = this._codeSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<code data-slot="typography-code"></code>`;
	}
};
qa = C([a("rtg-typography-code")], qa);
//#endregion
//#region src/components/ui/typography/_typography-h.ts
var Ja = class extends e {
	constructor(...e) {
		super(...e), this.level = "h1";
	}
	createRenderRoot() {
		return this;
	}
	get _hSlot() {
		return this.querySelector("[data-slot=\"typography-h\"]");
	}
	firstUpdated() {
		let e = this._hSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return this.level === "h2" ? n`
        <h2 data-slot="typography-h" data-level="${this.level}"></h2>
      ` : this.level === "h3" ? n`
        <h3 data-slot="typography-h" data-level="${this.level}"></h3>
      ` : this.level === "h4" ? n`
        <h4 data-slot="typography-h" data-level="${this.level}"></h4>
      ` : n`<h1 data-slot="typography-h" data-level="${this.level}"></h1>`;
	}
};
C([o({ type: String }), S("design:type", Object)], Ja.prototype, "level", void 0), Ja = C([a("rtg-typography-h")], Ja);
//#endregion
//#region src/components/ui/typography/_typography-large.ts
var Ya = class extends e {
	createRenderRoot() {
		return this;
	}
	get _largeSlot() {
		return this.querySelector("[data-slot=\"typography-large\"]");
	}
	firstUpdated() {
		let e = this._largeSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="typography-large"></div>`;
	}
};
Ya = C([a("rtg-typography-large")], Ya);
//#endregion
//#region src/components/ui/typography/_typography-lead.ts
var Xa = class extends e {
	createRenderRoot() {
		return this;
	}
	get _leadSlot() {
		return this.querySelector("[data-slot=\"typography-lead\"]");
	}
	firstUpdated() {
		let e = this._leadSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="typography-lead"></p>`;
	}
};
Xa = C([a("rtg-typography-lead")], Xa);
//#endregion
//#region src/components/ui/typography/_typography-list.ts
var Za = class extends e {
	createRenderRoot() {
		return this;
	}
	get _listSlot() {
		return this.querySelector("[data-slot=\"typography-list\"]");
	}
	firstUpdated() {
		let e = this._listSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<ul data-slot="typography-list"></ul>`;
	}
};
Za = C([a("rtg-typography-list")], Za);
//#endregion
//#region src/components/ui/typography/_typography-muted.ts
var Qa = class extends e {
	createRenderRoot() {
		return this;
	}
	get _mutedSlot() {
		return this.querySelector("[data-slot=\"typography-muted\"]");
	}
	firstUpdated() {
		let e = this._mutedSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="typography-muted"></p>`;
	}
};
Qa = C([a("rtg-typography-muted")], Qa);
//#endregion
//#region src/components/ui/typography/_typography-p.ts
var $a = class extends e {
	createRenderRoot() {
		return this;
	}
	get _pSlot() {
		return this.querySelector("[data-slot=\"typography-p\"]");
	}
	firstUpdated() {
		let e = this._pSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="typography-p"></p>`;
	}
};
$a = C([a("rtg-typography-p")], $a);
//#endregion
//#region src/components/ui/typography/_typography-small.ts
var eo = class extends e {
	createRenderRoot() {
		return this;
	}
	get _smallSlot() {
		return this.querySelector("[data-slot=\"typography-small\"]");
	}
	firstUpdated() {
		let e = this._smallSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<small data-slot="typography-small"></small>`;
	}
};
eo = C([a("rtg-typography-small")], eo);
//#endregion
//#region src/components/ui/typography/_typography-table.ts
var to = class extends e {
	createRenderRoot() {
		return this;
	}
};
to = C([a("rtg-typography-table")], to);
//#endregion
//#region src/components/widgets/light-sample-demo/light-sample.demo.ts
var no = class extends w {
	constructor() {
		super(), this.defaultValue = "account";
	}
	getAttributesToExclude() {
		return [
			"disabled",
			"type",
			"placeholder",
			"value",
			"data-testid"
		];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div class="sb-flex sb-flex-col sb-gap-4">
        <rtg-tabs .defaultValue=${this.defaultValue} class="rtg-w-[400px]">
          <rtg-tabs-list customClass="rtg-h-10 rtg-rounded-2xl" slot="tab-list">
            <rtg-tabs-trigger
              id="account"
              value="account"
              @click=${() => console.log("clicked account")}
            >
              account
            </rtg-tabs-trigger>
            <rtg-tabs-trigger
              data-testid="Password"
              id="password"
              value="password"
              @click=${() => console.log("clicked Password")}
            >
              Password
            </rtg-tabs-trigger>
          </rtg-tabs-list>
          <div slot="tab-content" class="rtg-pt-2">
            <rtg-tabs-content value="password">
              <rtg-card>
                <rtg-card-header class="rtg-space-y-1.5 rtg-p-6">
                  <rtg-card-title>
                    <h3
                      class="rtg-text-2xl rtg-font-semibold rtg-leading-none rtg-tracking-tight"
                    >
                      Password
                    </h3>
                  </rtg-card-title>
                  <rtg-card-description>
                    <div class="rtg-pt-2 rtg-text-sm rtg-text-muted-foreground">
                      Change your password here. After saving, you'll be logged
                      out.
                    </div>
                  </rtg-card-description>
                </rtg-card-header>
                <rtg-card-content>
                  <div>
                    <rtg-label htmlFor="name">Current password</rtg-label>
                  </div>
                  <div class="rtg-py-2">
                    <rtg-label htmlFor="username">New password</rtg-label>
                  </div>
                </rtg-card-content>

                <div class="py-2">
                  <rtg-button> Save password </rtg-button>
                </div>
              </rtg-card>
            </rtg-tabs-content>
            <rtg-tabs-content value="account">
              <rtg-card>
                <rtg-card-header class="rtg-space-y-1.5 rtg-p-6">
                  <rtg-card-title>
                    <h3
                      class="rtg-text-2xl rtg-font-semibold rtg-leading-none rtg-tracking-tight"
                    >
                      Account
                    </h3>
                  </rtg-card-title>
                  <rtg-card-description>
                    <div class="rtg-pt-2 rtg-text-sm rtg-text-muted-foreground">
                      Make changes to your account here. Click save when you're
                      done.
                    </div>
                  </rtg-card-description>
                </rtg-card-header>
                <rtg-card-content>
                  <div>
                    <rtg-label htmlFor="name">Name</rtg-label>
                  </div>
                  <div class="rtg-py-2">
                    <rtg-label htmlFor="username">Username</rtg-label>
                  </div>
                </rtg-card-content>

                <div class="rtg-py-2">
                  <rtg-button> Save changes </rtg-button>
                </div>
              </rtg-card>
            </rtg-tabs-content>
          </div>
        </rtg-tabs>

        <rtg-avatar customClass="rtg-h-20 rtg-w-20">
          <rtg-avatar-image
            src="https://github.com/shadcn.png"
          ></rtg-avatar-image>
        </rtg-avatar>

        <rtg-card class="rtg-rounded-2xl">
          <rtg-card-header data-testid="card-header-id">
            <rtg-card-title data-testid="card-title-id">
              <h3>Create project</h3>
            </rtg-card-title>
            <rtg-card-description data-testid="card-description-id">
              <p class="rtg-text-sm rtg-text-muted-foreground">
                Deploy your new project in one-click.
              </p>
            </rtg-card-description>
          </rtg-card-header>
          <rtg-card-content data-testid="card-content-id">
            <form class="rtg-pt-4">
              <div class="gap-4 rtg-grid rtg-w-full rtg-items-center">
                <div class="rtg-flex rtg-flex-col rtg-space-y-1.5">
                  <label
                    class="rtg-text-sm rtg-font-medium rtg-leading-none peer-disabled:rtg-cursor-not-allowed peer-disabled:rtg-opacity-70"
                    for="name"
                    >Name</label
                  >
                  <input
                    id="name"
                    class="disabled:opacity-50 rtg-flex rtg-h-10 rtg-w-full rtg-rounded-md rtg-border rtg-border-input rtg-bg-background rtg-px-3 rtg-py-2 rtg-text-sm rtg-ring-offset-background placeholder:rtg-text-muted-foreground focus-visible:rtg-outline-none focus-visible:rtg-ring-2 focus-visible:rtg-ring-ring focus-visible:rtg-ring-offset-2 disabled:rtg-cursor-not-allowed"
                    placeholder="Name of your project"
                  />
                </div>
                <div class="rtg-flex rtg-flex-col rtg-space-y-1.5">
                  <label
                    class="rtg-text-sm rtg-font-medium rtg-leading-none peer-disabled:rtg-cursor-not-allowed peer-disabled:rtg-opacity-70"
                    for="framework"
                    >Framework</label
                  >
                  <input
                    id="framework"
                    class="focus-visible:ring-2 rtg-flex rtg-h-10 rtg-w-full rtg-rounded-md rtg-border rtg-border-input rtg-bg-background rtg-px-3 rtg-py-2 rtg-text-sm rtg-ring-offset-background placeholder:rtg-text-muted-foreground focus-visible:rtg-outline-none focus-visible:rtg-ring-ring focus-visible:rtg-ring-offset-2 disabled:rtg-cursor-not-allowed disabled:rtg-opacity-50"
                    placeholder="What framework you be going to use?"
                  />
                </div>
              </div>
            </form>
          </rtg-card-content>
          <rtg-card-footer data-testid="card-footer-id">
            <div class="rtg-flex rtg-items-center rtg-justify-between rtg-pt-4">
              <button
                class="rtg-inline-flex rtg-h-10 rtg-items-center rtg-justify-center rtg-whitespace-nowrap rtg-rounded-md rtg-border rtg-border-input rtg-bg-background rtg-px-4 rtg-py-2 rtg-text-sm rtg-font-medium rtg-ring-offset-background rtg-transition-colors hover:rtg-bg-accent hover:rtg-text-accent-foreground focus-visible:rtg-outline-none focus-visible:rtg-ring-2 focus-visible:rtg-ring-ring focus-visible:rtg-ring-offset-2 disabled:rtg-pointer-events-none disabled:rtg-opacity-50"
              >
                Cancel
              </button>
              <button
                class="rtg-inline-flex rtg-h-10 rtg-items-center rtg-justify-center rtg-whitespace-nowrap rtg-rounded-md rtg-bg-primary rtg-px-4 rtg-py-2 rtg-text-sm rtg-font-medium rtg-text-primary-foreground rtg-ring-offset-background rtg-transition-colors hover:rtg-bg-primary/90 focus-visible:rtg-outline-none focus-visible:rtg-ring-2 focus-visible:rtg-ring-ring focus-visible:rtg-ring-offset-2 disabled:rtg-pointer-events-none disabled:rtg-opacity-50"
              >
                Deploy
              </button>
            </div>
          </rtg-card-footer>
        </rtg-card>

        <rtg-tabs orientation="vertical" defaultValue="account">
          <rtg-tabs-list customClass="!rtg-rounded-2xl" orientation="vertical">
            <rtg-tabs-trigger value="account">Account</rtg-tabs-trigger>
            <rtg-tabs-trigger value="password">Password</rtg-tabs-trigger>
          </rtg-tabs-list>

          <rtg-tabs-content customClass="rtg-rounded-2xl" value="account">
            <rtg-card>
              <rtg-card-header class="rtg-space-y-1.5 rtg-p-6">
                <rtg-card-title>
                  <h3
                    class="rtg-text-2xl rtg-font-semibold rtg-leading-none rtg-tracking-tight"
                  >
                    Account
                  </h3>
                </rtg-card-title>
                <rtg-card-description>
                  <div class="rtg-pt-2 rtg-text-sm rtg-text-muted-foreground">
                    Make changes to your account here. Click save when you're
                    done.
                  </div>
                </rtg-card-description>
              </rtg-card-header>
              <rtg-card-content>
                <div>
                  <rtg-label htmlFor="name">Name</rtg-label>
                </div>
                <div class="rtg-py-2">
                  <rtg-label htmlFor="username">Username</rtg-label>
                </div>
              </rtg-card-content>

              <div class="rtg-py-2">
                <rtg-button> Save changes </rtg-button>
              </div>
            </rtg-card>
          </rtg-tabs-content>

          <rtg-tabs-content customClass="rtg-rounded-2xl" value="password">
            <rtg-card customClass="rtg-rounded-2xl">
              <rtg-card-header class="rtg-space-y-1.5 rtg-p-6">
                <rtg-card-title>
                  <h3
                    class="rtg-text-2xl rtg-font-semibold rtg-leading-none rtg-tracking-tight"
                  >
                    Password
                  </h3>
                </rtg-card-title>
                <rtg-card-description>
                  <div class="rtg-pt-2 rtg-text-sm rtg-text-muted-foreground">
                    Change your password here. After saving, you'll be logged
                    out.
                  </div>
                </rtg-card-description>
              </rtg-card-header>
              <rtg-card-content>
                <div>
                  <rtg-label htmlFor="name">Current password</rtg-label>
                </div>
                <div class="rtg-py-2">
                  <rtg-label htmlFor="username">New password</rtg-label>
                </div>
              </rtg-card-content>

              <div class="py-2">
                <rtg-button> Save password </rtg-button>
              </div>
            </rtg-card>
          </rtg-tabs-content>
        </rtg-tabs>
      </div>
    `;
	}
};
C([o({ type: String }), S("design:type", String)], no.prototype, "defaultValue", void 0), no = C([a("light-sample-demo"), S("design:paramtypes", [])], no);
//#endregion
//#region node_modules/@lit-labs/react/create-component.js
var ro = new Set([
	"children",
	"localName",
	"ref",
	"style",
	"className"
]), io = /* @__PURE__ */ new WeakMap(), ao = (e, t, n, r, i) => {
	let a = i?.[t];
	a === void 0 || n === r ? n == null && t in HTMLElement.prototype ? e.removeAttribute(t) : e[t] = n : ((e, t, n) => {
		let r = io.get(e);
		r === void 0 && io.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(t);
		n === void 0 ? i !== void 0 && (r.delete(t), e.removeEventListener(t, i)) : i === void 0 ? (r.set(t, i = { handleEvent: n }), e.addEventListener(t, i)) : i.handleEvent = n;
	})(e, a, n);
}, oo = (e, t) => {
	typeof e == "function" ? e(t) : e.current = t;
};
function so(e = window.React, t, n, r, i) {
	let a, o, s;
	if (t === void 0) {
		let t = e;
		({tagName: o, elementClass: s, events: r, displayName: i} = t), a = t.react;
	} else a = e, s = n, o = t;
	let c = a.Component, l = a.createElement, u = new Set(Object.keys(r ?? {}));
	class d extends c {
		constructor() {
			super(...arguments), this.o = null;
		}
		t(e) {
			if (this.o !== null) for (let t in this.i) ao(this.o, t, this.props[t], e ? e[t] : void 0, r);
		}
		componentDidMount() {
			var e;
			this.t(), (e = this.o) == null || e.removeAttribute("defer-hydration");
		}
		componentDidUpdate(e) {
			this.t(e);
		}
		render() {
			let { _$Gl: e, ...t } = this.props;
			this.h !== e && (this.u = (t) => {
				e !== null && oo(e, t), this.o = t, this.h = e;
			}), this.i = {};
			let n = { ref: this.u };
			for (let [e, r] of Object.entries(t)) ro.has(e) ? n[e === "className" ? "class" : e] = r : u.has(e) || e in s.prototype ? this.i[e] = r : n[e] = r;
			return n.suppressHydrationWarning = !0, l(o, n);
		}
	}
	d.displayName = i ?? s.name;
	let f = a.forwardRef(((e, t) => l(d, {
		...e,
		_$Gl: t
	}, e?.children)));
	return f.displayName = d.displayName, f;
}
//#endregion
//#region node_modules/react/cjs/react.production.js
var co = /* @__PURE__ */ y(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.activity"), p = Symbol.iterator;
	function ee(e) {
		return typeof e != "object" || !e ? null : (e = p && e[p] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var m = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, h = Object.assign, g = {};
	function _(e, t, n) {
		this.props = e, this.context = t, this.refs = g, this.updater = n || m;
	}
	_.prototype.isReactComponent = {}, _.prototype.setState = function(e, t) {
		if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, e, t, "setState");
	}, _.prototype.forceUpdate = function(e) {
		this.updater.enqueueForceUpdate(this, e, "forceUpdate");
	};
	function te() {}
	te.prototype = _.prototype;
	function ne(e, t, n) {
		this.props = e, this.context = t, this.refs = g, this.updater = n || m;
	}
	var v = ne.prototype = new te();
	v.constructor = ne, h(v, _.prototype), v.isPureReactComponent = !0;
	var re = Array.isArray;
	function ie() {}
	var y = {
		H: null,
		A: null,
		T: null,
		S: null
	}, b = Object.prototype.hasOwnProperty;
	function x(e, n, r) {
		var i = r.ref;
		return {
			$$typeof: t,
			type: e,
			key: n,
			ref: i === void 0 ? null : i,
			props: r
		};
	}
	function S(e, t) {
		return x(e.type, t, e.props);
	}
	function C(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}
	function w(e) {
		var t = {
			"=": "=0",
			":": "=2"
		};
		return "$" + e.replace(/[=:]/g, function(e) {
			return t[e];
		});
	}
	var T = /\/+/g;
	function E(e, t) {
		return typeof e == "object" && e && e.key != null ? w("" + e.key) : t.toString(36);
	}
	function D(e) {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: switch (typeof e.status == "string" ? e.then(ie, ie) : (e.status = "pending", e.then(function(t) {
				e.status === "pending" && (e.status = "fulfilled", e.value = t);
			}, function(t) {
				e.status === "pending" && (e.status = "rejected", e.reason = t);
			})), e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
			}
		}
		throw e;
	}
	function O(e, r, i, a, o) {
		var s = typeof e;
		(s === "undefined" || s === "boolean") && (e = null);
		var c = !1;
		if (e === null) c = !0;
		else switch (s) {
			case "bigint":
			case "string":
			case "number":
				c = !0;
				break;
			case "object": switch (e.$$typeof) {
				case t:
				case n:
					c = !0;
					break;
				case d: return c = e._init, O(c(e._payload), r, i, a, o);
			}
		}
		if (c) return o = o(e), c = a === "" ? "." + E(e, 0) : a, re(o) ? (i = "", c != null && (i = c.replace(T, "$&/") + "/"), O(o, r, i, "", function(e) {
			return e;
		})) : o != null && (C(o) && (o = S(o, i + (o.key == null || e && e.key === o.key ? "" : ("" + o.key).replace(T, "$&/") + "/") + c)), r.push(o)), 1;
		c = 0;
		var l = a === "" ? "." : a + ":";
		if (re(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + E(a, u), c += O(a, r, i, s, o);
		else if (u = ee(e), typeof u == "function") for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + E(a, u++), c += O(a, r, i, s, o);
		else if (s === "object") {
			if (typeof e.then == "function") return O(D(e), r, i, a, o);
			throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
		}
		return c;
	}
	function k(e, t, n) {
		if (e == null) return e;
		var r = [], i = 0;
		return O(e, r, "", "", function(e) {
			return t.call(n, e, i++);
		}), r;
	}
	function ae(e) {
		if (e._status === -1) {
			var t = e._result;
			t = t(), t.then(function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
			}, function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
			}), e._status === -1 && (e._status = 0, e._result = t);
		}
		if (e._status === 1) return e._result.default;
		throw e._result;
	}
	var oe = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, A = {
		map: k,
		forEach: function(e, t, n) {
			k(e, function() {
				t.apply(this, arguments);
			}, n);
		},
		count: function(e) {
			var t = 0;
			return k(e, function() {
				t++;
			}), t;
		},
		toArray: function(e) {
			return k(e, function(e) {
				return e;
			}) || [];
		},
		only: function(e) {
			if (!C(e)) throw Error("React.Children.only expected to receive a single React element child.");
			return e;
		}
	};
	e.Activity = f, e.Children = A, e.Component = _, e.Fragment = r, e.Profiler = a, e.PureComponent = ne, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = y, e.__COMPILER_RUNTIME = {
		__proto__: null,
		c: function(e) {
			return y.H.useMemoCache(e);
		}
	}, e.cache = function(e) {
		return function() {
			return e.apply(null, arguments);
		};
	}, e.cacheSignal = function() {
		return null;
	}, e.cloneElement = function(e, t, n) {
		if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
		var r = h({}, e.props), i = e.key;
		if (t != null) for (a in t.key !== void 0 && (i = "" + t.key), t) !b.call(t, a) || a === "key" || a === "__self" || a === "__source" || a === "ref" && t.ref === void 0 || (r[a] = t[a]);
		var a = arguments.length - 2;
		if (a === 1) r.children = n;
		else if (1 < a) {
			for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
			r.children = o;
		}
		return x(e.type, i, r);
	}, e.createContext = function(e) {
		return e = {
			$$typeof: s,
			_currentValue: e,
			_currentValue2: e,
			_threadCount: 0,
			Provider: null,
			Consumer: null
		}, e.Provider = e, e.Consumer = {
			$$typeof: o,
			_context: e
		}, e;
	}, e.createElement = function(e, t, n) {
		var r, i = {}, a = null;
		if (t != null) for (r in t.key !== void 0 && (a = "" + t.key), t) b.call(t, r) && r !== "key" && r !== "__self" && r !== "__source" && (i[r] = t[r]);
		var o = arguments.length - 2;
		if (o === 1) i.children = n;
		else if (1 < o) {
			for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
			i.children = s;
		}
		if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
		return x(e, a, i);
	}, e.createRef = function() {
		return { current: null };
	}, e.forwardRef = function(e) {
		return {
			$$typeof: c,
			render: e
		};
	}, e.isValidElement = C, e.lazy = function(e) {
		return {
			$$typeof: d,
			_payload: {
				_status: -1,
				_result: e
			},
			_init: ae
		};
	}, e.memo = function(e, t) {
		return {
			$$typeof: u,
			type: e,
			compare: t === void 0 ? null : t
		};
	}, e.startTransition = function(e) {
		var t = y.T, n = {};
		y.T = n;
		try {
			var r = e(), i = y.S;
			i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && r.then(ie, oe);
		} catch (e) {
			oe(e);
		} finally {
			t !== null && n.types !== null && (t.types = n.types), y.T = t;
		}
	}, e.unstable_useCacheRefresh = function() {
		return y.H.useCacheRefresh();
	}, e.use = function(e) {
		return y.H.use(e);
	}, e.useActionState = function(e, t, n) {
		return y.H.useActionState(e, t, n);
	}, e.useCallback = function(e, t) {
		return y.H.useCallback(e, t);
	}, e.useContext = function(e) {
		return y.H.useContext(e);
	}, e.useDebugValue = function() {}, e.useDeferredValue = function(e, t) {
		return y.H.useDeferredValue(e, t);
	}, e.useEffect = function(e, t) {
		return y.H.useEffect(e, t);
	}, e.useEffectEvent = function(e) {
		return y.H.useEffectEvent(e);
	}, e.useId = function() {
		return y.H.useId();
	}, e.useImperativeHandle = function(e, t, n) {
		return y.H.useImperativeHandle(e, t, n);
	}, e.useInsertionEffect = function(e, t) {
		return y.H.useInsertionEffect(e, t);
	}, e.useLayoutEffect = function(e, t) {
		return y.H.useLayoutEffect(e, t);
	}, e.useMemo = function(e, t) {
		return y.H.useMemo(e, t);
	}, e.useOptimistic = function(e, t) {
		return y.H.useOptimistic(e, t);
	}, e.useReducer = function(e, t, n) {
		return y.H.useReducer(e, t, n);
	}, e.useRef = function(e) {
		return y.H.useRef(e);
	}, e.useState = function(e) {
		return y.H.useState(e);
	}, e.useSyncExternalStore = function(e, t, n) {
		return y.H.useSyncExternalStore(e, t, n);
	}, e.useTransition = function() {
		return y.H.useTransition();
	}, e.version = "19.2.6";
})), lo = /* @__PURE__ */ y(((e, t) => {
	process.env.NODE_ENV !== "production" && (function() {
		function n(e, t) {
			Object.defineProperty(a.prototype, e, { get: function() {
				console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
			} });
		}
		function r(e) {
			return typeof e != "object" || !e ? null : (e = _e && e[_e] || e["@@iterator"], typeof e == "function" ? e : null);
		}
		function i(e, t) {
			e = (e = e.constructor) && (e.displayName || e.name) || "ReactClass";
			var n = e + "." + t;
			ve[n] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, e), ve[n] = !0);
		}
		function a(e, t, n) {
			this.props = e, this.context = t, this.refs = xe, this.updater = n || ye;
		}
		function o() {}
		function s(e, t, n) {
			this.props = e, this.context = t, this.refs = xe, this.updater = n || ye;
		}
		function c() {}
		function l(e) {
			return "" + e;
		}
		function u(e) {
			try {
				l(e);
				var t = !1;
			} catch {
				t = !0;
			}
			if (t) {
				t = console;
				var n = t.error, r = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
				return n.call(t, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", r), l(e);
			}
		}
		function d(e) {
			if (e == null) return null;
			if (typeof e == "function") return e.$$typeof === Ce ? null : e.displayName || e.name || null;
			if (typeof e == "string") return e;
			switch (e) {
				case A: return "Fragment";
				case ce: return "Profiler";
				case se: return "StrictMode";
				case fe: return "Suspense";
				case pe: return "SuspenseList";
				case ge: return "Activity";
			}
			if (typeof e == "object") switch (typeof e.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), e.$$typeof) {
				case oe: return "Portal";
				case ue: return e.displayName || "Context";
				case le: return (e._context.displayName || "Context") + ".Consumer";
				case de:
					var t = e.render;
					return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
				case me: return t = e.displayName || null, t === null ? d(e.type) || "Memo" : t;
				case he:
					t = e._payload, e = e._init;
					try {
						return d(e(t));
					} catch {}
			}
			return null;
		}
		function f(e) {
			if (e === A) return "<>";
			if (typeof e == "object" && e && e.$$typeof === he) return "<...>";
			try {
				var t = d(e);
				return t ? "<" + t + ">" : "<...>";
			} catch {
				return "<...>";
			}
		}
		function p() {
			var e = M.A;
			return e === null ? null : e.getOwner();
		}
		function ee() {
			return Error("react-stack-top-frame");
		}
		function m(e) {
			if (we.call(e, "key")) {
				var t = Object.getOwnPropertyDescriptor(e, "key").get;
				if (t && t.isReactWarning) return !1;
			}
			return e.key !== void 0;
		}
		function h(e, t) {
			function n() {
				Ee || (Ee = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", t));
			}
			n.isReactWarning = !0, Object.defineProperty(e, "key", {
				get: n,
				configurable: !0
			});
		}
		function g() {
			var e = d(this.type);
			return Oe[e] || (Oe[e] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.")), e = this.props.ref, e === void 0 ? null : e;
		}
		function _(e, t, n, r, i, a) {
			var o = n.ref;
			return e = {
				$$typeof: ae,
				type: e,
				key: t,
				props: n,
				_owner: r
			}, (o === void 0 ? null : o) === null ? Object.defineProperty(e, "ref", {
				enumerable: !1,
				value: null
			}) : Object.defineProperty(e, "ref", {
				enumerable: !1,
				get: g
			}), e._store = {}, Object.defineProperty(e._store, "validated", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: 0
			}), Object.defineProperty(e, "_debugInfo", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: null
			}), Object.defineProperty(e, "_debugStack", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: i
			}), Object.defineProperty(e, "_debugTask", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: a
			}), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
		}
		function te(e, t) {
			return t = _(e.type, t, e.props, e._owner, e._debugStack, e._debugTask), e._store && (t._store.validated = e._store.validated), t;
		}
		function ne(e) {
			v(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e && e.$$typeof === he && (e._payload.status === "fulfilled" ? v(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
		}
		function v(e) {
			return typeof e == "object" && !!e && e.$$typeof === ae;
		}
		function re(e) {
			var t = {
				"=": "=0",
				":": "=2"
			};
			return "$" + e.replace(/[=:]/g, function(e) {
				return t[e];
			});
		}
		function ie(e, t) {
			return typeof e == "object" && e && e.key != null ? (u(e.key), re("" + e.key)) : t.toString(36);
		}
		function y(e) {
			switch (e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
				default: switch (typeof e.status == "string" ? e.then(c, c) : (e.status = "pending", e.then(function(t) {
					e.status === "pending" && (e.status = "fulfilled", e.value = t);
				}, function(t) {
					e.status === "pending" && (e.status = "rejected", e.reason = t);
				})), e.status) {
					case "fulfilled": return e.value;
					case "rejected": throw e.reason;
				}
			}
			throw e;
		}
		function b(e, t, n, i, a) {
			var o = typeof e;
			(o === "undefined" || o === "boolean") && (e = null);
			var s = !1;
			if (e === null) s = !0;
			else switch (o) {
				case "bigint":
				case "string":
				case "number":
					s = !0;
					break;
				case "object": switch (e.$$typeof) {
					case ae:
					case oe:
						s = !0;
						break;
					case he: return s = e._init, b(s(e._payload), t, n, i, a);
				}
			}
			if (s) {
				s = e, a = a(s);
				var c = i === "" ? "." + ie(s, 0) : i;
				return Se(a) ? (n = "", c != null && (n = c.replace(Me, "$&/") + "/"), b(a, t, n, "", function(e) {
					return e;
				})) : a != null && (v(a) && (a.key != null && (s && s.key === a.key || u(a.key)), n = te(a, n + (a.key == null || s && s.key === a.key ? "" : ("" + a.key).replace(Me, "$&/") + "/") + c), i !== "" && s != null && v(s) && s.key == null && s._store && !s._store.validated && (n._store.validated = 2), a = n), t.push(a)), 1;
			}
			if (s = 0, c = i === "" ? "." : i + ":", Se(e)) for (var l = 0; l < e.length; l++) i = e[l], o = c + ie(i, l), s += b(i, t, n, o, a);
			else if (l = r(e), typeof l == "function") for (l === e.entries && (je || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), je = !0), e = l.call(e), l = 0; !(i = e.next()).done;) i = i.value, o = c + ie(i, l++), s += b(i, t, n, o, a);
			else if (o === "object") {
				if (typeof e.then == "function") return b(y(e), t, n, i, a);
				throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
			}
			return s;
		}
		function x(e, t, n) {
			if (e == null) return e;
			var r = [], i = 0;
			return b(e, r, "", "", function(e) {
				return t.call(n, e, i++);
			}), r;
		}
		function S(e) {
			if (e._status === -1) {
				var t = e._ioInfo;
				t != null && (t.start = t.end = performance.now()), t = e._result;
				var n = t();
				if (n.then(function(t) {
					if (e._status === 0 || e._status === -1) {
						e._status = 1, e._result = t;
						var r = e._ioInfo;
						r != null && (r.end = performance.now()), n.status === void 0 && (n.status = "fulfilled", n.value = t);
					}
				}, function(t) {
					if (e._status === 0 || e._status === -1) {
						e._status = 2, e._result = t;
						var r = e._ioInfo;
						r != null && (r.end = performance.now()), n.status === void 0 && (n.status = "rejected", n.reason = t);
					}
				}), t = e._ioInfo, t != null) {
					t.value = n;
					var r = n.displayName;
					typeof r == "string" && (t.name = r);
				}
				e._status === -1 && (e._status = 0, e._result = n);
			}
			if (e._status === 1) return t = e._result, t === void 0 && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", t), "default" in t || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", t), t.default;
			throw e._result;
		}
		function C() {
			var e = M.H;
			return e === null && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."), e;
		}
		function w() {
			M.asyncTransitions--;
		}
		function T(e) {
			if (Fe === null) try {
				var n = ("require" + Math.random()).slice(0, 7);
				Fe = (t && t[n]).call(t, "timers").setImmediate;
			} catch {
				Fe = function(e) {
					!1 === Pe && (Pe = !0, typeof MessageChannel > "u" && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
					var t = new MessageChannel();
					t.port1.onmessage = e, t.port2.postMessage(void 0);
				};
			}
			return Fe(e);
		}
		function E(e) {
			return 1 < e.length && typeof AggregateError == "function" ? AggregateError(e) : e[0];
		}
		function D(e, t) {
			t !== Ie - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Ie = t;
		}
		function O(e, t, n) {
			var r = M.actQueue;
			if (r !== null) if (r.length !== 0) try {
				k(r), T(function() {
					return O(e, t, n);
				});
				return;
			} catch (e) {
				M.thrownErrors.push(e);
			}
			else M.actQueue = null;
			0 < M.thrownErrors.length ? (r = E(M.thrownErrors), M.thrownErrors.length = 0, n(r)) : t(e);
		}
		function k(e) {
			if (!N) {
				N = !0;
				var t = 0;
				try {
					for (; t < e.length; t++) {
						var n = e[t];
						do {
							M.didUsePromise = !1;
							var r = n(!1);
							if (r !== null) {
								if (M.didUsePromise) {
									e[t] = n, e.splice(0, t);
									return;
								}
								n = r;
							} else break;
						} while (1);
					}
					e.length = 0;
				} catch (n) {
					e.splice(0, t + 1), M.thrownErrors.push(n);
				} finally {
					N = !1;
				}
			}
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var ae = Symbol.for("react.transitional.element"), oe = Symbol.for("react.portal"), A = Symbol.for("react.fragment"), se = Symbol.for("react.strict_mode"), ce = Symbol.for("react.profiler"), le = Symbol.for("react.consumer"), ue = Symbol.for("react.context"), de = Symbol.for("react.forward_ref"), fe = Symbol.for("react.suspense"), pe = Symbol.for("react.suspense_list"), me = Symbol.for("react.memo"), he = Symbol.for("react.lazy"), ge = Symbol.for("react.activity"), _e = Symbol.iterator, ve = {}, ye = {
			isMounted: function() {
				return !1;
			},
			enqueueForceUpdate: function(e) {
				i(e, "forceUpdate");
			},
			enqueueReplaceState: function(e) {
				i(e, "replaceState");
			},
			enqueueSetState: function(e) {
				i(e, "setState");
			}
		}, be = Object.assign, xe = {};
		Object.freeze(xe), a.prototype.isReactComponent = {}, a.prototype.setState = function(e, t) {
			if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
			this.updater.enqueueSetState(this, e, t, "setState");
		}, a.prototype.forceUpdate = function(e) {
			this.updater.enqueueForceUpdate(this, e, "forceUpdate");
		};
		var j = {
			isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
			replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
		};
		for (ze in j) j.hasOwnProperty(ze) && n(ze, j[ze]);
		o.prototype = a.prototype, j = s.prototype = new o(), j.constructor = s, be(j, a.prototype), j.isPureReactComponent = !0;
		var Se = Array.isArray, Ce = Symbol.for("react.client.reference"), M = {
			H: null,
			A: null,
			T: null,
			S: null,
			actQueue: null,
			asyncTransitions: 0,
			isBatchingLegacy: !1,
			didScheduleLegacyUpdate: !1,
			didUsePromise: !1,
			thrownErrors: [],
			getCurrentStack: null,
			recentlyCreatedOwnerStacks: 0
		}, we = Object.prototype.hasOwnProperty, Te = console.createTask ? console.createTask : function() {
			return null;
		};
		j = { react_stack_bottom_frame: function(e) {
			return e();
		} };
		var Ee, De, Oe = {}, ke = j.react_stack_bottom_frame.bind(j, ee)(), Ae = Te(f(ee)), je = !1, Me = /\/+/g, Ne = typeof reportError == "function" ? reportError : function(e) {
			if (typeof window == "object" && typeof window.ErrorEvent == "function") {
				var t = new window.ErrorEvent("error", {
					bubbles: !0,
					cancelable: !0,
					message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
					error: e
				});
				if (!window.dispatchEvent(t)) return;
			} else if (typeof process == "object" && typeof process.emit == "function") {
				process.emit("uncaughtException", e);
				return;
			}
			console.error(e);
		}, Pe = !1, Fe = null, Ie = 0, Le = !1, N = !1, Re = typeof queueMicrotask == "function" ? function(e) {
			queueMicrotask(function() {
				return queueMicrotask(e);
			});
		} : T;
		j = Object.freeze({
			__proto__: null,
			c: function(e) {
				return C().useMemoCache(e);
			}
		});
		var ze = {
			map: x,
			forEach: function(e, t, n) {
				x(e, function() {
					t.apply(this, arguments);
				}, n);
			},
			count: function(e) {
				var t = 0;
				return x(e, function() {
					t++;
				}), t;
			},
			toArray: function(e) {
				return x(e, function(e) {
					return e;
				}) || [];
			},
			only: function(e) {
				if (!v(e)) throw Error("React.Children.only expected to receive a single React element child.");
				return e;
			}
		};
		e.Activity = ge, e.Children = ze, e.Component = a, e.Fragment = A, e.Profiler = ce, e.PureComponent = s, e.StrictMode = se, e.Suspense = fe, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = M, e.__COMPILER_RUNTIME = j, e.act = function(e) {
			var t = M.actQueue, n = Ie;
			Ie++;
			var r = M.actQueue = t === null ? [] : t, i = !1;
			try {
				var a = e();
			} catch (e) {
				M.thrownErrors.push(e);
			}
			if (0 < M.thrownErrors.length) throw D(t, n), e = E(M.thrownErrors), M.thrownErrors.length = 0, e;
			if (typeof a == "object" && a && typeof a.then == "function") {
				var o = a;
				return Re(function() {
					i || Le || (Le = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
				}), { then: function(e, a) {
					i = !0, o.then(function(i) {
						if (D(t, n), n === 0) {
							try {
								k(r), T(function() {
									return O(i, e, a);
								});
							} catch (e) {
								M.thrownErrors.push(e);
							}
							if (0 < M.thrownErrors.length) {
								var o = E(M.thrownErrors);
								M.thrownErrors.length = 0, a(o);
							}
						} else e(i);
					}, function(e) {
						D(t, n), 0 < M.thrownErrors.length ? (e = E(M.thrownErrors), M.thrownErrors.length = 0, a(e)) : a(e);
					});
				} };
			}
			var s = a;
			if (D(t, n), n === 0 && (k(r), r.length !== 0 && Re(function() {
				i || Le || (Le = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
			}), M.actQueue = null), 0 < M.thrownErrors.length) throw e = E(M.thrownErrors), M.thrownErrors.length = 0, e;
			return { then: function(e, t) {
				i = !0, n === 0 ? (M.actQueue = r, T(function() {
					return O(s, e, t);
				})) : e(s);
			} };
		}, e.cache = function(e) {
			return function() {
				return e.apply(null, arguments);
			};
		}, e.cacheSignal = function() {
			return null;
		}, e.captureOwnerStack = function() {
			var e = M.getCurrentStack;
			return e === null ? null : e();
		}, e.cloneElement = function(e, t, n) {
			if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
			var r = be({}, e.props), i = e.key, a = e._owner;
			if (t != null) {
				var o;
				a: {
					if (we.call(t, "ref") && (o = Object.getOwnPropertyDescriptor(t, "ref").get) && o.isReactWarning) {
						o = !1;
						break a;
					}
					o = t.ref !== void 0;
				}
				for (s in o && (a = p()), m(t) && (u(t.key), i = "" + t.key), t) !we.call(t, s) || s === "key" || s === "__self" || s === "__source" || s === "ref" && t.ref === void 0 || (r[s] = t[s]);
			}
			var s = arguments.length - 2;
			if (s === 1) r.children = n;
			else if (1 < s) {
				o = Array(s);
				for (var c = 0; c < s; c++) o[c] = arguments[c + 2];
				r.children = o;
			}
			for (r = _(e.type, i, r, a, e._debugStack, e._debugTask), i = 2; i < arguments.length; i++) ne(arguments[i]);
			return r;
		}, e.createContext = function(e) {
			return e = {
				$$typeof: ue,
				_currentValue: e,
				_currentValue2: e,
				_threadCount: 0,
				Provider: null,
				Consumer: null
			}, e.Provider = e, e.Consumer = {
				$$typeof: le,
				_context: e
			}, e._currentRenderer = null, e._currentRenderer2 = null, e;
		}, e.createElement = function(e, t, n) {
			for (var r = 2; r < arguments.length; r++) ne(arguments[r]);
			r = {};
			var i = null;
			if (t != null) for (c in De || !("__self" in t) || "key" in t || (De = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), m(t) && (u(t.key), i = "" + t.key), t) we.call(t, c) && c !== "key" && c !== "__self" && c !== "__source" && (r[c] = t[c]);
			var a = arguments.length - 2;
			if (a === 1) r.children = n;
			else if (1 < a) {
				for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
				Object.freeze && Object.freeze(o), r.children = o;
			}
			if (e && e.defaultProps) for (c in a = e.defaultProps, a) r[c] === void 0 && (r[c] = a[c]);
			i && h(r, typeof e == "function" ? e.displayName || e.name || "Unknown" : e);
			var c = 1e4 > M.recentlyCreatedOwnerStacks++;
			return _(e, i, r, p(), c ? Error("react-stack-top-frame") : ke, c ? Te(f(e)) : Ae);
		}, e.createRef = function() {
			var e = { current: null };
			return Object.seal(e), e;
		}, e.forwardRef = function(e) {
			e != null && e.$$typeof === me ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof e == "function" ? e.length !== 0 && e.length !== 2 && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", e.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.") : console.error("forwardRef requires a render function but was given %s.", e === null ? "null" : typeof e), e != null && e.defaultProps != null && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
			var t = {
				$$typeof: de,
				render: e
			}, n;
			return Object.defineProperty(t, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return n;
				},
				set: function(t) {
					n = t, e.name || e.displayName || (Object.defineProperty(e, "name", { value: t }), e.displayName = t);
				}
			}), t;
		}, e.isValidElement = v, e.lazy = function(e) {
			e = {
				_status: -1,
				_result: e
			};
			var t = {
				$$typeof: he,
				_payload: e,
				_init: S
			}, n = {
				name: "lazy",
				start: -1,
				end: -1,
				value: null,
				owner: null,
				debugStack: Error("react-stack-top-frame"),
				debugTask: console.createTask ? console.createTask("lazy()") : null
			};
			return e._ioInfo = n, t._debugInfo = [{ awaited: n }], t;
		}, e.memo = function(e, t) {
			e ?? console.error("memo: The first argument must be a component. Instead received: %s", e === null ? "null" : typeof e), t = {
				$$typeof: me,
				type: e,
				compare: t === void 0 ? null : t
			};
			var n;
			return Object.defineProperty(t, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return n;
				},
				set: function(t) {
					n = t, e.name || e.displayName || (Object.defineProperty(e, "name", { value: t }), e.displayName = t);
				}
			}), t;
		}, e.startTransition = function(e) {
			var t = M.T, n = {};
			n._updatedFibers = /* @__PURE__ */ new Set(), M.T = n;
			try {
				var r = e(), i = M.S;
				i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && (M.asyncTransitions++, r.then(w, w), r.then(c, Ne));
			} catch (e) {
				Ne(e);
			} finally {
				t === null && n._updatedFibers && (e = n._updatedFibers.size, n._updatedFibers.clear(), 10 < e && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), t !== null && n.types !== null && (t.types !== null && t.types !== n.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), t.types = n.types), M.T = t;
			}
		}, e.unstable_useCacheRefresh = function() {
			return C().useCacheRefresh();
		}, e.use = function(e) {
			return C().use(e);
		}, e.useActionState = function(e, t, n) {
			return C().useActionState(e, t, n);
		}, e.useCallback = function(e, t) {
			return C().useCallback(e, t);
		}, e.useContext = function(e) {
			var t = C();
			return e.$$typeof === le && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"), t.useContext(e);
		}, e.useDebugValue = function(e, t) {
			return C().useDebugValue(e, t);
		}, e.useDeferredValue = function(e, t) {
			return C().useDeferredValue(e, t);
		}, e.useEffect = function(e, t) {
			return e ?? console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?"), C().useEffect(e, t);
		}, e.useEffectEvent = function(e) {
			return C().useEffectEvent(e);
		}, e.useId = function() {
			return C().useId();
		}, e.useImperativeHandle = function(e, t, n) {
			return C().useImperativeHandle(e, t, n);
		}, e.useInsertionEffect = function(e, t) {
			return e ?? console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"), C().useInsertionEffect(e, t);
		}, e.useLayoutEffect = function(e, t) {
			return e ?? console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"), C().useLayoutEffect(e, t);
		}, e.useMemo = function(e, t) {
			return C().useMemo(e, t);
		}, e.useOptimistic = function(e, t) {
			return C().useOptimistic(e, t);
		}, e.useReducer = function(e, t, n) {
			return C().useReducer(e, t, n);
		}, e.useRef = function(e) {
			return C().useRef(e);
		}, e.useState = function(e) {
			return C().useState(e);
		}, e.useSyncExternalStore = function(e, t, n) {
			return C().useSyncExternalStore(e, t, n);
		}, e.useTransition = function() {
			return C().useTransition();
		}, e.version = "19.2.6", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), uo = /* @__PURE__ */ x((/* @__PURE__ */ y(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = co() : t.exports = lo();
})))(), 1), fo = so({
	tagName: "rtg-button",
	elementClass: L,
	react: uo.default
}), po = so({
	tagName: "rtg-checkbox",
	elementClass: B,
	react: uo.default
});
//#endregion
export { it as Accordion, tt as AccordionContent, I as AccordionItem, nt as AccordionTrigger, at as Alert, ct as AlertAction, st as AlertDescription, ot as AlertTitle, ut as AspectRatio, dt as Avatar, mt as AvatarBadge, pt as AvatarFallback, ht as AvatarGroup, gt as AvatarGroupCount, ft as AvatarImage, _t as Badge, Tt as BreadCrumb, yt as BreadCrumbEllipsis, bt as BreadCrumbItem, xt as BreadCrumbLink, St as BreadCrumbList, Ct as BreadCrumbSeparator, wt as BreadCrumbText, L as Button, fo as ButtonReact, Nt as Calendar, Pt as Card, Rt as CardAction, zt as CardContent, Lt as CardDescription, Bt as CardFooter, Ft as CardHeader, It as CardTitle, Jt as Carousel, B as Checkbox, po as CheckboxReact, Zt as Collapsible, Xt as CollapsibleContent, Yt as CollapsibleTrigger, H as ComboBox, an as ComboBoxEmpty, nn as ComboBoxGroup, rn as ComboBoxInput, V as ComboBoxItem, $t as ComboBoxTrigger, en as ComboBoxValue, _n as Command, cn as CommandEmpty, un as CommandGroup, dn as CommandInput, pn as CommandItem, mn as CommandList, gn as CommandSeparator, En as ContextMenu, vn as ContextMenuCheckboxItem, yn as ContextMenuContent, bn as ContextMenuGroup, xn as ContextMenuItem, Sn as ContextMenuRadioItem, Cn as ContextMenuSeparator, wn as ContextMenuShortcut, Tn as ContextTrigger, Mn as DatePicker, Gn as Dialog, Fn as DialogClose, Ln as DialogContent, Rn as DialogFooter, zn as DialogHeader, Bn as DialogOverlay, Hn as DialogTrigger, nr as Drawer, Jn as DrawerClose, Yn as DrawerContent, Xn as DrawerDescription, Zn as DrawerFooter, Qn as DrawerHeader, $n as DrawerOverlay, er as DrawerTitle, tr as DrawerTrigger, fr as DropdownMenu, rr as DropdownMenuCheckboxItem, ar as DropdownMenuContent, or as DropdownMenuGroup, sr as DropdownMenuItem, cr as DropdownMenuRadioItem, lr as DropdownMenuSeparator, ur as DropdownMenuShortcut, dr as DropdownMenuTrigger, pr as Empty, mr as EmptyContent, hr as EmptyDescription, gr as EmptyHeader, _r as EmptyMedia, vr as EmptyTitle, Sr as Field, Cr as FieldContent, Dr as FieldDescription, kr as FieldError, xr as FieldGroup, Tr as FieldLabel, br as FieldLegend, Or as FieldSeparator, yr as FieldSet, Er as FieldTitle, Xr as HoverCard, Yr as HoverCardTrigger, Jr as HoverContent, K as Input, Zr as InputGroup, Qr as InputGroupAddon, $r as InputGroupButton, q as InputGroupInput, ei as InputGroupText, Y as InputGroupTextarea, X as InputOTP, ti as InputOTPGroup, ri as InputOTPSeparator, ni as InputOTPSlot, ii as Item, ai as ItemActions, oi as ItemContent, si as ItemDescription, ci as ItemFooter, li as ItemGroup, ui as ItemHeader, di as ItemMedia, fi as ItemSeparator, pi as ItemTitle, mi as Kbd, hi as KbdGroup, wr as Label, no as LightSampleDemo, Ai as Menubar, _i as MenubarCheckboxItem, yi as MenubarContent, xi as MenubarGroup, Ci as MenubarItem, vi as MenubarMenu, Ti as MenubarRadioItem, Di as MenubarSeparator, Oi as MenubarShortcut, ki as MenubarTrigger, Li as NavigationMenu, Pi as NavigationMenuContent, Ni as NavigationMenuItem, Fi as NavigationMenuLink, Mi as NavigationMenuList, Ii as NavigationMenuTrigger, Gi as Pagination, zi as PaginationContent, Bi as PaginationEllipsis, Hi as PaginationItem, Vi as PaginationLink, Ui as PaginationNext, Wi as PaginationPrevious, Q as PasswordInput, An as Popover, On as PopoverContent, kn as PopoverTrigger, qi as Progress, Zi as RadioGroup, Xi as RadioGroupItem, Kr as RtgForm, Mr as RtgFormController, Br as RtgFormDescription, Hr as RtgFormField, Ur as RtgFormItem, Wr as RtgFormLabel, Gr as RtgFormMessage, $i as RtgScrollArea, da as RtgSkeleton, na as Select, ra as SelectGroup, ia as SelectItem, aa as SelectLabel, oa as SelectList, sa as SelectSeperator, ca as SelectTrigger, la as SelectValue, tn as Separator, fa as Spinner, ma as Switch, Fa as TOGGLE_GROUP_SIZE, Na as TOGGLE_GROUP_TYPE, Pa as TOGGLE_GROUP_VARIANT, Va as TOGGLE_SIZE, Ha as TOGGLE_VARIANT, ha as Table, ya as Tabs, Sa as TabsContent, ba as TabsList, xa as TabsTrigger, J as Textarea, Ma as Toast, Oa as ToastAction, ka as ToastDescription, Aa as ToastTitle, ja as ToastTrigger, Ea as ToastViewPort, Ga as Toggle, Ba as ToggleGroup, Ka as TypographyBlockquote, qa as TypographyCode, Ja as TypographyH, Ya as TypographyLarge, Xa as TypographyLead, Za as TypographyList, Qa as TypographyMuted, $a as TypographyP, eo as TypographySmall, to as TypographyTable };
